//#region import
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  CSSProperties,
  Card,
  Checkbox,
  Collapse,
  Divider,
  Flex,
  Grid,
  Group,
  LoadingOverlay,
  Menu,
  Modal,
  NumberFormatter,
  NumberInput,
  Select,
  Switch,
  Table,
  Tabs,
  Text,
  TextInput,
  Textarea,
  Title,
  Tooltip,
  rem,
} from "@mantine/core";
import {
  useClickOutside,
  useDebouncedCallback,
  useDebouncedState,
  useDisclosure,
  useHotkeys,
} from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { notifications } from "@mantine/notifications";
import {
  IconBan,
  IconCheck,
  IconCoin,
  IconCreditCard,
  IconDiscount,
  IconEdit,
  IconEye,
  IconMaximize,
  IconMaximizeOff,
  IconMenu2,
  IconPlus,
  IconLock,
  IconPencil,
  IconPrinter,
  IconRefresh,
  IconSearch,
  IconSettings,
  IconShieldCheck,
  IconTrash,
  IconTruck,
  IconWindow,
  IconX,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_Row,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as xlsx from "xlsx";
import {
  repositoryMdm,
  repositoryPayment,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { SocketExtension } from "../../../_base/socket/socket";
import { CREATEORDERSUCCESS } from "../../../_base/socket/ToplicList";
import { styleCellTable } from "../../../_setup/navdata/baseStyleCellTable";
import { UserAuthResponse, apiAuth } from "../../../api/apiAuth";
import { createAhamoveOrder } from "../../../api/apiDeliveryPartner";
import { getProvinceSelectNew } from "../../../service/getSelectApi";
import EditableTextWithOptions from "../../../common/selectValue";
import SelectBuildPc from "../../../common/selectValue/SelectBuildPc";
import SelectPaymentMethod from "../../../common/selectValue/SelectPaymentMethod";
import { _localizationSales } from "../../../config/location";
import { cobalt_blue, orange } from "../../../const/variables";
import { DepartmentModel } from "../../../model/DepartmentModel";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  OrderHeader,
  dataOrderDetailTable,
} from "../../../model/SaleOrderModel";
import { ProductModel } from "../../../model/TblDMItem";
import { TblDMPaymentMethod } from "../../../model/TblDMPaymentMethod";
import {
  ItemDetailPriceModel,
  TblItemPromotionModel,
  itemAddOnPromotionModel,
  itemGiftPromotionModel,
} from "../../../model/TblItem";
import "../../../Styles/TableBodyCell.module.css";
import {
  ZNS_TEMPLATE_IDS,
  createZnsPayload,
  sendZnsMessage,
} from "../../../service/znsService";
import { LineType, OrderStatus } from "../orderStatus";
import PrintInvoice from "../PrintInvoice";
import {
  containsDT,
  formatDateString,
  formatOrderDate,
  getDiscountDecisionSupportTable,
  getTotalQuality,
  handleCheckBackgroundColor,
  handleCheckChooseProduct,
  handleCheckIsSuccessValidateItem,
  handleGetNameBranch,
  handleGetNameDepartment,
  handleGetNameEmployeeAll,
  handleGetTechnicialRequireId,
  handleGetTechnicialRequireName,
  handleKeyDown,
  handlePaymentChange,
  handleQuantityChange,
  handlerRenderOptionSelect,
  parseAttribute19,
} from "./Helper/HelperFunction";
import ShipCompanyTable from "./ModalComponent/ChooseShipCompany";
import ChooseShipDepartment from "./ModalComponent/ChooseShipDepartment";
import CTKMModalContent from "./ModalComponent/CTKMModalContent";
import CustomerDetail from "./ModalComponent/CustomerDetail";
import DiscountSelectionModal from "./ModalComponent/DiscountSelectionModal";
import DiscountSuggestionModal from "./ModalComponent/DiscountSuggestionModal";
import CustomerEditDataView from "../../CustomerManagement/CustomerList/EditDataView";
import CustomerInformation from "./ModalComponent/ModalCustomerInformation";
import ModalDeliveryInformation from "./ModalComponent/ModalDeliveryInformation";
import { PaymentMethodMb } from "./ModalComponent/ModalPaymentMb";
import PaymentDetails from "./ModalComponent/PaymentDetails";
import VoucherRefactor from "./ModalComponent/Voucher";
import WarehouseSelector from "./ModalComponent/WarehouseSelector";
import ModalAllocateWarranty from "./ModalComponent/ModalAllocateWarranty";
import {
  isWarrantyItem,
  isLaptopItem,
  getAssignedWarrantyCodes,
  getWarrantyAllocationSummary,
  getExternalSerialsForWarranty,
  assignOneWarrantyToLaptop,
  unassignOneWarrantyFromLaptop,
  handleWarrantyOnDeleteRow,
  handleLaptopQuantityChangeWarrantySync,
  handleWarrantyQuantityChangeSync,
  toStoredWarranty,
  fromStoredWarranty,
  fromStoredWarrantyByOrder,
  getUnderAllocatedWarranties,
} from "./Helper/WarrantyHelper";
import {
  TableSelectProps,
  customerCheck,
  dataCreateSalesOrder,
} from "./Model/modelRetailOrder";
import OptionPrintOrder, {
  PrintOrderModalType,
} from "./ModalComponent/OptionPrintOrder";
import styles from "./RetailOrder.module.css";
import { useReactToPrint } from "react-to-print";
import usePrintWithLoadedCss from "../../../common/PrintWithLoadedCss/usePrintWithLoadedCss";
import PrintOderhandover from "./ModalComponent/PrintOderhandover";
import PrintWarehouseOutWard from "../../Warehouse/WarehouseOutWard/pages/PrintWarehouseOutWard";
import OptionPrintOutWard from "../../Warehouse/WarehouseOutWard/pages/PrintPage/OptionPrintOutWard";
import { SelectListItem } from "../../../model/SelectListItem";
import PrintWarehouseLKLR from "../../Warehouse/WarehouseOutWard/pages/PrintPage/PrintWarehouseLKLR";
import { SerialItemLKLR } from "../../Warehouse/WarehouseOutWard/pages/WarehouseOutWardActionV2";
import { IconAlertCircle } from "@tabler/icons-react";
import axios from "axios";
import DetailPopup from "./ModalComponent/DetailPopup";
import PromotionDescriptionPopover from "./ModalComponent/PromotionDescriptionPopover";

const newGuid = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function")
    return crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const RetailOrder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isFetchDataCalledRef = React.useRef(false);
  const isSetDefaultBuildPc = React.useRef(false);
  const isFetchingDiscountRef = React.useRef(false); // Thêm ref để tránh fetch liên tục

  // logic chọn lại kho
  const [opened2, setOpened2] = useState(false);
  const [selectedWarehouse, setSelectedWarehouse] = useState<any>();
  const [warehouseList, setWarehouseList] = useState<any[]>([]);

  //#region   khai báo state
  const [accountantId, setAccountantId] = useState(0);
  const [accountantName, setAccountantName] = useState("");
  const [isPaymentMbSuccess, setIsPaymentMbSuccess] = useState(false);
  const [userAuth, setUserAuth] = useState<UserAuthResponse | null>(null);
  const [approvalHistory, setApprovalHistory] = useState<any[]>([]);

  const [selectedBank, setSelectedBank] = useState("");
  const [modalType, setModalType] = useState(""); // COD, "Công nợ", "Trả góp"
  const [installmentInfo, setInstallmentInfo] = useState({
    installmentType: "",
    companyName: "",
    contractCode: "",
    cardType: "",
  });

  // State cho thông tin công nợ
  const [debtInfo, setDebtInfo] = useState({
    dueDate: "",
  });

  // State cho email list khi xuất VAT
  const [vatEmailList, setVatEmailList] = useState<string>("");

  // State cho thông tin thuế VAT
  const [taxInfo, setTaxInfo] = useState({
    TaxCode: "",
    TaxCompany: "",
    TaxEmail: "",
    TaxAddress: "",
  });
  const [taxInfoModalOpened, setTaxInfoModalOpened] = useState(false);
  const [emailError, setEmailError] = useState<string>("");

  // Danh sách các ngân hàng (ví dụ)
  const bankOptions = [
    { value: "VCB-930", label: "VCB-930" },
    { value: "TPB-604", label: "TPB-604" },
    { value: "VCB-813", label: "VCB-813" },
    { value: "VCB-762", label: "VCB-762" },
    { value: "113106", label: "PAYOO" },
    { value: "113101", label: "VN PAY" },
    { value: "113105", label: "Alepay" },
    { value: "113107", label: "ONEPAY" },
  ];

  // State cho discount suggestion modal
  const [discountModalOpened, setDiscountModalOpened] = useState(false);
  const [discountSuggestionData, setDiscountSuggestionData] =
    useState<any>(null);
  const [discountLoading, setDiscountLoading] = useState(false);
  const [isFromCompletedList, setIsFromCompletedList] = useState(false);

  // State để lưu mức giảm tối đa cho từng sản phẩm
  const [itemMaxDiscounts, setItemMaxDiscounts] = useState<{
    [itemCode: string]: number;
  }>({});

  // State cho discount selection modal
  const [discountSelectionOpened, setDiscountSelectionOpened] = useState(false);
  const [selectedRowForDiscount, setSelectedRowForDiscount] =
    useState<any>(null);

  // State để lưu discount options cho sản phẩm được chọn
  const [currentDiscountOptions, setCurrentDiscountOptions] = useState<any[]>(
    [],
  );

  // State để lưu giá trị custom discount hiện tại
  const [currentCustomDiscount, setCurrentCustomDiscount] = useState<number>(0);

  const [timeOutCallApi, setTimeOutCallApi] = useState<boolean>(false);

  // State cho modal chia suất gói bảo hành
  const [warrantyModalOpened, setWarrantyModalOpened] = useState(false);
  const [selectedWarrantyRow, setSelectedWarrantyRow] =
    useState<dataOrderDetailTable | null>(null);

  function mapSelectedBank(selectedBank: string): string {
    switch (selectedBank) {
      case "VCB-930":
      case "TPB-604":
      case "VCB-813":
      case "VCB-762":
        return "113201";
      case "PAYOO":
        return "113106";
      case "VN PAY":
        return "113101";
      case "Alepay":
        return "113105";
      case "ONEPAY":
        return "113107";
      default:
        return selectedBank; // Trả lại nguyên nếu không match
    }
  }

  const [transactionCodeReserve, setTransactionCodeReserve] = useState<
    string | null
  >(null); // Mã giao dịch
  const [transactionCodeMb, setTransactionCodeMb] = useState<string | null>(
    null,
  ); // Mã giao dịch MB động
  const [transactionCodeCard, setTransactionCodeCard] = useState<string | null>(
    null,
  ); // Mã giao dịch thẻ
  const [selectedBankReserve, setSelectedBankReserve] = useState<string | null>(
    null,
  ); // Ngân hàng dự phòng
  const [modeSearch, setModeSearch] = useState("SP"); //SP là tìm sản phẩm , DV là tìm dịch vụ
  const [userLogin, setUserLogin] = useState<any>();
  const [listSerial, setListSerial] =
    useState<{ value: string; label: string }[]>();
  const [totalKM, setTotalKM] = useState(0);
  const [totalKMLine, setTotalKMLine] = useState(0);
  const [totalXGDetail, setTotalXGDetail] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [payableAmount, setPayableAmount] = useState(0);
  // phần 5 hàng thanh toán
  const [cashPayment, setCashPayment] = useState(0);
  const [bankTransfer, setBankTransfer] = useState(0);
  const [cardPayment, setCardPayment] = useState(0);
  const [vnpayPayment, setVnpayPayment] = useState(0);
  const [anotherPayment, setAnotherPayment] = useState(0);
  //
  const [totalPaid, setTotalPaid] = useState(0);
  const [deferredPayment, setDeferredPayment] = useState(0);
  const [contractcode, setContractcode] = useState("");

  const [listEmployeeSales, setListEmployeeSales] = useState<any[]>([]);
  const [listBranch, setListBranch] = useState<any[]>([]);
  const [branchId, setBranchId] = useState<number>();
  const [branchName, setBranchName] = useState<string>("");
  const [employeeSalesId, setEmployeeSalesId] = useState("");
  const [employeeSalesRevenueId, setEmployeeSalesRevenueId] = useState("");
  const [listDepartment, setListDepartment] = useState<DepartmentModel[]>([]);
  const [departmentId, setDepartmentId] = useState<Number>();
  const [employeeSalesName, setEmployeeSalesName] = useState("");
  const [employeeSalesRevenueName, setEmployeeSalesRevenueName] = useState("");
  const [department, setDepartment] = useState("");
  const [orderStatus, setOrderStatus] = useState<string>("noCreate");
  const [shipping, setShipping] = useState("Nhận tại cửa hàng");
  const [shipingVendor, setShipingVendor] = useState("");
  const [payLaterMethod, setPayLaterMethod] = useState("Không");
  const [saleChanelList, setSaleChanelList] = useState<any[]>();
  const [saleChanelId, setSaleChanelId] = useState<number>();
  const [saleChanel, setSaleChanel] = useState("Khách đến showroom");
  const [height, setHeight] = useState(0);
  const [isError, setIsError] = useState(false);
  const [listAdd, setListAdd] = useState<dataOrderDetailTable[]>([]);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [dataProducts, setDataProducts] = useState<ProductModel[]>([]);
  const [valueDebounced, setValueDebounced] = useDebouncedState("", 500);
  const [paymentDone, setPaymentDone] = useState<string[]>([]);
  const [idPrint, setIdPrint] = useState<number | null>(null);
  const [isPrinting, setIsPrinting] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [loading, { close: closeLoading, open: openLoading }] =
    useDisclosure(false);
  const [isCollapse, { toggle: toggleCollapse }] = useDisclosure(false);

  //#region  state object
  const [listBuyerName, setListBuyerName] = useState([]);
  const [listAddress, setListAddress] = useState([]);

  const [isHaveShiping, setIsHaveShipping] = useState(false);

  // States for deposit popup
  const [depositModalOpened, setDepositModalOpened] = useState(false);
  const [depositCode, setDepositCode] = useState<string>("");
  const [depositAmount, setDepositAmount] = useState<string>("");

  const [dataDeliveryInformation, setDataDeliveryInformation] = useState<any>();
  const [dataPayment, setDataPayment] = useState<any>();
  const [dataPaymentLatter, setDataPaymentLatter] = useState<any>();
  const [orderHeaderRef, setOrderHeaderRef] = useState<any>();
  const [orderHeader, setOrderHeader] = useState<OrderHeader>({
    id: 0, // ID của đơn hàng - OK
    orderNumber: "", // Số đơn hàng - đã ghép vào field "Mã đơn hàng"
    orderTypeId: 2, // Loại đơn hàng (2 là đơn hàng lẻ)
    orderDate: "2024-01-01T01:00:00.000Z", // Ngày đặt hàng - đã ghép vào field "Thời gian"
    orderStatus: "DON_HANG_TAM", // Trạng thái đơn hàng (pending: đang chờ) -đã ghép vào trạng thái góc trên phải
    note: "", // Ghi chú đơn hàng - đã ghép vào field "Ghi chú"
    orgId: 0, // ID tổ chức
    invOrgId: 0, // ID tổ chức liên quan đến kho hàng
    deptId: 0, // ID phòng ban
    divisionId: 0, // ID bộ phận
    saleChanelId: 0, // ID kênh bán hàng
    sourceOrderNumber: "", // Số đơn hàng nguồn
    sourceDocument: "", // Tài liệu nguồn
    sourceInvoices: "", // Hóa đơn nguồn
    custId: 0, // ID khách hàng
    custGroupId: 0, // ID nhóm khách hàng
    contactPersonId: 0, // ID người liên hệ
    billToLocationId: 0, // ID địa điểm hóa đơn
    shipToLocationId: 0, // ID địa điểm giao hàng
    invoiceSerial: "", // Số serial hóa đơn
    invoiceNumber: "", // Số hóa đơn
    invoiceDate: "2024-07-16T04:10:09.167Z", // Ngày hóa đơn
    taxCode: "", // Mã số thuế
    taxAddr: "", // Địa chỉ thuế
    amountTotal: 0, // Tổng số tiền
    amountDiscount: 0, // Số tiền giảm giá
    amountVoucher: 0, // Số tiền voucher
    amountVat: 0, // Số tiền thuế VAT
    currentcyCode: "", // Mã tiền tệ
    currentcyRate: 0, // Tỷ giá tiền tệ
    amountPaid: 0, // Số tiền đã thanh toán
    amountRemaining: 0, // Số tiền còn lại
    paymentType: "", // Loại thanh toán
    paymentStatus: "", // Trạng thái thanh toán
    paymentMethod: "", // Phương thức thanh toán
    paymentDue: 0, // Hạn thanh toán
    saleId: 0, // ID người bán hàng
    managerId: 0, // ID quản lý
    approveId: 0, // ID người duyệt
    approveNote: "", // Ghi chú người duyệt
    rejectNote: "", // Ghi chú từ chối
    shipngType: "", // Loại vận chuyển
    shipingVendor: "", // Nhà cung cấp vận chuyển
    shippingCode: "", // Mã vận chuyển
    shippingStatus: "", // Trạng thái vận chuyển
    shippingPriority: "", // Ưu tiên vận chuyển
    shippingDate: "2024-07-16T04:10:09.167Z", // Ngày vận chuyển
    shippingNote: "", // Ghi chú vận chuyển
    technicalChecked: 0, // Kiểm tra kỹ thuật
    technicalNote: "", // Ghi chú kỹ thuật
    clientId: 0, // ID khách hàng
    createBy: 0, // ID người tạo
    createDate: "2024-07-16T04:10:09.167Z", // Ngày tạo
    lastUpdateBy: 0, // ID người cập nhật cuối cùng
    lastUpdateDate: "2024-07-16T04:10:09.167Z", // Ngày cập nhật cuối cùng
    salesShift: "", // Ca bán hàng
    printInvoiceCheck: 0, // Kiểm tra in hóa đơn
    technicalRequired: 0,
    contractcode: "",
    discountAdded: 0,
    discountAddedTotal: 0,
    orderNumberLink: "",
    attribute97: "",
  });

  const [customerCheck, setCustomerCheck] = useState<customerCheck>({
    id: 0,
    companyName: null,
    code: null,
    name: null,
    contact: null,
    address: null,
    telephoneNumber: null,
    fax: null,
    email: null,
    taxCode: "",
    type: null,
    active: null,
    description: null,
    sex: null,
    groupId: 0,
    country: null,
    province: null,
    district: null,
    commune: null,
    provinceName: null,
    districtName: null,
    communeName: null,
    birthOfDate: null,
    groupName: null,
    groupCode: null,
    debtLimit: null,
    debtTerm: null,
    attribute1: null,
    attribute2: null,
    attribute3: null,
    attribute4: null,
    attribute5: null,
  });

  const [dataAllocate, setDataAllocate] = useState([]);
  const [isDisablePhanBo, setIsDisablePhanBo] = useState(false);

  // Chỗ này cho In biên bản bàn giao
  const componentRef = React.useRef(null);
  const [valuePrintOrderModal, setValuePrintOrderModal] =
    useState<PrintOrderModalType>({
      soHopDong: null,
      ngayBaoGia: null,
      ngayBanGiao: null,
      diachiBM: null,
      maSoThueBM: null,
      daiDienBM: null,
      chucVuBM: null,
      daiDienBB: null,
      chucVuBB: null,
      inGiaTien: true,
      inSoLuong: true,
      inKemDichVu: true,
    });
  const [printOrderModalOpened, setPrintOrderModalOpened] = useState(false);
  // States cho in phiếu xuất kho
  const [idPrintOutWard, setIdPrintOutWard] = useState<string | number>("");
  const [typePrintOutWard, setTypePrintOutWard] = useState<string | null>("");
  const [dataPrintOutWard, setDataPrintOutWard] = useState<any>(null);
  const [valuePrintOutWardModal, setValuePrintOutWardModal] = useState<{
    option1: string;
    option2: string;
    dichVuDiKem: boolean;
    inLinhKienLR: boolean;
    inQR: boolean;
  }>();
  const [valueQRCodeOutWard, setValueQRCodeOutWard] = useState<string | null>(
    null,
  );
  const [isReadyQrPrintOutWard, setIsReadyQrPrintOutWard] = useState(false);
  const shouldPrintQrOutWardRef = React.useRef(false);
  const [paymentSummaryForPrint, setPaymentSummaryForPrint] =
    useState<any>(null);
  const [locationDataOutWard, setLocationDataOutWard] = useState<{
    provinceName?: any;
    districtName?: any;
    wardName?: any;
    customerAddress?: any;
    customerName?: any;
    telephoneNumber?: any;
  }>({});
  const [dataCommuneMoi, setDataCommuneMoi] = useState<SelectListItem[]>([]);
  const [isReadyToPrint, setIsReadyToPrint] = useState(false);
  const componentRefOutWard = React.useRef(null);
  const [currentDateOutWard, setCurrentDateOutWard] = useState<string>("");
  const [promoDescOpened, setPromoDescOpened] = useState(false);

  // Hook để in phiếu xuất kho
  const handlePrintOutWard = useReactToPrint({
    contentRef: componentRefOutWard,
    pageStyle: `
      @page{
        size: A4;
       margin: 7mm 0 7mm 0;
      }
      body:{
        margin: 0;
        color: #000;
      }`,
  });
  const handlePrint = usePrintWithLoadedCss({
    contentRef: componentRef,
    pageStyle: `
      @page{
        size: A4;
       margin: 7mm 0 7mm 0;
      }
      body:{
        margin: 0;
        color: #000;
      }`,
    // onBeforePrint: () => console.log("Before printing..."),
    // onAfterPrint: () => console.log("After printing..."),
  });
  // Bắt sự kiện chuột phải để in linh kiện sản xuất
  const [ctxOpen, setCtxOpen] = useState(false);
  const [ctxPos, setCtxPos] = useState({ x: 0, y: 0 });
  const [ctxRowData, setCtxRowData] = useState<dataOrderDetailTable | null>(
    null,
  );
  const [dataLinhKienLR, setDataLinhKienLR] = useState<SerialItemLKLR[] | null>(
    null,
  ); //dữ liệu linh kiện lắp ráp

  //In list sản phẩm linh kiện lắp ráp
  const componentRef3 = React.useRef(null);
  const handlePrintLK = useReactToPrint({
    contentRef: componentRef3,
    pageStyle: `
       @page{
         size: A4;
        margin: 7mm 0 7mm 0;
       }
       body:{
         margin: 0;
         color: #000;
       }`,
    // onBeforePrint: () => console.log("Before printing..."),
    onAfterPrint: () => {
      setDataLinhKienLR(null);
    },
  });
  const [dataOutWard, setDataOutWard] = useState<any>(null); // THÔNG TIN  dữ liệu xuất kho để in linh kiện lắp ráp

  const deliveryFee =
    listAdd.length > 0 ? dataDeliveryInformation?.deliveryFee || 0 : 0;

  // Hàm xác định typeAction dựa trên userAuth và isLimit
  const determineTypeAction = (userAuth: any, isLimit: boolean): number => {
    // Trường hợp 1: userAuth = 1 và isLimit = false thì gán = 2 (duyệt)
    if (userAuth?.typeAtuh === 1 && !isLimit) {
      return 2; // duyệt
    }

    // Trường hợp 2: userAuth = 1 và isLimit = true thì gán = 1 (trình)
    if (userAuth?.typeAtuh === 1 && isLimit) {
      return 1; // trình
    }

    // Trường hợp 3: userAuth = 2 thì không cần check isLimit và gán luôn = 1
    if (userAuth?.typeAtuh === 2) {
      return 2; // trình
    }

    // Mặc định trả về 1 (trình) cho các trường hợp khác
    return 1;
  };

  // Hàm kiểm tra user có quyền duyệt giảm giá không
  const canUserApproveDiscount = (): boolean => {
    // Chỉ user cấp 2 (typeAtuh === 2) mới có quyền duyệt trực tiếp
    // và không cần hiển thị thông báo chờ duyệt
    return userAuth?.typeAtuh === 2;
  };

  // Kiểm tra điều kiện có thể giảm giá tự nhập
  const canApplyCustomDiscount = (item?: any): boolean => {
    if (item) {
      // Kiểm tra CTKM của item cụ thể
      return (
        item.attribute33 &&
        item.attribute33.trim() !== "" &&
        item.attribute34 &&
        item.attribute34.trim() !== ""
      );
    }
    // Không có item parameter thì return false
    return false;
  };

  // Check if need to call discount decision support API
  React.useEffect(() => {
    const checkDiscountDecisionSupport = async () => {
      if (
        location?.state?.actionType === "approved" &&
        orderStatus === "DON_HANG_CHO_DUYET_GIAM" &&
        customerCheck?.id &&
        listAdd.length > 0
      ) {
        try {
          const itemCodes = listAdd.map((item) => item.itemCode);
          const result = await getDiscountDecisionSupportTable(
            customerCheck.id.toString(),
            itemCodes,
          );
        } catch (error) {
          console.error(
            "Error calling getDiscountDecisionSupportTable:",
            error,
          );
        }
      }
    };

    checkDiscountDecisionSupport();
  }, [location?.state?.actionType, orderStatus, customerCheck?.id, listAdd]);

  //#region handle FUNC

  const handleSelectShipingVendor = (value: any) => {
    setShipingVendor(value?.DoiTacVanChuyen);
  };
  const handleRenderOptionListAdd = (
    listAdd: any[],
  ): { value: string; label: string }[] => {
    return listAdd
      .filter((item) => item.lineTyle === "HT" && item.attribute13)
      .map((item) => ({
        value: item.attribute13,
        label: item.attribute13,
      }));
  };

  // Hàm xử lý mở modal gợi ý chiết khấu
  const handleOpenDiscountSuggestion = async (
    e: any,
    fromCompletedList?: boolean,
  ) => {
    if (!customerCheck?.id || listAdd.length === 0) {
      NotificationExtension.Warn("Chưa có thông tin khách hàng hoặc sản phẩm!");
      return;
    }

    setDiscountLoading(true);
    setDiscountModalOpened(true);
    setIsFromCompletedList(fromCompletedList || false);

    try {
      const itemCodes = listAdd.map((item) => item.itemCode);
      const result = await getDiscountDecisionSupportTable(
        customerCheck.id.toString(),
        itemCodes,
      );
      setDiscountSuggestionData(result);
    } catch (error) {
      console.error("Error fetching discount suggestions:", error);
      NotificationExtension.Fails("Lỗi khi tải gợi ý chiết khấu!");
    } finally {
      setDiscountLoading(false);
    }
  };

  // Hàm xử lý mở modal chọn mức giảm giá cho từng sản phẩm
  const handleOpenDiscountSelection = async (row: any) => {
    setSelectedRowForDiscount(row);

    // Kiểm tra nếu chưa có discountSuggestionData thì gọi API trước
    let currentDiscountData = discountSuggestionData;

    if (!currentDiscountData && customerCheck?.id && listAdd.length > 0) {
      try {
        const itemCodes = listAdd.map((item) => item.itemCode);
        currentDiscountData = await getDiscountDecisionSupportTable(
          customerCheck.id.toString(),
          itemCodes,
        );
        setDiscountSuggestionData(currentDiscountData);
      } catch (error) {
        console.error("Error fetching discount suggestions:", error);
        NotificationExtension.Fails("Lỗi khi tải gợi ý chiết khấu!");
        return;
      }
    }

    // Tìm discount options cho sản phẩm từ discountSuggestionData
    const itemCode = row?.original?.itemCode;
    let discountOptions = [
      { id: 1, label: "Giảm giá 1", value: 0 },
      { id: 2, label: "Giảm giá 2", value: 0 },
      { id: 3, label: "Giảm giá 3", value: 0 },
    ];

    if (currentDiscountData && currentDiscountData.itemPrices) {
      const itemData = currentDiscountData.itemPrices.find(
        (item: any) => item.itemCode === itemCode,
      );

      if (itemData) {
        discountOptions = [
          { id: 1, label: "Giảm giá 1", value: itemData.discountPrice1 || 0 },
          { id: 2, label: "Giảm giá 2", value: itemData.discountPrice2 || 0 },
          { id: 3, label: "Giảm giá 3", value: itemData.discountPrice3 || 0 },
        ];
      }
    }

    setCurrentDiscountOptions(discountOptions);

    // Lấy giá trị hiện tại của "Xin giảm" để hiển thị trong modal
    setCurrentCustomDiscount(row?.original?.discountAdded || 0);

    // Đặt timeout ngắn để đảm bảo state đã được cập nhật trước khi mở modal
    setTimeout(() => {
      setDiscountSelectionOpened(true);
    }, 50);
  };

  // Hàm reset giảm giá về 0
  const handleResetDiscount = (row: any) => {
    const rowIndex = listAdd.findIndex((item) => item.id === row.original.id);
    if (rowIndex !== -1) {
      setListAdd((prevData) =>
        prevData.map((item, i) =>
          i === rowIndex
            ? {
                ...item,
                discountAdded: 0,
                isDiscountReset: true, // Đánh dấu item này đã được user reset
                priceFinal:
                  item.priceOnPriceList -
                  (item.discountAmount || 0) -
                  (item.discountRate
                    ? (item.discountRate * item.priceOnPriceList) / 100
                    : 0),
              }
            : item,
        ),
      );
      NotificationExtension.Success("Đã reset mức giảm giá về 0!");
    }
  };

  // Hàm xử lý khi chọn mức giảm giá
  const handleSelectDiscount = (discount: number) => {
    if (selectedRowForDiscount) {
      handleChangeRequestReduction(
        discount,
        selectedRowForDiscount.original.id,
        selectedRowForDiscount.original.priceOnPriceList,
      );
      setDiscountSelectionOpened(false);
      setSelectedRowForDiscount(null);
    }
  };

  // Callback function để nhận dữ liệu max discount từ modal
  const handleReceiveMaxDiscounts = useCallback(
    (maxDiscounts: { [itemCode: string]: number }) => {
      setItemMaxDiscounts(maxDiscounts);

      // Tự động map maxDiscounts vào discountAdded cho các sản phẩm trong listAdd
      // Chỉ áp dụng cho những sản phẩm chưa có chiết khấu thủ công và chưa được user reset
      setListAdd((prevListAdd) => {
        let hasChanges = false;
        const newListAdd = prevListAdd.map((item) => {
          const maxDiscount = maxDiscounts[item.itemCode];

          // Chỉ cập nhật nếu:
          // 1. Có maxDiscount và > 0
          // 2. Item chưa có chiết khấu thủ công (discountAdded = 0 hoặc undefined)
          // 3. Item chưa được user reset (isDiscountReset không phải true)
          // 4. maxDiscount khác với discountAdded hiện tại
          if (
            maxDiscount &&
            maxDiscount > 0 &&
            (item.discountAdded === 0 || item.discountAdded === undefined) &&
            !item.isDiscountReset && // Không áp dụng cho item đã được reset
            item.discountAdded !== maxDiscount
          ) {
            hasChanges = true;
            // Tính lại priceFinal với discountAdded mới
            const newPriceFinal =
              item.priceOnPriceList - (item.discountAmount || 0) - maxDiscount;

            return {
              ...item,
              discountAdded: maxDiscount,
              priceFinal: Math.max(newPriceFinal, 0), // Đảm bảo không âm
            };
          }
          return item;
        });

        // Chỉ return array mới nếu có thay đổi, tránh vòng lặp
        return hasChanges ? newListAdd : prevListAdd;
      });
    },
    [],
  ); // Empty dependency array vì logic không phụ thuộc vào external values

  // Hàm helper để lấy max discount cho một sản phẩm
  const getMaxDiscountForItem = (itemCode: string): number => {
    const result = itemMaxDiscounts[itemCode] || 0;
    return result;
  };

  // Helper function để fetch discount data khi cần thiết
  const fetchDiscountDataIfNeeded = async (): Promise<any> => {
    // Nếu đang fetch thì không fetch lại
    if (isFetchingDiscountRef.current) {
      return discountSuggestionData;
    }

    // Nếu đã có data thì return luôn
    if (discountSuggestionData && Object.keys(itemMaxDiscounts).length > 0) {
      return discountSuggestionData;
    }

    // Nếu chưa có thì fetch
    if (!customerCheck?.id || listAdd.length === 0) {
      console.warn(
        "Không thể fetch discount data: thiếu thông tin khách hàng hoặc sản phẩm",
      );
      return null;
    }

    try {
      isFetchingDiscountRef.current = true; // Đánh dấu đang fetch

      const itemCodes = listAdd.map((item) => item.itemCode);
      const result = await getDiscountDecisionSupportTable(
        customerCheck.id.toString(),
        itemCodes,
      );

      // Cập nhật state với data vừa fetch được
      setDiscountSuggestionData(result);

      // Cập nhật itemMaxDiscounts từ data vừa fetch
      if (result?.itemPrices) {
        const maxDiscounts: { [itemCode: string]: number } = {};
        result.itemPrices.forEach((item: any) => {
          maxDiscounts[item.itemCode] = item.maxDiscountPrice;
        });
        setItemMaxDiscounts(maxDiscounts);
      }

      return result;
    } catch (error) {
      console.error("Error fetching discount data:", error);
      return null;
    } finally {
      isFetchingDiscountRef.current = false; // Reset flag
    }
  };

  const isDisableHoanThanh = () => {
    if (!orderHeader?.amountDiscountTotal && !orderHeader?.discountAddedTotal) {
      return false;
    }

    if (listAdd.length === 0) return true;

    const sumAttr28 = listAdd.reduce(
      (sum, item) => sum + (Number(item.attribute28) ?? 0),
      0,
    );
    const sumAttr29 = listAdd.reduce(
      (sum, item) => sum + (Number(item.attribute29) ?? 0),
      0,
    );

    return sumAttr28 === 0 && sumAttr29 === 0;
  };

  const saveLogToLocalStorage = () => {
    // Kiểm tra điều kiện: amountDiscountTotal > 0 hoặc discountAddedTotal > 0
    if (
      !(
        (orderHeader?.amountDiscountTotal ?? 0) > 0 ||
        (orderHeader?.discountAddedTotal ?? 0) > 0
      )
    ) {
      return; // Không thỏa điều kiện => không lưu
    }

    const logData = {
      tblOrderDetails: dataAllocate?.length > 0 ? listAdd : [],
      orderNumber: orderHeader?.orderNumber ?? null,
    };

    // Lấy log cũ từ localStorage
    const existingLogsString = localStorage.getItem("orderLog");
    const existingLogs = existingLogsString
      ? JSON.parse(existingLogsString)
      : [];

    // Thêm log mới
    existingLogs.push(logData);

    // Lưu lại
    localStorage.setItem("orderLog", JSON.stringify(existingLogs));
  };

  const [isApprovingWithNote, setIsApprovingWithNote] = useState(false);
  const [isSentForApproval, setIsSentForApproval] = useState(false);
  const [isLimitApproval, setIsLimitApproval] = useState(true); // State để lưu giá trị isLimit

  const handleOpenApprovalWithNote = (
    currentUserAuth: any,
    isLimit: boolean,
  ) => {
    const typeAction = determineTypeAction(currentUserAuth, isLimit);

    // Luôn yêu cầu ghi chú cho mọi trường hợp
    setIsApprovingWithNote(true);

    // Component con với state cục bộ để tránh closure issue
    const ApprovalNoteModal = () => {
      const [noteValue, setNoteValue] = React.useState("");

      return (
        <div>
          <Text>
            {typeAction === 1
              ? "Bạn có muốn gửi đơn này cho quản lý duyệt không?"
              : "Bạn có muốn duyệt đơn hàng này không?"}
          </Text>
          <Box mt="sm">
            <Text fw={500}>Ghi chú (bắt buộc):</Text>
            <Textarea
              placeholder="Nhập ghi chú lý do xin duyệt..."
              value={noteValue}
              onChange={(event) => setNoteValue(event.currentTarget.value)}
              minRows={3}
              required
              data-autofocus
            />
          </Box>
        </div>
      );
    };

    modals.openConfirmModal({
      title:
        typeAction === 1 ? "Xác nhận gửi đơn hàng" : "Xác nhận duyệt đơn hàng",
      children: <ApprovalNoteModal />,
      confirmProps: { color: "blue" },
      labels: {
        confirm: typeAction === 1 ? "Gửi duyệt" : "Duyệt",
        cancel: "Hủy",
      },
      onConfirm: async () => {
        // Lấy giá trị từ DOM vì không thể access state của component con
        const textareaElement = document.querySelector(
          "[data-autofocus]",
        ) as HTMLTextAreaElement;
        const noteText = textareaElement?.value?.trim() || "";

        if (!noteText) {
          notifications.show({
            title: "Lỗi",
            message: "Vui lòng nhập ghi chú trước khi tiếp tục",
            color: "red",
          });
          return;
        }

        try {
          await executeApprovalAPI(currentUserAuth, isLimit, noteText);
        } catch (error) {
          console.error("Error during approval:", error);
        } finally {
          setIsApprovingWithNote(false);
        }
      },
      onCancel: () => {
        setIsApprovingWithNote(false);
      },
    });
  };

  // Function helper để thực hiện API call duyệt đơn hàng
  const executeApprovalAPI = async (
    currentUserAuth: any,
    isLimit: boolean,
    noteValue?: string,
  ) => {
    // Tính tổng tiền trước khi sửa = tổng tiền sau khi sửa + tổng discountAdded (nhân với số lượng)
    const totalDiscountAdded = listAdd.reduce(
      (sum, item) => sum + (item.discountAdded || 0) * (item.quality || 1),
      0,
    );

    const price_b = payableAmount + totalDiscountAdded;

    // Xác định typeAction dựa trên userAuth và isLimit
    const typeAction = determineTypeAction(currentUserAuth, isLimit);

    const response = await repositoryPos.post<
      MessageResponse<dataCreateSalesOrder>
    >("/api/v1/CreateSellItem/approve-order-v3", {
      orderId: orderHeader.id || 0,
      type_History: 1, // 1 = duyệt giảm giá
      price_b: price_b, // Tổng tiền trước khi sửa
      price_a: payableAmount, // Tổng tiền sau khi sửa
      isLimit: isLimit,
      typeAction: typeAction,
      note: noteValue || "", // Thêm trường note
      approves: listAdd.map((item) => ({
        id: item.id || 0,
        totalAmount: (item.priceFinal || 0) * (item.quality || 1),
        discountAdded: item.discountAdded || 0,
        priceFinal: item.priceFinal || 0,
        price: item.priceOnPriceList || 0, // Giá gốc trước khi giảm
      })),
    });

    if (response && response.success) {
      // Đánh dấu đã gửi duyệt để disable các nút
      setIsSentForApproval(true);

      // Cập nhật isLimitApproval từ payload gửi đi (vì response có thể không trả về isLimit)
      setIsLimitApproval(isLimit);

      // Chỉ đổi status khi typeAction = 2 (duyệt), không đổi khi typeAction = 1 (trình)
      if (typeAction === 2) {
        setOrderStatus("DON_HANG_DA_DUYET_GIAM");
      }

      // Hiển thị thông báo phù hợp dựa trên typeAction
      if (typeAction === 1) {
        NotificationExtension.Success("Gửi trình duyệt thành công!");
      } else if (typeAction === 2) {
        NotificationExtension.Success("Duyệt giảm giá thành công!");
      } else {
        NotificationExtension.Success("Xử lý thành công!");
      }
      SocketExtension.SendMessageToTopic<any>({
        topic: CREATEORDERSUCCESS,
        data: "",
      });
    } else {
      NotificationExtension.Fails(response?.message);
    }
  };

  const handleApprovedSalesOrder = async () => {
    if (!orderHeader.custId) {
      NotificationExtension.Warn("Chưa có thông tin khách hàng !");
      return;
    }

    try {
      // Lấy thông tin userAuth trước khi xử lý
      let currentUserAuth = userAuth;
      if (!currentUserAuth || !currentUserAuth.typeAtuh) {
        try {
          const authData = await apiAuth.getUserAuth();
          currentUserAuth = authData?.data;
          setUserAuth(currentUserAuth);
        } catch (error) {
          console.error("Error fetching user auth:", error);
          NotificationExtension.Fails(
            "Lỗi khi lấy thông tin quyền người dùng!",
          );
          return;
        }
      }

      // Kiểm tra mức giảm giá để xác định isLimit
      let isLimit = false;

      if (discountSuggestionData && discountSuggestionData.itemPrices) {
        // Kiểm tra từng item trong listAdd
        for (const item of listAdd) {
          // Tìm thông tin discount cho item này từ discountSuggestionData
          const itemDiscountInfo = discountSuggestionData.itemPrices.find(
            (discountItem: any) => discountItem.itemCode === item.itemCode,
          );

          if (itemDiscountInfo) {
            const discountPrice3 = itemDiscountInfo.discountPrice3 || 0;
            const currentDiscountAdded = item.discountAdded || 0;

            // Chuyển đổi discountPrice3 thành giá trị dương để so sánh
            const maxAllowedDiscount = Math.abs(discountPrice3);

            // Nếu có ít nhất 1 item có mức giảm > mức 3 (so sánh với giá trị tuyệt đối) thì isLimit = true
            if (currentDiscountAdded > maxAllowedDiscount) {
              isLimit = true;
              break; // Thoát khỏi vòng lặp vì đã tìm thấy
            }
          }
        }
      }

      // Sử dụng handleOpenApprovalWithNote thay vì xử lý trực tiếp
      handleOpenApprovalWithNote(currentUserAuth, isLimit);
    } catch (error) {
      console.error("Error approving sales order:", error);
      NotificationExtension.Fails("Lỗi khi duyệt đơn hàng!");
    }
  };

  const chooseWareHouse = async () => {
    setOpened2(true); // mở modal
    const response = await repositoryPos.post<MessageResponse<any>>(
      "/api/v1/CreateSellItem/get-list-inventory-onhand",
      {
        getListInventoryOnhands: listAdd.map((item) => ({
          itemId: item.itemId,
          itemCode: item.itemCode,
          quantity: item.quality,
        })),
        isFull: true,
        branchId: 0,
      },
    );

    if (response?.data) {
      setWarehouseList(response?.data);
    }
  };

  const handleChangeQuantity = async (e: any, row: any) => {
    await handleQuantityChange(e, row, branchId, location, setListAdd);
    const newQty = Number(e) || 0;
    if (isLaptopItem(row.original)) {
      setListAdd((prevList) =>
        handleLaptopQuantityChangeWarrantySync(
          prevList,
          row.original.id,
          newQty
        )
      );
    }
    if (isWarrantyItem(row.original)) {
      setListAdd((prevList) => {
        const { list, trimmedCount } = handleWarrantyQuantityChangeSync(
          prevList,
          row.original.itemCode,
          newQty
        );
        if (trimmedCount > 0) {
          NotificationExtension.Warn(
            `Đã thu hồi ${trimmedCount} suất phân bổ do số lượng gói bảo hành giảm xuống ${newQty}!`
          );
        }
        return list;
      });
    }
  };

  // Hàm mở modal theo loại
  const handleOpenModal = (type: string) => {
    setModalType(type);
  };

  // Hàm đóng modal
  const handleCloseModal = () => {
    setModalType("");
  };

  // Hàm xử lý lưu thông tin trả góp
  const handleSaveInstallment = () => {
    handleCloseModal();
  };

  // Hàm xử lý lưu thông tin công nợ
  const handleSaveDebt = () => {
    handleCloseModal();
  };

  const debouncedNoteChange = useDebouncedCallback(
    (value) =>
      setOrderHeader((prev) => ({
        ...prev,
        note: value,
      })),
    300,
  );

  const debouncedCashierNoteChange = useDebouncedCallback(
    (value) =>
      setOrderHeader((prev) => ({
        ...prev,
        attribute23: value,
      })),
    300,
  );

  // Functions for deposit popup
  const handleOpenDepositModal = () => {
    // Khởi tạo giá trị từ orderHeader nếu có (load từ database)
    setDepositCode(orderHeader?.receiptNumber || ""); // Load mã báo có từ receiptNumber
    setDepositAmount(orderHeader?.deposit?.toString() || ""); // Load số tiền từ deposit
    setDepositModalOpened(true);
  };

  const handleSaveDeposit = () => {
    // Lưu cả số tiền cọc và mã báo có vào orderHeader
    setOrderHeader((prev) => ({
      ...prev,
      deposit: Number(depositAmount) || 0, // Số tiền cọc (chuyển string sang number)
      receiptNumber: depositCode, // Mã báo có
    }));
    setDepositModalOpened(false);
  };
  // Hàm mở modal chọn kiểu in phiếu xuất kho
  const openPrintOutWardModal = (orderNumber: string) => {
    modals.openConfirmModal({
      title: "Chọn loại phiếu Xuất Kho Bán",
      closeOnConfirm: false,
      size: "400px",
      children: (
        <OptionPrintOutWard
          id={orderHeader?.id || 0}
          type="XUAT_BAN"
          onhandlePrint={(id, type, printOption) =>
            onhandlePrintOutWard(orderNumber, type, printOption)
          }
          setValuePrintOptionModal={setValuePrintOutWardModal}
          isTMDT={<></>}
          isTmdtOrder={!!(orderHeader as any)?.ecommerceOrderId}
          // setDataLinhKienLR={setDataLinhKienLR}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  // Hàm xử lý khi chọn in
  const onhandlePrintOutWard = (
    id: string | number,
    type: string | null,
    printOption?: {
      option1: string;
      option2: string;
      dichVuDiKem: boolean;
      inLinhKienLR: boolean;
      inQR: boolean;
    },
  ) => {
    if (id != null && type != null) {
      shouldPrintQrOutWardRef.current = !!printOption?.inQR;
      if (printOption) {
        setValuePrintOutWardModal(printOption);
      }
      setIdPrintOutWard(id);
      setTypePrintOutWard(type);
    }
  };
  // Hàm fetch dữ liệu để in phiếu xuất kho
  const fetchDataToPrintOutWard = async (
    orderNumber: string,
    type: string | null,
  ) => {
    let apiPath;
    switch (type) {
      case "XUAT_BAN":
        const isDichVu = valuePrintOutWardModal?.dichVuDiKem;

        apiPath = isDichVu
          ? `/api/v1/Outward/print-sale-order-out-ward?order_number=${orderNumber}&isserive=true`
          : `/api/v1/Outward/print-sale-order-out-ward?order_number=${orderNumber}&isserive=false`;

        break;
      default:
        return;
    }
    try {
      const response = await repositoryPos.get<MessageResponse<any>>(apiPath);
      if (response?.success && response?.data) {
        const serialLinhKienLR =
          response?.data?.inventoryTransactionSerialModels || [];
        if (valuePrintOutWardModal?.inLinhKienLR === true) {
          // seriaLinhKienLR có thể là mảng object hoặc mảng string
          const serialList: string[] = (
            Array.isArray(serialLinhKienLR)
              ? serialLinhKienLR.map((s: any) =>
                  typeof s === "string"
                    ? s.trim()
                    : String(s?.serial ?? "").trim(),
                )
              : []
          ).filter((x) => !!x);

          if (serialList.length === 0) {
            NotificationExtension.Warn("Không có serial để lấy linh kiện.");
            return null;
          }

          const result = await repositoryPos.post<MessageResponse<any>>(
            `/api/v1/TblItemTransaction/get-serial-parent-info`,
            { parentSerial: serialList },
          );
          setDataLinhKienLR(result?.data || []);
        }
        // Set current date for printing
        const now = new Date();
        const formattedDate = now.toLocaleDateString("vi-VN");
        setCurrentDateOutWard(formattedDate);

        // Fetch payment summary từ MDM giống invoice print
        try {
          const orderId = orderHeader?.id;
          if (orderId) {
            const mdmResponse = await repositoryMdm.get<MessageResponse<any[]>>(
              `/api/v1/TblOrderHeader/print-order?ids=${orderId}`,
            );
            if (mdmResponse?.success && mdmResponse?.data?.[0]) {
              const orderData = mdmResponse.data[0];
              setPaymentSummaryForPrint({
                cashAmount: orderData?.cashAmount,
                transferAmount: orderData?.custTransferTotal,
                cardAmount: orderData?.cardAmount,
                totalPayBefore: orderData?.payAmount,
                codAmount: orderData?.codAmount,
                payLaterMethod: orderData?.attribute20,
              });
            }
          }
        } catch (e) {
          console.log("error fetch payment summary", e);
        }

        if (
          response?.data?.tblInventoryTransactionModel.dvtn !== null &&
          response?.data?.tblInventoryTransactionModel?.gv !==
            "Nhận tại cửa hàng"
        ) {
          const dataViewLocation = JSON.parse(
            response?.data?.tblInventoryTransactionModel?.attribute3 || "{}",
          );
          if (dataViewLocation) {
            setLocationDataOutWard({
              customerAddress: dataViewLocation?.customerAddress,
              customerName: dataViewLocation?.customerName,
              telephoneNumber: dataViewLocation?.telephoneNumber,
            });
          }
          setDataPrintOutWard(response?.data);
        } else {
          setDataPrintOutWard(response?.data);
        }
      } else {
        setDataPrintOutWard(null);
        NotificationExtension.Fails("Lỗi khi tải dữ liệu in");
      }
    } catch (error) {
      console.log("error fetch data to print", error);
    }
  };

  // useEffect để fetch data khi có idPrintOutWard
  React.useEffect(() => {
    if (idPrintOutWard !== "" && typePrintOutWard) {
      fetchDataToPrintOutWard(idPrintOutWard.toString(), typePrintOutWard);
    }
  }, [idPrintOutWard, typePrintOutWard]);

  // useEffect để fetch dataCommuneMoi khi có dataPrintOutWard
  React.useEffect(() => {
    if (dataPrintOutWard && idPrintOutWard) {
      let idCheck: string | undefined = undefined;
      let paramType: "Ids" | "OldCommuneId" | undefined = undefined;
      const checkDvtn = dataPrintOutWard?.tblInventoryTransactionModel.dvtn;

      // Parse lại attribute3 từ dataPrintOutWard
      let parsedData: any | null = null;
      try {
        parsedData = dataPrintOutWard?.tblInventoryTransactionModel?.attribute3
          ? JSON.parse(dataPrintOutWard.tblInventoryTransactionModel.attribute3)
          : null;
      } catch (error) {
        parsedData = null;
      }
      // NOTE:CHUYỂN ĐỔI LOGIC LẤY HẾT ĐỊA CHỈ MỚI LÊN CHỈ DÙNG TYPE LÀ IDS THÔI
      if (checkDvtn) {
        // nếu là đơn vị tiếp nhận thì mặc định truyền vào OldComnunedId
        idCheck = parsedData?.customerCommuneId;
        paramType = "Ids";
      } else if (
        dataPrintOutWard?.tblInventoryTransactionModel.newCommuneId &&
        !checkDvtn
      ) {
        //nếu là địa chỉ mới thì truyền vào Ids
        idCheck = dataPrintOutWard?.tblInventoryTransactionModel.newCommuneId;
        paramType = "Ids";
      } else if (
        dataPrintOutWard?.tblInventoryTransactionModel?.cusCommuneId &&
        !checkDvtn
      ) {
        //nếu là địa chỉ cũ thì truyền vào OldCommuneId
        idCheck = dataPrintOutWard?.tblInventoryTransactionModel.cusCommuneId;
        paramType = "Ids";
      }

      // Api gọi Xã Phường Mới
      const fetchDataReceiptCommuneMoi = async () => {
        if (!idCheck || !paramType) {
          setDataCommuneMoi([]);
          setIsReadyToPrint(true); // Không cần fetch, vẫn cho phép in
          return;
        } else {
          const response = await repositoryMdm.get<
            MessageResponse<SelectListItem[]>
          >(`/api/v1/TblDmCommuneMoi/get-select?${paramType}=${idCheck}`);
          if (response && response.success) {
            setDataCommuneMoi(response.data);
            setIsReadyToPrint(true); // Đánh dấu đã fetch xong
          }
        }
      };
      setIsReadyToPrint(false); // Reset trước khi fetch
      fetchDataReceiptCommuneMoi();
    }
  }, [dataPrintOutWard, idPrintOutWard]);

  // useEffect tạo mã QR trước khi in (nếu người dùng chọn In QR)
  React.useEffect(() => {
    if (!dataPrintOutWard) {
      setIsReadyQrPrintOutWard(false);
      return;
    }

    const shouldPrintQr = shouldPrintQrOutWardRef.current === true;

    const userLoginHeader = JSON.parse(
      localStorage.getItem("userLoginHeader") || "{}",
    );
    const isDVT =
      listBranch?.find((item: any) => Number(item.value) === Number(branchId))
        ?.attr6 === "DVT" || userLoginHeader?.companyCode === "DVT";
    console.log("[DVT-DEBUG] RetailOrder QR useEffect - isDVT:", isDVT);
    if (isDVT) {
      setValueQRCodeOutWard("DVT_STATIC_QR");
      setIsReadyQrPrintOutWard(true);
      return;
    }
    if (!shouldPrintQr) {
      setValueQRCodeOutWard(null);
      setIsReadyQrPrintOutWard(true);
      return;
    }

    const transaction = dataPrintOutWard?.tblInventoryTransactionModel;
    const serials = dataPrintOutWard?.inventoryTransactionSerialModels || [];

    // Nếu đơn hàng đã được thanh toán hết (Thanh toán sau <= 0), không in mã QR
    if (deferredPayment <= 0) {
      setValueQRCodeOutWard(null);
      setIsReadyQrPrintOutWard(true);
      return;
    }

    const totalAmount = deferredPayment;

    const orderNumber =
      transaction?.sourceCode ||
      transaction?.transactionCode ||
      String(idPrintOutWard || "");

    setIsReadyQrPrintOutWard(false);

    const fetchQr = async () => {
      try {
        const responseIp =
          await repositoryPos.get<MessageResponse<any>>("/api/v1/Public/ip");
        const ipAddress = responseIp?.data || "";
        const responseQr = await repositoryPayment.post<MessageResponse<any>>(
          "/api/TblMBQRcode/gen-qr-mb-v2",
          {
            amount: totalAmount,
            ipAddress,
            orderInfo: orderNumber,
            orderNumber,
          },
        );
        if (responseQr?.success && responseQr?.data?.qr_url) {
          setValueQRCodeOutWard(responseQr.data.qr_url);
        } else {
          setValueQRCodeOutWard(null);
          NotificationExtension.Warn(
            "Không tạo được mã QR thanh toán cho phiếu này",
          );
        }
      } catch {
        setValueQRCodeOutWard(null);
      } finally {
        setIsReadyQrPrintOutWard(true);
      }
    };

    fetchQr();
  }, [dataPrintOutWard, idPrintOutWard]);

  // useEffect để in sau khi đã fetch xong dataCommuneMoi và QR
  React.useEffect(() => {
    if (dataPrintOutWard !== null && isReadyToPrint && isReadyQrPrintOutWard) {
      handlePrintOutWard();
      shouldPrintQrOutWardRef.current = false;
      setIdPrintOutWard("");
      setDataPrintOutWard(null);
      setIsReadyToPrint(false);
      setValueQRCodeOutWard(null);
      setDataLinhKienLR(null);
    }
  }, [dataPrintOutWard, isReadyToPrint, isReadyQrPrintOutWard]);
  const handleCloseDepositModal = () => {
    setDepositModalOpened(false);
  };

  const handleChangePrice = (value: any, key: string) => {
    handlePaymentChange(key, value, {
      setCashPayment,
      setBankTransfer,
      setCardPayment,
      setVnpayPayment,
      setAnotherPayment,
    });
  };

  const handleChooseCustomer = (value: any, isChooseCustomer: any) => {
    if (isChooseCustomer) {
      // Chỉ cập nhật attribute1 nếu isChooseCustomer = true
      setCustomerCheck({
        ...customerCheck,
        debtLimit: value?.debtLimit,
        debtTerm: value?.debtTerm,
        attribute1: value?.attribute1,
      });
      setOrderHeader({ ...orderHeader, attribute16: value?.attribute1 });
    } else {
      // Cập nhật toàn bộ thông tin khách hàng
      setCustomerCheck({
        ...customerCheck,
        code: value?.code,
        name: value?.name,
        telephoneNumber: value?.telephoneNumber,
        id: value?.id,
        type: value?.type,
        province: value?.province,
        district: value?.district,
        commune: value?.commune,
        address: value?.address,
        attribute1: value?.attribute1,
        attribute4: value?.attribute4,
        attribute13: value?.attribute13, // Province ID
        attribute14: value?.attribute14, // Commune ID
        companyName: value?.companyName,
        debtLimit: value?.debtLimit,
        debtTerm: value?.debtTerm,
        groupId: value?.groupId,
        groupCode: value?.groupCode,
        taxCode: value?.taxCode,
        email: value?.email,
      });

      // Tạo object thông tin thuế từ dữ liệu khách hàng
      const newTaxInfo = {
        TaxCode: value?.taxCode || "",
        TaxCompany: value?.companyName || "",
        TaxEmail: value?.email || "",
        TaxAddress: value?.attribute16 || "",
      };

      console.log("Tax Info Object:", newTaxInfo);

      // Cập nhật state taxInfo và lưu vào attribute57 của orderHeader
      setTaxInfo(newTaxInfo);
      setOrderHeader({
        ...orderHeader,
        custId: value?.id,
        attribute57: JSON.stringify(newTaxInfo),
      });

      // Kiểm tra nếu listBuyerName có phần tử hợp lệ thì cập nhật state
      if (
        Array.isArray(value?.listBuyerName) &&
        value.listBuyerName.length > 0
      ) {
        const filteredBuyerNames = value.listBuyerName
          .map((buyer: any) => {
            const parts = [];

            if (buyer.name) parts.push(buyer.name);
            if (buyer.telephoneNumber) parts.push(buyer.telephoneNumber);
            if (buyer.attribute1) parts.push(buyer.attribute1);

            return parts.length > 0 ? parts.join(" - ") : null;
          })
          .filter(Boolean); // Loại bỏ giá trị null, undefined, ""

        setListBuyerName(filteredBuyerNames);

        setListAddress(value?.listAddress || []); // Cập nhật listAddress nếu có
        setDataDeliveryInformation((prev: any) => ({
          ...prev,
          listAddress: value?.listAddress || [],
        }));
        // Auto chọn phần tử đầu tiên của mảng listBuyerName làm người mua hàng
        setOrderHeader((prev) => ({
          ...prev,
          attribute36: filteredBuyerNames[0] || "",
        }));
      } else {
        setListBuyerName([]); // Nếu không có dữ liệu hợp lệ, đặt về mảng rỗng
        setListAddress([]); // Nếu không có dữ liệu hợp lệ, đặt về mảng rỗng
        setDataDeliveryInformation((prev: any) => ({
          ...prev,
          listAddress: [],
        }));
        setOrderHeader((prev) => ({
          ...prev,
          attribute36: "",
        }));
      }
    }
  };

  // Hàm nhận vào payType và trả về payAmount
  const getPayAmountByPayType = (payType: string): number | undefined => {
    const payment = dataPayment?.find(
      (p: any) => (p.PayType ?? p.payType) === payType,
    );
    return payment ? (payment?.PayAmount ?? payment?.payAmount) : undefined;
  };

  const getCardBank = () => {
    const bankCard = dataPayment?.find((p: any) => p.PayType === "03");
    return bankCard ? bankCard?.Attribute1 : undefined;
  };

  const getBankCode = () => {
    const bankCard = dataPayment?.find((p: any) => p.PayType === "03");
    return bankCard ? bankCard?.Attribute2 : undefined;
  };

  const headerRef = React.useRef<HTMLDivElement>(null);

  const handleAllocateItems = async () => {
    try {
      if (
        (orderHeader?.amountDiscountTotal ?? 0) > 0 &&
        !orderHeader?.attribute39 &&
        (!orderHeader?.attribute97 || !orderHeader.attribute97.trim())
      ) {
        NotificationExtension.Warn(
          "Vui lòng nhập diễn giải khuyến mãi tổng đơn trước khi phân bổ!",
        );
        setPromoDescOpened(true);
        return;
      }

      const requestBody = {
        priceKm: orderHeader?.amountDiscountTotal || 0, //  Khuyến mãi tổng đơn, cập nhật giá trị nếu cần
        priceReduce: orderHeader?.discountAddedTotal || 0,
        idItems: listAdd
          .filter((item: any) => (item.priceFinal || 0) > 0) // Loại bỏ các item có priceFinal == 0
          .map((item: any) => ({
            price: item.priceFinal || 0,
            itemId: item.itemId || 0,
            quantity: item.quality || 0,
            itemCode: item.itemCode || "",
          })),
      };

      const response = await repositoryPos.post<MessageResponse<any>>(
        `/api/v1/TblItem/get-allcation-item`,
        requestBody,
      );

      if (response && response.success) {
        const data = response.data;
        // Tính tổng priceAllKM và priceAll từ data
        const totalPriceAllKM = data?.reduce(
          (sum: number, item: any) =>
            sum + (item.priceAllKM * item?.quantity || 0),
          0,
        );
        const totalPriceAll = data?.reduce(
          (sum: number, item: any) =>
            sum + (item.priceAll * item?.quantity || 0),
          0,
        );

        // Lấy giá trị từ orderHeader
        const expectedPriceAllKM = orderHeader?.amountDiscountTotal || 0;
        const expectedPriceAll = orderHeader?.discountAddedTotal || 0;

        // Kiểm tra điều kiện hợp lệ
        if (
          expectedPriceAllKM > 0 &&
          Math.abs(totalPriceAllKM - expectedPriceAllKM) >= 10
        ) {
          NotificationExtension.Fails(
            `Lỗi: Tổng priceAllKM (${totalPriceAllKM}) không khớp với amountDiscountTotal (${expectedPriceAllKM})`,
          );
          return;
        }

        if (
          expectedPriceAll > 0 &&
          Math.abs(totalPriceAll - expectedPriceAll) >= 10
        ) {
          NotificationExtension.Fails(
            `Lỗi: Tổng priceAll (${totalPriceAll}) không khớp với discountAddedTotal (${expectedPriceAll})`,
          );
          return;
        }

        // Xử lý logic khi API trả về thành công
        setDataAllocate(response?.data);
        setIsDisablePhanBo(true);
      } else {
        // Xử lý khi API trả về nhưng không thành công
      }
    } catch (error) {
      console.error("Error allocating items:", error);
    }
  };
  // Hàm xử lý call lấy mã tem và add vào list sản phẩm đã chọn
  const handleCheckTem = async (product: ProductModel) => {
    // check chi nhánh hiện tại xem đang thuộc thằng hacom hay DVT
    let brandAttr6 = listBranch.filter(
      (item) => Number(item.value) === Number(branchId),
    );
    const response = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblTemItem/tem?mahang=` + product?.segment3,
      true,
    );
    if (response && response.success) {
      const temData = response.data;
      // Nếu là chi nhánh DVT thì lấy temDvt, ngược lại lấy temHacom
      const itemCodeTem =
        brandAttr6[0]?.attr6 === "DVT" ? temData.temDvt : temData.temHacom;
      // console.log("itemCodeTem", itemCodeTem);
      if (itemCodeTem) {
        const url = `/api/v1/TblItem/search-sell?inv=${branchId}&key=${itemCodeTem}`;
        const result =
          await repositoryPos.get<MessageResponse<ProductModel[]>>(url);
        return result?.data || null; // Trả về data lấy được
      }
    }
    return null;
  };

  const handleSelectProduct = async (
    product: ProductModel,
    index: number,
    modeSearch?: string,
  ) => {
    try {
      if (branchId) {
        //cái Promotion này là call api lấy khuyến mại, quà tặng giảm giá
        const callapiPromotion = await repositoryPos.post<
          MessageResponse<TblItemPromotionModel[]>
        >(`/api/v1/TblItem/item-promotion`, {
          id: product.id,
          price: product?.price || 0,
          branch: branchId,
          groupId: customerCheck?.groupId,
        });

        // chỗ này call api để check gán mã tem (lưu ý số lượng tem còn thì mới hiện thị tem)
        const checkTemItem = await handleCheckTem(product);
        // console.log("checkTemItem", checkTemItem);

        const discountRate = 0;

        const discountAmount = 0;

        let idPromote = 0;
        // Chỗ này để map thằng temItem lấy được(nếu có)
        let addTemItem: dataOrderDetailTable | null = null;
        if (checkTemItem && checkTemItem.length > 0) {
          // Đối chiếu và chọn đúng tem theo kho của sản phẩm gốc (product)
          const selectedTem =
            checkTemItem.find(
              (item) =>
                product?.warehouseId &&
                item?.warehouseId &&
                Number(item.warehouseId) === Number(product.warehouseId),
            ) ||
            checkTemItem.find(
              (item) =>
                product?.wareHouseCode &&
                item?.wareHouseCode &&
                item.wareHouseCode.trim().toUpperCase() ===
                  product.wareHouseCode.trim().toUpperCase(),
            ) ||
            checkTemItem.find((item) => {
              const productWhSuffix = product?.wareHouseCode
                ?.split("_")[1]
                ?.toUpperCase();
              const itemWhSuffix = item?.wareHouseCode
                ?.split("_")[1]
                ?.toUpperCase();
              return (
                productWhSuffix &&
                itemWhSuffix &&
                productWhSuffix === itemWhSuffix
              );
            }) ||
            checkTemItem.find((item) => {
              const productCode = product?.wareHouseCode?.toUpperCase() || "";
              const itemCode = item?.wareHouseCode?.toUpperCase() || "";
              return (
                (productCode && itemCode.includes(productCode)) ||
                (itemCode && productCode.includes(itemCode))
              );
            }) ||
            checkTemItem[0];

          if (selectedTem) {
            addTemItem = {
              attribute23: selectedTem?.wareHouseCode,
              attribute20: selectedTem?.warranty?.toString(),
              id: selectedTem?.id,
              itemCode: selectedTem?.productCode,
              itemName: selectedTem?.productName,
              primaryUomCode: selectedTem?.unit || "",
              orgId: selectedTem?.warehouseId || 0,
              warehouse: selectedTem?.warehouse || "",
              priceType: "Giá niêm yết",
              quality: selectedTem?.quantity || 1,
              discountRate: discountRate,
              discountAmount: discountAmount,
              discountAdded: 0,
              isDiscountReset: false, // Khởi tạo flag reset discount
              priceFinal: discountRate
                ? (selectedTem?.price || 0) * 1 * (1 - discountRate / 100)
                : (selectedTem?.price || 0) * 1 - (discountAmount || 0) || 0,
              vatRate: 0,
              vatAmount: 0,
              totalLineAmount: discountRate
                ? (selectedTem?.price || 0) * 1 * (1 - discountRate / 100)
                : (selectedTem?.price || 0) * 1 - (discountAmount || 0) || 0,
              note: selectedTem?.notes ?? "",
              lineTyle: modeSearch === "DV" ? "DV" : "HH",
              orderHeaderId: 0,
              deptId: 0,
              itemId: selectedTem?.id,
              linkToItemId: 0,
              uomCode: "",
              priceListId: 0,
              priceOnPriceList: selectedTem?.price || 0,
              idPromote: idPromote || 0,
              idPromoteList: "",
              linkToLineId: 0,
              printInvoiceCheck: 0,
              promotePostPaid: "",
              promoteClearCheck: 0,
              promoteClearDate: "",
              prometeClearPersionId: 0,
              prometeClearClientId: "",
              clientId: 0,
              workShiftId: 0,
              createBy: 0,
              createDate: "",
              lastUpdateBy: 0,
              lastUpdateDate: "",
              subInvId: selectedTem?.warehouseId || 0,
              listIdPromotion: [],
              listIdAddOn: [],
              listIdGift: [],
              promotionDiscountPercent: 0,
              promotionDiscountAmount: 0,
              promotionItemGift: [],
            };
          }
        }

        if (callapiPromotion?.data) {
          // idPromote =
          //   callapiPromotion?.data[0]?.tblPromotionItemPrimary[0]?.id || 0;
          // idPromoteHT =
          //   callapiPromotion?.data[0]?.tblPromotionItemGift[0]?.id || 0;
        }
        const addData: dataOrderDetailTable = {
          attribute23: product?.wareHouseCode,
          attribute20: product?.warranty?.toString(),
          id: product?.id,
          isBhmrPackage: product?.isBhmrPackage, // BHMR: cờ gói (ATTRIBUTE57) từ search-sell
          itemCode: product?.productCode,
          itemName: product?.productName,
          primaryUomCode: product?.unit || "",
          orgId: product?.warehouseId || 0,
          warehouse: product?.warehouse || "",
          priceType: "Giá niêm yết",
          quality: product?.quantity || 1,
          discountRate: discountRate,
          discountAmount: discountAmount,
          discountAdded: 0,
          isDiscountReset: false, // Khởi tạo flag reset discount
          priceFinal: discountRate
            ? (product?.price || 0) * 1 * (1 - discountRate / 100)
            : (product?.price || 0) * 1 - (discountAmount || 0) || 0,
          vatRate: 0,
          vatAmount: 0,
          totalLineAmount: discountRate
            ? (product?.price || 0) * 1 * (1 - discountRate / 100)
            : (product?.price || 0) * 1 - (discountAmount || 0) || 0,
          note: product?.notes ?? "",
          lineTyle: modeSearch === "DV" ? "DV" : "HH",
          orderHeaderId: 0,
          deptId: 0,
          itemId: product?.id,
          linkToItemId: 0,
          uomCode: "",
          priceListId: 0,
          priceOnPriceList: product?.price || 0,
          idPromote: idPromote || 0,
          idPromoteList: "",
          linkToLineId: 0,
          printInvoiceCheck: 0,
          promotePostPaid: "",
          promoteClearCheck: 0,
          promoteClearDate: "",
          prometeClearPersionId: 0,
          prometeClearClientId: "",
          clientId: 0,
          workShiftId: 0,
          createBy: 0,
          createDate: "",
          lastUpdateBy: 0,
          lastUpdateDate: "",
          subInvId: product?.warehouseId || 0,
          listIdPromotion: [
            callapiPromotion?.data &&
            callapiPromotion.data.length > 0 &&
            typeof callapiPromotion.data[0].tblPromotion.id === "number"
              ? callapiPromotion.data[0].tblPromotion.id
              : null,
          ].filter((id): id is number => id !== null),
          listIdAddOn: [],
          listIdGift:
            (callapiPromotion?.data &&
              callapiPromotion?.data.length > 0 &&
              callapiPromotion?.data[0]?.tblPromotionItemGift &&
              callapiPromotion?.data[0]?.tblPromotionItemGift.map(
                (item) => item.idItemGift,
              )) ||
            [],
          promotionDiscountPercent:
            (callapiPromotion?.data &&
              callapiPromotion?.data.length > 0 &&
              callapiPromotion?.data[0]?.tblPromotionItemPrimary[0]
                ?.discountPercent) ||
            0,
          promotionDiscountAmount:
            (callapiPromotion?.data &&
              callapiPromotion?.data.length > 0 &&
              callapiPromotion?.data[0]?.tblPromotionItemPrimary[0]
                ?.discountAmount) ||
            0,
          promotionItemGift:
            (callapiPromotion?.data &&
              callapiPromotion?.data.length > 0 &&
              callapiPromotion?.data[0]?.tblPromotionItemGift.map((item) => ({
                itemCode: item?.itemForSellModel.productCode,
                itemName: item?.itemForSellModel.productName,
                primaryUomCode: item?.itemForSellModel.unit || "",
                quality: 1,
                warehouse: item?.itemForSellModel.warehouse,
              }))) ||
            [],
          coBanLe: product?.coBanLe,
        };

        if (
          callapiPromotion?.data &&
          callapiPromotion?.data[0]?.tblPromotionItemGift?.length > 0
        ) {
          setListAdd((prevList) => {
            // Nếu index === -1, thêm addData vào đầu mảng
            if (index === -1) {
              return [addData, ...prevList]; // Thêm addData vào đầu, và dataItemGif vào cuối
            } else {
              // Nếu index khác -1, cập nhật phần tử tại vị trí index và thêm dataItemGif
              const newList = [...prevList];
              newList[index] = addData;
              return newList;
            }
          });
          return;
        }

        // setListAdd((prevList) => {
        //   if (index === -1) {
        //     return [addData, ...prevList];
        //   } else {
        //     const newList = [...prevList];
        //     newList[index] = addData;
        //     return newList;
        //   }
        // });
        setListAdd((prevList) => {
          if (index === -1) {
            // Nếu có addTemItem thì thêm cả addData và addTemItem vào đầu mảng
            return addTemItem
              ? [addData, addTemItem, ...prevList]
              : [addData, ...prevList];
          } else {
            // Nếu index khác -1, cập nhật phần tử tại vị trí index và thêm addTemItem nếu có
            const newList = [...prevList];
            newList[index] = addData;
            return addTemItem ? [...newList, addTemItem] : newList;
          }
        });

        setIsCreating(false);
        table.setEditingRow(null);
        setDataProducts([]);
      }
    } catch (error) {
      console.error("Error in handleSelectProduct:", error);
    }
  };

  const handleGetNameAccountantById = async (
    accountantId: number | undefined,
  ) => {
    try {
      if (accountantId && accountantId != 0) {
        const response = await repositoryPos.get<MessageResponse<any>>(
          `/api/v1/TblDmEmployee/detail-employee?id=${accountantId}`,
        );
        if (response && response.success) {
          setAccountantName(response?.data?.fullName);
        }
      }
    } catch (error) {
      console.error("Error fetching accountant name:", error);
      return ""; // Trả về chuỗi rỗng nếu có lỗi
    }
  };

  const handleSelectPromotionMain = (promotionMain: any) => {
    const updatedList = listAdd.map((item) => {
      // Kiểm tra nếu itemId trùng với idItemPrimary
      if (
        item?.itemId ===
        promotionMain?.tblPromotionItemPrimary[0]?.idItemPrimary
      ) {
        const discountPrice =
          promotionMain?.tblPromotionItemPrimary[0]?.discountPrice || 0;

        // Nếu có discountPrice > 0 thì sử dụng logic mới
        if (discountPrice > 0) {
          return {
            ...item,
            idPromote: promotionMain?.tblPromotionItemPrimary[0]?.id,
            discountAmount: item?.priceOnPriceList - discountPrice,
            discountRate:
              promotionMain?.tblPromotionItemPrimary[0]?.discountPercent,
            priceFinal: discountPrice,
            // Thêm thông tin voucher vào item để dễ console log
            voucherInfo: promotionMain,
          };
        } else {
          // Giữ nguyên logic cũ khi không có discountPrice hoặc discountPrice <= 0
          return {
            ...item,
            idPromote: promotionMain?.tblPromotionItemPrimary[0]?.id,
            discountAmount:
              promotionMain?.tblPromotionItemPrimary[0]?.discountAmount,
            discountRate:
              promotionMain?.tblPromotionItemPrimary[0]?.discountPercent,
            priceFinal: promotionMain?.tblPromotionItemPrimary[0]
              ?.discountPercent
              ? item?.priceOnPriceList *
                  1 *
                  (1 -
                    promotionMain?.tblPromotionItemPrimary[0]?.discountPercent /
                      100) -
                (item?.discountAdded || 0)
              : item?.priceOnPriceList * 1 -
                  (promotionMain?.tblPromotionItemPrimary[0]?.discountAmount ||
                    0) -
                  (item?.discountAdded || 0) || 0,
            // Thêm thông tin voucher vào item để dễ console log
            voucherInfo: promotionMain,
          };
        }
      }
      return item; // Trả về item không thay đổi nếu không khớp
    });
    setListAdd(updatedList);
  };

  const handleSelectProductAddOn = async (
    products: itemAddOnPromotionModel[],
    itemId: string,
  ) => {
    try {
      if (branchId) {
        const newAddDataList: dataOrderDetailTable[] = [];

        for (const product of products) {
          const callapi = await repositoryPos.post<
            MessageResponse<ItemDetailPriceModel>
          >(
            `/api/v1/TblPriceListDetail/detail-price?id=${product?.idItemAddOn}&BranchId=${branchId}`,
          );

          if (callapi?.success) {
            const addData: dataOrderDetailTable = {
              attribute23: product?.itemForSellModel?.wareHouseCode,
              id: product?.idItemAddOn || 0,
              itemCode: product?.itemForSellModel?.productCode || "",
              itemName: product?.itemForSellModel?.productName || "",
              primaryUomCode: product?.itemForSellModel?.unit || "",
              orgId: product?.itemForSellModel?.warehouseId || 0,
              warehouse: product?.itemForSellModel?.warehouse || "",
              priceType: "Giá niêm yết",
              quality: 1,
              discountRate: product.discountPercent || 0,
              discountAmount: product.discountAmount || 0,
              discountAdded: 0,
              priceFinal: product.discountPercent
                ? callapi?.data?.listPrice -
                  (callapi?.data?.listPrice * product.discountPercent) / 100
                : callapi?.data?.listPrice - (product.discountAmount || 0),
              vatRate: callapi.data?.vatRate || 0,
              vatAmount: callapi.data?.vatAmount || 0,
              totalLineAmount: product.discountPercent
                ? callapi?.data?.listPrice -
                  (callapi?.data?.listPrice * product.discountPercent) / 100
                : callapi?.data?.listPrice - (product.discountAmount || 0),
              note: "",
              lineTyle: "HK",
              orderHeaderId: 0,
              deptId: 0,
              itemId: product?.idItemAddOn || 0,
              linkToItemId: Number(itemId),
              uomCode: "",
              priceListId: callapi.data?.idPriceLis || 0,
              priceOnPriceList: callapi.data?.listPrice || 0,
              idPromote: product?.id || 0,
              idPromoteList: "",
              linkToLineId: 0,
              printInvoiceCheck: 0,
              promotePostPaid: "",
              promoteClearCheck: 0,
              promoteClearDate: "",
              prometeClearPersionId: 0,
              prometeClearClientId: "",
              clientId: 0,
              workShiftId: 0,
              createBy: 0,
              createDate: "",
              lastUpdateBy: 0,
              lastUpdateDate: "",
              subInvId: product?.itemForSellModel?.warehouseId || 0,
              listIdPromotion: [],
              listIdAddOn: [],
              listIdGift: [],
              promotionDiscountPercent: 0,
              promotionDiscountAmount: 0,
            };

            newAddDataList.push(addData);
          }
        }

        setListAdd((prevList) => {
          // Xóa các sản phẩm cũ có cùng itemCode và lineTyle với sản phẩm mới
          const filteredList = prevList.filter((existingItem) => {
            return !newAddDataList.some(
              (newItem) =>
                existingItem.itemCode === newItem.itemCode &&
                existingItem.lineTyle === newItem.lineTyle,
            );
          });

          // Thêm sản phẩm mới
          return [...filteredList, ...newAddDataList];
        });
        table.setEditingRow(null);
      }
    } catch (error) {
      console.error("Error in handleSelectProductAddOn:", error);
    }
  };

  const handleSelectProductGift = async (
    products: itemGiftPromotionModel[],
    itemId: string,
  ) => {
    try {
      console.log("products gift", products);
      if (branchId) {
        const addDataList: dataOrderDetailTable[] = [];

        for (const product of products) {
          const callapi = await repositoryPos.post<
            MessageResponse<ItemDetailPriceModel>
          >(
            `/api/v1/TblPriceListDetail/detail-price?id=${product?.idItemGift}&BranchId=${branchId}`,
          );

          if (callapi?.success) {
            const addData: dataOrderDetailTable = {
              attribute23: product?.itemForSellModel?.wareHouseCode,
              id: product?.idItemGift || 0,
              itemCode: product?.itemForSellModel?.productCode || "",
              itemName: product?.itemForSellModel?.productName || "",
              primaryUomCode: product?.itemForSellModel?.unit || "",
              orgId: product?.itemForSellModel?.warehouseId || 0,
              warehouse: product?.itemForSellModel?.warehouse || "",
              priceType: "Giá niêm yết",
              quality: 1,
              discountRate: 100,
              discountAmount: 0,
              discountAdded: 0,
              priceFinal: 0,
              vatRate: callapi.data?.vatRate || 0,
              vatAmount: callapi.data?.vatAmount || 0,
              totalLineAmount: 0,
              note: "",
              lineTyle: "KM",
              orderHeaderId: 0,
              deptId: 0,
              itemId: product?.idItemGift || 0,
              linkToItemId: Number(itemId),
              uomCode: "",
              priceListId: callapi.data?.idPriceLis || 0,
              priceOnPriceList: callapi.data?.listPrice || 0,
              idPromote: product?.id || 0,
              idPromoteList: "",
              linkToLineId: 0,
              printInvoiceCheck: 0,
              promotePostPaid: "",
              promoteClearCheck: 0,
              promoteClearDate: "",
              prometeClearPersionId: 0,
              prometeClearClientId: "",
              clientId: 0,
              workShiftId: 0,
              createBy: 0,
              createDate: "",
              lastUpdateBy: 0,
              lastUpdateDate: "",
              subInvId: product?.itemForSellModel?.warehouseId || 0,
              listIdPromotion: [],
              listIdAddOn: [],
              listIdGift: [],
              promotionDiscountPercent: 0,
              promotionDiscountAmount: 0,
            };
            addDataList.push(addData);
          }
        }

        setListAdd((prevList) => {
          // Xóa các sản phẩm cũ có cùng itemCode và lineTyle với sản phẩm mới
          const filteredList = prevList.filter((existingItem) => {
            return !addDataList.some(
              (newItem) =>
                existingItem.itemCode === newItem.itemCode &&
                existingItem.lineTyle === newItem.lineTyle,
            );
          });

          // Thêm sản phẩm mới
          return [...filteredList, ...addDataList];
        });
      }
    } catch (error) {
      console.error("Error in handleSelectProductGift:", error);
    }
  };

  const checkDebtLimit = (dueAmount: any, debtLimit: any, debtType: string) => {
    if (debtType !== "Công nợ") return true;
    const totalDebt = dueAmount || 0; // Tổng số tiền nợ
    const limit = debtLimit || 0; // Hạn mức công nợ

    if (totalDebt > limit) {
      NotificationExtension.Fails(
        `Đơn Hàng ${
          orderHeader?.orderNumber
        } vượt quá hạn mức công nợ: ${limit.toLocaleString(
          "vi-VN",
        )} VNĐ. Không thể thanh toán.`,
      );
      return false; // Trả về false nếu vượt hạn mức công nợ
    }

    return true; // Trả về true nếu trong hạn mức
  };

  //Hàm lấy thông tin của MST
  const handleSearchTax = async () => {
    try {
      const response = await axios.get(
        `https://hoadondientu.gdt.gov.vn/api/category/public/dsdkts/${taxInfo?.TaxCode}/manager`,
        {
          headers: {
            "request-id": newGuid(),
          },
        },
      );

      if (response && response.data) {
        const data = response.data;
        const dataAddress = [data?.dctsdchi, data?.dctsxaten, data?.dctstinhten]
          .filter((i) => i && String(i).length > 0)
          .map((i) => String(i).trim())
          .join(", ");

        NotificationExtension.Success("Lấy thông tin MST thành công !");

        const newTaxInfo = {
          ...taxInfo,
          TaxCompany: data.tennnt || "",
          TaxAddress: dataAddress || "",
        };
        setTaxInfo(newTaxInfo);
        setOrderHeader((prev) => ({
          ...prev,
          attribute57: JSON.stringify(newTaxInfo),
        }));

        setTimeOutCallApi(true);
        setTimeout(() => {
          setTimeOutCallApi(false);
        }, 5000);
      } else {
        NotificationExtension.Fails("Không tìm thấy thông tin của MST !");
      }
    } catch (error) {
      console.log(error);
      NotificationExtension.Fails(
        "Có lỗi xảy ra trong quá trình lấy thông tin của MST, vui lòng thử lại sau ít phút !",
      );
    }
  };

  const handleSendMessageOrderSuccsess = async () => {
    if ((customerCheck as any)?.blockZns) return;
    const isDVT =
      listBranch?.find((item: any) => Number(item.value) === Number(branchId))
        ?.attr6 === "DVT";
    console.log("[DVT-DEBUG] RetailOrder handleSendMessage - isDVT:", isDVT);
    if (isDVT) return;
    if (customerCheck?.groupId === 166) return;
    if (customerCheck?.type !== 1) return;
    if (
      customerCheck?.groupCode === "PHUQUYHY_CAM" ||
      customerCheck?.groupCode === "CAM"
    )
      return;

    let customerData = null;
    try {
      customerData = orderHeader?.attribute1
        ? JSON.parse(orderHeader.attribute1)
        : null;
    } catch (error) {
      console.error("Error parsing customerData from attribute1:", error);
      customerData = null;
    }

    const recipientPhone =
      customerData?.telephoneNumber || customerCheck?.telephoneNumber;
    if (!recipientPhone) return;

    const formatDate = (value?: string | Date | null) => {
      if (!value) return "";

      const date = new Date(value);
      return Number.isNaN(date.getTime())
        ? ""
        : date.toLocaleDateString("vi-VN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
    };
    const orderAmount =
      location?.state?.actionType === "view"
        ? orderHeader?.amountTotal
        : payableAmount;
    const completedAt = new Date();
    const tomorrow = new Date(completedAt);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const znsResponse = await sendZnsMessage(
      createZnsPayload(
        `${orderHeader?.orderNumber || "ORDER"}-${Date.now()}`,
        ZNS_TEMPLATE_IDS.ORDER_COMPLETED,
        {
          customer_name: customerCheck?.name || customerData?.customerName,
          ma_don_hang: orderHeader?.orderNumber,
          ngay_dat_hang: formatDate(completedAt),
          thanh_tien: `${Number(orderAmount || 0).toLocaleString("vi-VN")} VND`,
          dia_chi_nhan__hang: !isHaveShiping
            ? branchName
            : customerData?.customerAddress || customerCheck?.address,
          ngay_nhan_du_kien: !isHaveShiping
            ? formatDate(completedAt)
            : formatDate(
                dataDeliveryInformation?.deliveryAppointmentTime ||
                  customerData?.deliveryAppointmentTime ||
                  tomorrow,
              ),
          so_dien_thoai: recipientPhone,
          ma_don: orderHeader?.orderNumber,
        },
        recipientPhone,
      ),
    );

    if (znsResponse?.status === 0 || znsResponse?.success === false) {
      NotificationExtension.Fails(
        znsResponse?.description || znsResponse?.message || "Gui ZNS that bai",
      );
    }
  };

  const handleCreatePartnerShippingOrder = async (custData?: any) => {
    try {
      let customerDataParsed = custData;
      if (!customerDataParsed) {
        try {
          customerDataParsed = orderHeader?.attribute1
            ? JSON.parse(orderHeader.attribute1)
            : null;
        } catch (e) {
          customerDataParsed = null;
        }
      }

      const deliveryData = {
        ...dataDeliveryInformation,
        ...(customerDataParsed || {}),
        isOffice124:
          customerDataParsed?.isOffice124 ?? dataDeliveryInformation?.isOffice124,
        senderPhone:
          customerDataParsed?.senderPhone || dataDeliveryInformation?.senderPhone,
      };

      const isOffice124 = Boolean(deliveryData?.isOffice124);
      
      const isCOD =
        orderHeader?.attribute24 === "Giao Hàng Thu Tiền(COD)" ||
        deliveryData?.attribute24 === "Giao Hàng Thu Tiền(COD)" ||
        orderHeader?.attribute24?.toLowerCase()?.includes("giao hàng thu tiền");

      if (!isOffice124 && !isCOD) return;

      const shippingVendor = (
        deliveryData?.shippingVendor ||
        deliveryData?.shipingVendor ||
        orderHeader?.shipingVendor ||
        ""
      ).trim();

      if (!shippingVendor) {
        console.warn(
          "Không có thông tin hãng vận chuyển (shippingVendor)",
        );
        return;
      }

      console.log(
        "Đang tạo đơn vận chuyển cho hãng:",
        shippingVendor,
      );

      // Lấy tên tỉnh/thành phố và phường/xã của người nhận
      const provinceId =
        deliveryData?.customerProvinceId ||
        customerCheck?.province ||
        customerCheck?.attribute13;
      const communeId =
        deliveryData?.customerCommuneId ||
        customerCheck?.commune ||
        customerCheck?.attribute14;

      let provinceName = "";
      let communeName = "";

      try {
        const [provRes, commRes] = await Promise.all([
          provinceId ? getProvinceSelectNew() : Promise.resolve([]),
          provinceId
            ? repositoryMdm.get<any>(
                `/api/v1/TblDmCommuneMoi/get-select?ProvinceIds=${provinceId}`,
              )
            : Promise.resolve(null),
        ]);

        const rawProvData = (provRes as any)?.data ?? provRes;
        const provList = Array.isArray(rawProvData) ? rawProvData : [];
        if (provList.length > 0) {
          const foundProv = provList.find(
            (p: any) =>
              String(p.id) === String(provinceId) ||
              String(p.value) === String(provinceId) ||
              Number(p.id) === Number(provinceId),
          );
          if (foundProv) {
            provinceName =
              foundProv.name || foundProv.label || foundProv.text || "";
          }
        }

        const rawCommData = (commRes as any)?.data ?? commRes;
        const commList = Array.isArray(rawCommData) ? rawCommData : [];
        if (commList.length > 0) {
          const foundComm = commList.find(
            (c: any) =>
              String(c.value) === String(communeId) ||
              String(c.id) === String(communeId) ||
              Number(c.value) === Number(communeId),
          );
          if (foundComm) {
            communeName =
              foundComm.text || foundComm.label || foundComm.name || "";
          }
        }
      } catch (err) {
        console.error("Lỗi khi lấy tên tỉnh/thành phố, phường/xã:", err);
      }

      if (!provinceName && (deliveryData?.customerProvinceName || customerCheck?.provinceName)) {
        provinceName =
          deliveryData?.customerProvinceName ||
          customerCheck?.provinceName ||
          "";
      }
      if (!communeName && (deliveryData?.customerCommuneName || customerCheck?.communeName)) {
        communeName =
          deliveryData?.customerCommuneName ||
          customerCheck?.communeName ||
          "";
      }

      // Thông tin người nhận
      const recipientName =
        deliveryData?.customerName ||
        customerCheck?.name ||
        "";
      const recipientPhone =
        deliveryData?.telephoneNumber ||
        customerCheck?.telephoneNumber ||
        "";
      const recipientAddress = deliveryData?.customerAddress || "";

      // Ghép địa chỉ giao hàng đầy đủ: [Số nhà chi tiết, Phường/Xã, Tỉnh/Thành phố]
      const addressParts = [recipientAddress, communeName, provinceName].filter(
        (i: any) => i && String(i).trim().length > 0,
      );
      const fullAddress =
        deliveryData?.to_address ||
        (addressParts.length > 1 ? addressParts.join(" - ") : recipientAddress);

      // Thông tin người gửi
      const senderPhone =
        deliveryData?.senderPhone ||
        deliveryData?.pick_tel ||
        dataDeliveryInformation?.senderPhone ||
        "0988655130";
        
      let pickAddress = deliveryData?.pick_address || "";
      let pickName = deliveryData?.pick_name || "CÔNG TY CỔ PHẦN ĐẦU TƯ CÔNG NGHỆ HACOM";
      let pickProvince = deliveryData?.pick_province || "";
      let pickWard = deliveryData?.pick_ward || "";
      let pickDistrict = deliveryData?.pick_district || "";

      if (isOffice124) {
        pickAddress = "124 Minh Khai, Hai Bà Trưng, Hà Nội";
        pickName = "Văn phòng Hacom 124";
        pickProvince = "Hà Nội";
        pickWard = "Minh Khai";
        pickDistrict = "Hai Bà Trưng";
      }

      // Tiền COD
      const pickMoney = isCOD
        ? Math.max(
            0,
            (Number(orderHeader?.amountRemaining) || 0) -
              (Number(orderHeader?.deposit) || 0),
          )
        : 0;

      const totalValue = Number(orderHeader?.amountTotal) || 0;

      // Nhận diện đối tác vận chuyển
      const isGHTK =
        shippingVendor === "Giao hàng tiết kiệm" ||
        shippingVendor.toLowerCase().includes("tiết kiệm") ||
        shippingVendor.toLowerCase().includes("ghtk");

      const isAhamove =
        shippingVendor.startsWith("Ahamove") ||
        shippingVendor.toLowerCase().includes("ahamove");

      if (isGHTK) {
        const productsGHTK = (
          listAdd && listAdd.length > 0 ? listAdd : []
        ).map((item: any) => ({
          name: String(item.itemName || item.name || "Dịch vụ giao hàng"),
          weight: Number(item.weight) > 0 ? Number(item.weight) : 0.5,
          quantity: Number(item.quality || item.quantity) || 1,
          product_code: String(item.itemCode || item.id || "DV"),
        }));

        if (productsGHTK.length === 0) {
          productsGHTK.push({
            name: isOffice124 ? "Dịch vụ giao hàng văn phòng 124" : "Dịch vụ giao hàng",
            weight: 0.5,
            quantity: 1,
            product_code: isOffice124 ? "DV_124" : "DV",
          });
        }

        const ghtkPayload = {
          order: {
            products: productsGHTK,
            order: {
              id: orderHeader?.orderNumber,
              pick_name: pickName,
              pick_address: pickAddress,
              pick_province: pickProvince,
              pick_district: null,
              pick_ward: pickWard,
              pick_tel: senderPhone,
              tel: recipientPhone,
              name: recipientName,
              address: fullAddress || recipientAddress,
              province: provinceName,
              district: null,
              ward: communeName,
              hamlet: "Khác",
              is_freeship: "1",
              pick_money: pickMoney,
              note: deliveryData?.description || "",
              value: totalValue,
              pick_option: "cod",
              total_box: 1,
            },
          },
          updateOrderShipping: isCOD,
          attribute78: "DA_DONG_GOI",
          attribute71: isOffice124 ? "Tạo đơn GHTK văn phòng 124" : "Tạo đơn GHTK (COD)",
        };

        const responseGHTK = await repositoryMdm.post<any>(
          "/api/v1/GHTK/create-order",
          ghtkPayload,
        );

        if (responseGHTK?.success === true) {
          NotificationExtension.Success(
            isOffice124 ? "Tạo đơn GHTK văn phòng 124 thành công" : "Tạo đơn GHTK thành công",
          );
        } else {
          NotificationExtension.Fails(
            `Tạo đơn GHTK thất bại: ${responseGHTK?.message || "Lỗi không xác định"}`,
          );
          await repositoryPos.post("/api/v1/CreateSellItem/update-ghtk-log", {
            orderNumber: orderHeader?.orderNumber,
            attribute42:
              responseGHTK?.message ||
              "Lỗi không xác định khi tạo đơn GHTK",
          });
        }
      } else if (isAhamove) {
        const itemsAhamove = (
          listAdd && listAdd.length > 0 ? listAdd : []
        ).map((item: any) => ({
          _id: String(item.itemCode || item.itemId || item.id || "DV"),
          num: Number(item.quality || item.quantity) || 1,
          name: String(item.itemName || item.name || "Dịch vụ giao hàng"),
          price: Number(item.priceFinal || item.price) || 0,
        }));

        if (itemsAhamove.length === 0) {
          itemsAhamove.push({
            _id: "DV_124",
            num: 1,
            name: "Dịch vụ giao hàng",
            price: 0,
          });
        }

        let serviceId = "HAN-BIKE";
        const typeShip =
          deliveryData?.typeShip || dataDeliveryInformation?.typeShip || "";
        if (
          typeShip === "Siêu tốc tiết kiệm" ||
          typeShip === "Tiết kiệm" ||
          typeShip === "HAN-ECO"
        ) {
          serviceId = "HAN-ECO";
        } else if (typeShip === "Đồng giá" || typeShip === "HAN-SAMEPRICE") {
          serviceId = "HAN-SAMEPRICE";
        } else {
          serviceId = "HAN-BIKE";
        }

        const dataAhamove = {
          order_time: 0,
          path: [
            {
              address: pickAddress,
              short_address: pickProvince || "Hà Nội",
              name: pickName,
              mobile: senderPhone,
              remarks: isOffice124 ? "Đến văn phòng 124 Minh Khai đọc mã đơn để nhận hàng" : "Đọc mã đơn để nhận hàng",
            },
            {
              address: fullAddress,
              short_address: provinceName || "Hà Nội",
              name: recipientName,
              mobile: recipientPhone,
              cod: pickMoney,
              item_value: totalValue,
              tracking_number: orderHeader?.orderNumber,
              remarks:
                deliveryData?.description ||
                "Gọi điện trước khi giao. Giao hàng cẩn thận",
            },
          ],
          service_id: serviceId,
          payment_method: "BALANCE",
          remarks: `Tài xế đến văn phòng 124 Minh Khai, đọc mã đơn ${orderHeader?.orderNumber} để lấy hàng`,
          items: itemsAhamove,
        };

        const responseAhamove = await createAhamoveOrder(dataAhamove);
        if (responseAhamove?.data?.order_id) {
          NotificationExtension.Success(
            isOffice124 ? "Tạo đơn Ahamove văn phòng 124 thành công" : "Tạo đơn Ahamove thành công",
          );
          try {
            const updatedAttr1 = {
              ...deliveryData,
              sharedLink:
                responseAhamove?.data?.shared_link ||
                responseAhamove?.order?.tracking_id,
            };
            await repositoryPos.post(
              "/api/v1/CreateSellItem/update-attribute1",
              {
                orderNumber: orderHeader?.orderNumber,
                attribute1: JSON.stringify(updatedAttr1),
              },
            );
          } catch (err) {
            console.error("Error updating attribute1 with sharedLink:", err);
          }
        } else {
          NotificationExtension.Fails(
            `Tạo đơn Ahamove thất bại: ${
              responseAhamove?.description ||
              responseAhamove?.message ||
              "Lỗi không xác định"
            }`,
          );
          await repositoryPos.post("/api/v1/CreateSellItem/update-ghtk-log", {
            orderNumber: orderHeader?.orderNumber,
            attribute42:
              responseAhamove?.description ||
              responseAhamove?.message ||
              "Lỗi không xác định khi tạo đơn Ahamove",
          });
        }
      }
    } catch (error) {
      console.error("Lỗi khi tạo đơn vận chuyển đối tác:", error);
      NotificationExtension.Fails(
        "Lỗi khi tạo đơn vận chuyển đối tác",
      );
    }
  };

  const handleCallApiPayment = async () => {
    try {
      let customerData = null;
      try {
        customerData = orderHeader?.attribute1
          ? JSON.parse(orderHeader.attribute1)
          : null;
      } catch (error) {
        console.error("Error parsing customerData from attribute1:", error);
        customerData = null;
      }

      if (customerData?.shippingVendor === "Ahamove") {
        const amountToCheck =
          location?.state?.actionType === "view"
            ? orderHeader?.amountRemaining
            : deferredPayment - orderHeader?.amountPaid;

        const typeShip = customerData?.typeShip;

        let limit = Infinity;

        if (typeShip === "Hỏa tốc") {
          limit = 10_000_000;
        } else if (typeShip === "2H") {
          limit = 1_000_000;
        }

        if (amountToCheck > limit) {
          const limitFormatted = limit.toLocaleString("vi-VN") + " VNĐ";
          NotificationExtension.Fails(
            `Số tiền cần thanh toán vượt quá giới hạn cho loại giao hàng "${typeShip}": ${limitFormatted}`,
          );
          return;
        }
      }

      const expectedPriceAllKM = orderHeader?.amountDiscountTotal || 0;
      const expectedPriceAll = orderHeader?.discountAddedTotal || 0;
      if (
        (expectedPriceAllKM > 0 || expectedPriceAll > 0) &&
        dataAllocate.length === 0
      ) {
        NotificationExtension.Fails("Vui lòng phân bổ trước khi thanh toán !");
        return;
      }
      //ghi log
      saveLogToLocalStorage();
      // Kiểm tra công nợ trước khi thực hiện thanh toán
      if (
        !checkDebtLimit(
          containsDT(orderHeader?.orderNumber) &&
            location?.state?.actionType !== "doi"
            ? orderHeader?.amountTotal
            : deferredPayment - orderHeader?.amountPaid,
          customerCheck?.debtLimit,
          dataPaymentLatter
            ? dataPaymentLatter?.payLaterMethod
            : payLaterMethod,
        )
      ) {
        return; // Dừng nếu công nợ vượt hạn mức
      }

      // Tạo mảng paymentCommands
      const paymentCommands = [
        {
          // Tiền mặt
          payType: "02",
          payAmount: cashPayment,
          payeeId: customerCheck?.id,
        },
        {
          // QR
          payType: "01",
          payAmount: bankTransfer,
          payeeId: customerCheck?.id,
          attribute1: selectedBankReserve,
          attribute2: transactionCodeReserve
            ? transactionCodeReserve
            : transactionCodeMb,
          isDynamicQr: transactionCodeMb ? 1 : 0,
        },
        {
          // VN pay
          payType: "04",
          payAmount: vnpayPayment,
          payeeId: customerCheck?.id,
        },
        {
          // Cà thẻ
          payType: "03",
          payAmount: cardPayment,
          payeeId: customerCheck?.id,
          attribute1: mapSelectedBank(selectedBank), // Ngân hàng cà thẻ
          attribute2: transactionCodeCard, // Mã giao dịch thẻ
        },
        {
          // Thanh toán khác
          payType: "08",
          payAmount: anotherPayment,
          payeeId: customerCheck?.id,
          attribute1: selectedBankReserve,
          attribute2: transactionCodeReserve,
        },
      ].filter((payment) => payment.payAmount > 0); // Lọc các phương thức thanh toán có payAmount > 0

      const combinedInfo = {
        payLaterMethod,
        installmentInfo:
          payLaterMethod === "Trả góp" ? installmentInfo : undefined,
        debtInfo: payLaterMethod === "Công nợ" ? debtInfo : undefined,
      };

      // Gọi API update-deposit trước nếu có thông tin tiền cọc
      if (depositCode && depositAmount) {
        try {
          const depositResponse = await repositoryPos.post<
            MessageResponse<any>
          >("/api/v1/CreateSellItem/update-deposit", {
            orderNumber: orderHeader?.orderNumber,
            orderId: orderHeader?.id || 0,
            deposit: Number(depositAmount),
            receiptNumber: depositCode,
          });

          if (depositResponse?.success) {
            console.log("Update deposit API response:", depositResponse.data); // Debug log
            // Lưu thông tin từ API response vào orderHeader
            setOrderHeader((prev) => ({
              ...prev,
              deposit:
                depositResponse.data?.deposit?.toString() || depositAmount,
              receiptNumber: depositResponse.data?.receiptNumber || depositCode,
              // Có thể lưu thêm các field khác nếu cần
            }));
            console.log("Updated orderHeader with deposit:", {
              deposit:
                depositResponse.data?.deposit?.toString() || depositAmount,
              receiptNumber: depositResponse.data?.receiptNumber || depositCode,
            }); // Debug log
          } else {
            NotificationExtension.Fails("Lỗi khi cập nhật thông tin tiền cọc!");
            return; // Dừng lại nếu API update-deposit thất bại
          }
        } catch (depositError) {
          console.error("Error calling update-deposit API:", depositError);
          NotificationExtension.Fails("Lỗi khi cập nhật thông tin tiền cọc!");
          return; // Dừng lại nếu có lỗi
        }
      }

      const response = await repositoryPos.post<
        MessageResponse<dataCreateSalesOrder>
      >("/api/v1/CreateSellItem/payment", {
        paymentCommands: paymentCommands,
        orderNumber: orderHeader?.orderNumber,
        attribute20: JSON.stringify(combinedInfo),
        attribute1: selectedBankReserve,
        attribute2: transactionCodeReserve,
        attribute23: orderHeader?.attribute23 || "",
        tblOrderDetails: dataAllocate?.length > 0 ? listAdd : [],
        orderTotal: payableAmount,
      });

      if (response?.success) {
        setOrderStatus("DON_HANG_HOAN_THANH");
        // Thanh toán thành công update thời gian hoàn thành
        setOrderHeader((prev) => ({
          ...prev,
          orderDate: new Date().toISOString(),
        }));

        setTimeout(
          () => NotificationExtension.Success("Hoàn tất thanh toán thành công"),
          500,
        );

        // Kiểm tra nếu đơn hàng giao từ văn phòng 124 HOẶC PTTT là COD -> gọi API tạo đơn GHTK / Ahamove
        const isOffice124Order = Boolean(
          customerData?.isOffice124 ||
          dataDeliveryInformation?.isOffice124
        );
        const isCODOrder =
          orderHeader?.attribute24 === "Giao Hàng Thu Tiền(COD)" ||
          dataDeliveryInformation?.attribute24 === "Giao Hàng Thu Tiền(COD)" ||
          orderHeader?.attribute24?.toLowerCase()?.includes("giao hàng thu tiền");

        if (isOffice124Order || isCODOrder) {
          handleCreatePartnerShippingOrder(customerData);
        }

        // setIsPrinting(true);
        // setIdPrint(location?.state.id)
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    }
    modals.closeAll();
  };

  const handleDeleteOrder = async (
    orderNumber: string,
    type: string,
    closeModal = true,
  ) => {
    const res = await repositoryPos.get<MessageResponse<boolean>>(
      `/api/v1/CreateSellItem/delete?orderNumber=${orderNumber}`,
    );
    if (res?.success) {
      type === "cancel"
        ? NotificationExtension.Success("Hủy thành công !")
        : NotificationExtension.Success("Từ chối duyệt thành công !");
      setOrderStatus("DON_HANG_HUY");

      // Gửi ZNS thông báo hủy đơn (chỉ khi hủy đơn, không gửi khi từ chối duyệt)
      if (type === "cancel") {
        try {
          // Lọc: không gửi cho khách doanh nghiệp, nhóm 166, khách CAM
          const canSend =
            customerCheck?.groupId !== 166 &&
            customerCheck?.type === 1 &&
            customerCheck?.code !== "PHUQUYHY_CAM" &&
            customerCheck?.code !== "CAM";

          if (canSend) {
            let customerData: any = null;
            try {
              customerData = orderHeader?.attribute1
                ? JSON.parse(orderHeader.attribute1)
                : null;
            } catch (_) {}

            const recipientPhone =
              customerData?.telephoneNumber || customerCheck?.telephoneNumber;

            if (recipientPhone) {
              const formatDate = (value?: string | Date | null) => {
                if (!value) return "";
                const date = new Date(value);
                return Number.isNaN(date.getTime())
                  ? ""
                  : date.toLocaleDateString("vi-VN", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    });
              };

              const znsResponse = await sendZnsMessage(
                createZnsPayload(
                  `${orderNumber}-CANCEL-${Date.now()}`,
                  ZNS_TEMPLATE_IDS.ORDER_CANCELLED,
                  {
                    customer_name:
                      customerCheck?.name ||
                      customerData?.customerName ||
                      "Khách hàng",
                    ma_don_hang: orderNumber,
                    ngay_mua_hang: formatDate(orderHeader?.orderDate),
                  },
                  recipientPhone,
                ),
              );

              if (znsResponse?.status === 0 || znsResponse?.success === false) {
                console.warn(
                  "Gửi ZNS hủy đơn thất bại:",
                  znsResponse?.description || znsResponse?.message,
                );
              }
            }
          }
        } catch (znsError) {
          console.error("Lỗi khi gửi ZNS thông báo hủy đơn:", znsError);
        }
      }

      if (closeModal) modals.closeAll();
      return true;
    } else {
      type === "cancel"
        ? NotificationExtension.Fails("Hủy thất bại !")
        : NotificationExtension.Fails("Từ chối duyệt thất bại !");
      if (closeModal) modals.closeAll();
      return false;
    }
  };

  const handleCreateDraftFromCanceledApproval = async () => {
    const selectedBranchId =
      branchId || orderHeader?.orgId || orderHeader?.invOrgId;
    const selectedSaleChanelId = saleChanelId || orderHeader?.saleChanelId;

    if (!selectedBranchId) {
      NotificationExtension.Fails(
        "Vui lòng chọn chi nhánh trước khi tạo đơn nháp!",
      );
      return false;
    }

    if (!selectedSaleChanelId) {
      NotificationExtension.Fails(
        "Vui lòng chọn kênh bán trước khi tạo đơn nháp!",
      );
      return false;
    }

    const createHeaderResponse = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/CreateSellItem/create?codePrefix=DH`,
    );
    const draftHeader = createHeaderResponse?.data?.orderHeader;

    if (!createHeaderResponse?.success || !draftHeader?.orderNumber) {
      NotificationExtension.Fails("Không lấy được mã đơn nháp mới!");
      return false;
    }

    const deliveryAttribute = dataDeliveryInformation
      ? JSON.stringify({
          ...dataDeliveryInformation,
          branchId: selectedBranchId,
        })
      : orderHeader?.attribute1 || "";
    const canceledOrderNumber = orderHeader?.orderNumber || "";
    const draftReasonNote = `Đơn nháp được tạo bởi đơn hàng bị từ chối duyệt, mã đơn: ${canceledOrderNumber}`;
    const draftOrderNote = orderHeader?.note
      ? `${orderHeader.note}\n${draftReasonNote}`
      : draftReasonNote;

    const draftOrderDetail = listAdd.map((item) => ({
      ...item,
      id: item.itemId || item.id || 0,
      orderHeaderId: 0,
      totalLineAmount: (item.priceFinal || 0) * (item.quality || 0),
      deptId: orderHeader?.deptId,
      createBy: 0,
      createDate: "",
      lastUpdateBy: 0,
      lastUpdateDate: "",
    }));

    const response = await repositoryPos.post<
      MessageResponse<dataCreateSalesOrder>
    >("/api/v1/CreateSellItem/create", {
      orderDetail: toStoredWarranty(draftOrderDetail),
      orderHeader: {
        ...orderHeader,
        id: draftHeader?.id || 0,
        orderNumber: draftHeader.orderNumber,
        orderDate: draftHeader?.orderDate || orderHeader?.orderDate,
        orderStatus: "DON_HANG_TAM",
        note: draftOrderNote,
        approveId: 0,
        approveNote: "",
        rejectNote: "",
        shipngType: shipping,
        shipingVendor: shipingVendor,
        invOrgId: selectedBranchId,
        orgId: selectedBranchId,
        saleChanelId: selectedSaleChanelId,
        saleId: employeeSalesId,
        deptId: departmentId,
        printInvoiceCheck: orderHeader?.printInvoiceCheck,
        attribute2: accountantId,
        attribute18: employeeSalesRevenueId,
        contractcode: contractcode,
        orderTypeId: 2,
        branchId: selectedBranchId,
        amountTotal: payableAmount,
        amountDiscount: totalKMLine,
        amountVat: 0,
        attribute1: deliveryAttribute,
        createDate:
          draftHeader?.orderDate ||
          draftHeader?.createDate ||
          orderHeader?.orderDate,
        lastUpdateBy: 0,
        lastUpdateDate: "",
        orderNumberLink:
          orderHeader?.orderNumberLink || location?.state?.orderNumberOld,
        attribute8:
          customerCheck?.name && customerCheck?.code
            ? `${customerCheck.name}||${customerCheck.code}`
            : "",
        attribute16: orderHeader?.attribute16
          ? orderHeader?.attribute16
          : customerCheck?.attribute1,
        attribute31: customerCheck?.attribute4,
        attribute53: vatEmailList || "",
        custId: orderHeader?.custId ? orderHeader?.custId : customerCheck?.id,
        attribute70:
          (orderHeader as any)?.attribute70 ??
          discountSuggestionData?.customerGroup ??
          null,
        discountAdd: listAdd.reduce(
          (total, item) =>
            total + (item.discountAdded || 0) * (item.quality || 0),
          0,
        ),
      },
      isRetun: false,
      isLock: false,
    });

    if (response?.success) {
      NotificationExtension.Success("Tạo đơn nháp mới thành công!");
      SocketExtension.SendMessageToTopic<any>({
        topic: CREATEORDERSUCCESS,
        data: "",
      });
      return true;
    }

    NotificationExtension.Fails(
      response?.message || "Tạo đơn nháp mới thất bại!",
    );
    return false;
  };

  const handleCancelApprovalWithDraftChoice = () => {
    modals.openConfirmModal({
      title: <Title order={5}>Hủy duyệt đơn hàng</Title>,
      size: "sm",
      centered: true,
      children: (
        <Box>
          <Text size="sm" mb="md">
            Bạn có muốn tạo đơn nháp khi hủy?
          </Text>
          <Flex justify={"end"} gap={12}>
            <Button
              color="gray"
              leftSection={<IconX size={18} />}
              onClick={() => {
                handleDeleteOrder(orderHeader?.orderNumber, "approved");
              }}
            >
              Không
            </Button>
            <Button
              leftSection={<IconCheck size={18} />}
              onClick={async () => {
                modals.closeAll();
                openLoading();
                try {
                  const deleted = await handleDeleteOrder(
                    orderHeader?.orderNumber,
                    "approved",
                    false,
                  );
                  if (!deleted) return;

                  await handleCreateDraftFromCanceledApproval();
                } catch (error) {
                  console.error(
                    "Error canceling approval and creating draft:",
                    error,
                  );
                  NotificationExtension.Fails(
                    "Có lỗi xảy ra khi hủy duyệt và tạo đơn nháp!",
                  );
                } finally {
                  closeLoading();
                  modals.closeAll();
                }
              }}
            >
              Có
            </Button>
          </Flex>
        </Box>
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleCopyItemCodes = () => {
    const itemCodes = listAdd.map((item) => item.itemCode).join("\n"); // Ghép itemCode thành chuỗi
    navigator.clipboard
      .writeText(itemCodes)
      .then(() => {
        NotificationExtension.Success("Đã sao chép mã đơn hàng!");
      })
      .catch((err) => console.error("Lỗi sao chép:", err));
  };

  const handleClickCancelSalesOrder = () => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xác nhận hủy đơn hàng !</Title>
        </>
      ),

      size: "xs",
      children: (
        <Flex justify={"end"} gap={20} mt={"sm"}>
          <Button
            color="gray"
            leftSection={<IconWindow size={18} />}
            onClick={() => {
              modals.closeAll();
            }}
          >
            Huỷ
          </Button>
          <Button
            leftSection={<IconCheck size={18} />}
            onClick={() => {
              handleDeleteOrder(orderHeader?.orderNumber, "cancel");
              navigate("/sell/sales-order-list");
              modals.closeAll();
            }}
          >
            Xác nhận
          </Button>
        </Flex>
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  // Kiểm tra địa chỉ khách hàng đã đầy đủ chưa (địa chỉ, tỉnh/thành, phường/xã)
  // Nếu thiếu thì bật modal sửa khách hàng và dừng thao tác lưu/hoàn thành/chốt đơn
  const checkCustomerAddress = () => {
    if (
      (!customerCheck?.address ||
        !customerCheck?.attribute13 ||
        !customerCheck?.attribute14) &&
      orderStatus === "noCreate"
    ) {
      modals.openConfirmModal({
        title: <Title order={5}>Sửa khách hàng!</Title>,
        size: "auto",
        children: (
          <CustomerEditDataView
            id={customerCheck?.id}
            onClose={() => {}}
            isCreateBySeller={false}
            setCustomerCheck={setCustomerCheck}
          />
        ),
        confirmProps: { display: "none" },
        cancelProps: { display: "none" },
      });
      return false;
    }
    return true;
  };

  /** Chốt đơn: mọi gói BHMR phải phân bổ đủ suất (laptop trong đơn + serial máy cũ = số lượng gói) */
  const checkWarrantyFullyAllocated = () => {
    const underAllocated = getUnderAllocatedWarranties(listAdd);
    if (underAllocated.length === 0) return true;
    NotificationExtension.Warn(
      `Gói bảo hành chưa phân bổ đủ suất: ${underAllocated
        .map((item) => `${item.code} (${item.allocated}/${item.quantity})`)
        .join(", ")}. Vui lòng phân bổ đủ trước khi chốt đơn!`,
    );
    return false;
  };

  const handleCreateSalesOrderOld = useDebouncedCallback(
    async (isLock: boolean) => {
      if (
        !handleCheckIsSuccessValidateItem(listAdd) &&
        location?.state?.actionType === "doi"
      ) {
        NotificationExtension.Warn(
          "Vui lòng điền trường hợp đổi , Serial đổi !",
        );
        return;
      }
      const isShippingRequired = shipping !== "Nhận tại cửa hàng";

      if (isShippingRequired) {
        const requiredFields = {
          customerId: dataDeliveryInformation?.customerId,
          telephoneNumber: dataDeliveryInformation?.telephoneNumber,
          customerProvinceId: dataDeliveryInformation?.customerProvinceId,
          customerCommuneId: dataDeliveryInformation?.customerCommuneId,
          customerAddress: dataDeliveryInformation?.customerAddress,
          deliveryAppointmentTime:
            dataDeliveryInformation?.deliveryAppointmentTime,
          shippingVendor: dataDeliveryInformation?.shippingVendor,
          typeShip: dataDeliveryInformation?.typeShip,
        };

        const missingFields = Object.entries(requiredFields)
          .filter(([_, value]) => !value)
          .map(([key]) => key);

        if (missingFields.length > 0) {
          console.log("❌ Missing delivery fields:", missingFields);
          console.log("📦 dataDeliveryInformation:", dataDeliveryInformation);
          NotificationExtension.Warn(
            `Vui lòng điền đầy đủ thông tin giao hàng! Thiếu: ${missingFields.join(
              ", ",
            )}`,
          );
          return;
        }
      }

      if (!orderHeader?.custId && !orderHeaderRef?.custId) {
        NotificationExtension.Warn("Chưa có thông tin khách hàng!");
        return;
      }

      if (
        (orderHeader?.amountDiscountTotal ?? 0) > 0 &&
        !orderHeader?.attribute39 &&
        (!orderHeader?.attribute97 || !orderHeader.attribute97.trim())
      ) {
        NotificationExtension.Warn(
          "Vui lòng nhập diễn giải khuyến mãi tổng đơn!",
        );
        setPromoDescOpened(true);
        return;
      }

      let newListAdd: dataOrderDetailTable[];
      if (location?.state?.actionType === "doi") {
        newListAdd = listAdd
          .map((item) => {
            return {
              ...item,
              discountAdded: 0, // Đảm bảo xin giảm = 0
              totalLineAmount: item.priceFinal * item.quality,
            };
          })
          .filter((i) => {
            return (
              i?.attribute11 !== "G" &&
              i?.attribute11 !== "H" &&
              i?.attribute11 !== "T"
            );
          });
      } else {
        newListAdd = listAdd.map((item) => {
          return {
            ...item,
            discountAdded: 0, // Đảm bảo xin giảm = 0
            totalLineAmount: item.priceFinal * item.quality,
            deptId: orderHeader?.deptId,
          };
        });
      }

      openLoading();

      const response = await repositoryPos.post<
        MessageResponse<dataCreateSalesOrder>
      >("/api/v1/CreateSellItem/create", {
        orderDetail: toStoredWarranty(newListAdd),
        orderHeader: {
          ...orderHeader,
          shipngType: shipping,
          shipingVendor: shipingVendor,
          invOrgId: branchId ? branchId : 488,
          orgId: branchId ? branchId : 488,
          saleChanelId: saleChanelId ? saleChanelId : 67,
          saleId: employeeSalesId,
          deptId: departmentId,
          printInvoiceCheck: orderHeader?.printInvoiceCheck,
          attribute2: accountantId,
          attribute18: employeeSalesRevenueId,
          contractcode: contractcode,
          orderTypeId: 2,
          branchId: branchId ? branchId : 488,
          amountTotal: payableAmount,
          amountDiscount: totalKMLine,
          amountVat: 0,
          attribute1: JSON.stringify({
            ...dataDeliveryInformation,
            branchId: branchId,
          }),
          createDate: orderHeader?.orderDate,
          orderNumberLink: location?.state?.orderNumberOld,
          attribute8:
            customerCheck?.name && customerCheck?.code
              ? `${customerCheck.name}||${customerCheck.code}`
              : "",
          attribute16: orderHeader?.attribute16
            ? orderHeader?.attribute16
            : customerCheck?.attribute1,
          attribute31: customerCheck?.attribute4,
          attribute53: vatEmailList || "",
          custId: orderHeader?.custId ? orderHeader?.custId : customerCheck?.id,
        },
        isRetun: location?.state?.actionType === "doi",
        isLock: isLock,
      });

      if (response && response.success) {
        setOrderStatus(isLock ? "DON_HANG_CHOT" : "DON_HANG_TAM");

        setTimeout(
          () =>
            NotificationExtension.Success(
              isLock
                ? "Chốt đơn hàng thành công !"
                : "Lưu đơn hàng thành công !",
            ),
          500,
        );

        SocketExtension.SendMessageToTopic<any>({
          topic: CREATEORDERSUCCESS,
          data: "",
        });

        if (isLock) {
          await handleSendMessageOrderSuccsess();
        }
      } else {
        NotificationExtension.Fails(
          response?.message ||
            (isLock ? "Chốt đơn hàng thất bại !" : "Lưu đơn hàng thất bại !"),
        );
      }
      closeLoading();
    },
    1000,
  );

  const handleCreateSalesOrder = useDebouncedCallback(
    async (isLock: boolean) => {
      // Gói BHMR phải phân bổ đủ suất trước khi chốt đơn
      if (isLock && !checkWarrantyFullyAllocated()) {
        return;
      }

      // Kiểm tra địa chỉ khách hàng đã đầy đủ chưa
      if (!checkCustomerAddress()) {
        return;
      }

      // Validate số điện thoại khách hàng và người MH
      if (!customerCheck?.telephoneNumber && !orderHeader?.attribute36) {
        NotificationExtension.Warn(
          "Vui lòng chọn lại số điện thoại khách hàng!",
        );
        return;
      }

      // Validate thông tin xuất hóa đơn VAT chỉ khi Có xuất VAT (printInvoiceCheck === 1)
      if (orderHeader?.printInvoiceCheck === 1) {
        if (
          !taxInfo.TaxCode ||
          !taxInfo.TaxCompany ||
          !taxInfo.TaxEmail ||
          !taxInfo.TaxAddress
        ) {
          NotificationExtension.Warn(
            "Vui lòng nhập đầy đủ thông tin xuất hóa đơn VAT: Mã số thuế, Tên công ty, Email nhận hóa đơn và Địa chỉ công ty",
          );
          return;
        }

        if (emailError) {
          NotificationExtension.Warn(
            "Email nhận hóa đơn không đúng định dạng. Vui lòng kiểm tra lại!",
          );
          return;
        }
      }

      // Hiển thị loading ngay từ đầu
      openLoading();

      try {
        // Console log thông tin voucher khi chốt đơn
        console.log("=== CONSOLE LOG VOUCHER INFO WHEN CHỐT ĐƠN ===");
        let hasVoucherError = false;

        listAdd.forEach((item, index) => {
          if (item.voucherInfo?.tblPromotionItemPrimary?.[0]) {
            const voucherData = item.voucherInfo.tblPromotionItemPrimary[0];
            const currentQuantity = item.quality || 0;
            const minQuantity = voucherData.min || 0;
            const maxQuantity = voucherData.max || 0;

            console.log(`Sản phẩm ${index + 1} - Voucher:`, {
              itemCode: item.itemCode,
              itemName: item.itemName,
              currentQuantity: currentQuantity,
              voucherInfo: {
                code: item.voucherInfo?.tblPromotion?.code || "N/A",
                note: item.voucherInfo?.tblPromotion?.note || "N/A",
                min: minQuantity,
                max: maxQuantity,
                maxDisplay: maxQuantity === 0 ? "Không giới hạn" : maxQuantity,
                discountPercent: voucherData.discountPercent || 0,
                discountAmount: voucherData.discountAmount || 0,
              },
            });

            // Kiểm tra số lượng sản phẩm với min/max của voucher
            // Logic: Voucher có min/max là số lượng cho 1 lần áp dụng
            // Ví dụ: min=1, max=2 nghĩa là mỗi lần mua từ 1-2 sản phẩm được áp dụng voucher
            // Nếu mua 2 sản phẩm (và min=1, max=2) thì được áp dụng 2 lần voucher
            // Chỉ kiểm tra nếu số lượng tối thiểu chưa đạt

            if (minQuantity > 0 && currentQuantity < minQuantity) {
              hasVoucherError = true;
              NotificationExtension.Fails(
                `Sản phẩm "${item.itemName}" (${item.itemCode}) có số lượng ${currentQuantity} nhỏ hơn số lượng tối thiểu ${minQuantity} của voucher "${item.voucherInfo?.tblPromotion?.code}"`,
              );
            }

            // Không giới hạn số lượng tối đa vì voucher có thể áp dụng nhiều lần
            // Ví dụ: mua 1 tặng 1, mua 2 tặng 2, mua 3 tặng 3...
          }
        });
        console.log("=== END VOUCHER INFO ===");

        // Nếu có lỗi voucher thì dừng lại
        if (hasVoucherError) {
          closeLoading();
          return;
        }

        // Nếu đã gửi duyệt thì không cho phép thao tác
        if (isSentForApproval) {
          NotificationExtension.Warn(
            "Đơn hàng đã gửi duyệt, không thể thực hiện thao tác này!",
          );
          closeLoading();
          return;
        }

        // Kiểm tra attribute69 để quyết định logic
        if (orderHeader?.attribute69 !== "1") {
          // Gọi hàm logic cũ
          closeLoading(); // Tắt loading trước khi gọi hàm cũ vì hàm cũ có loading riêng
          await handleCreateSalesOrderOld(isLock);
          return;
        }

        // Logic mới - có xin giảm (attribute69 === "1")
        // Lấy discount data mới nhất trực tiếp từ API
        let currentMaxDiscounts: { [itemCode: string]: number } = {};
        let currentDiscountSuggestionData: any = null;

        // Fetch discount data để lấy customerGroup cho attribute70
        // Fetch khi có "xin giảm" hoặc khi cần lấy customerGroup
        if (orderHeader?.attribute69 === "1" || customerCheck?.code) {
          const freshDiscountData = await fetchDiscountDataIfNeeded();
          currentDiscountSuggestionData = freshDiscountData;

          // Extract maxDiscounts từ data vừa fetch để tránh stale closure
          if (freshDiscountData?.itemPrices) {
            freshDiscountData.itemPrices.forEach((item: any) => {
              currentMaxDiscounts[item.itemCode] = item.maxDiscountPrice || 0;
            });
          }
        } else {
          // Nếu không fetch mới thì dùng state hiện tại (có thể bị stale)
          currentMaxDiscounts = itemMaxDiscounts;
          currentDiscountSuggestionData = discountSuggestionData;
        }

        if (
          !handleCheckIsSuccessValidateItem(listAdd) &&
          location?.state?.actionType === "doi"
        ) {
          NotificationExtension.Warn(
            "Vui lòng điền trường hợp đổi , Serial đổi !",
          );
          return;
        }
        const isShippingRequired = shipping !== "Nhận tại cửa hàng";
        const isMissingDeliveryInfo = [
          dataDeliveryInformation?.customerId,
          dataDeliveryInformation?.telephoneNumber,
          dataDeliveryInformation?.customerProvinceId,
          dataDeliveryInformation?.customerCommuneId,
          dataDeliveryInformation?.customerAddress,
          dataDeliveryInformation?.deliveryAppointmentTime,
          dataDeliveryInformation?.shippingVendor,
          dataDeliveryInformation?.typeShip,
        ].some(
          (field) => field === null || field === undefined || field === "",
        );

        if (isShippingRequired && isMissingDeliveryInfo) {
          NotificationExtension.Warn(
            "Vui lòng điền đầy đủ thông tin giao hàng!",
          );
          return;
        }

        if (!orderHeader?.custId && !orderHeaderRef?.custId) {
          NotificationExtension.Warn("Chưa có thông tin khách hàng!");
          return;
        }

        if (
          (orderHeader?.amountDiscountTotal ?? 0) > 0 &&
          !orderHeader?.attribute39 &&
          (!orderHeader?.attribute97 || !orderHeader.attribute97.trim())
        ) {
          NotificationExtension.Warn(
            "Vui lòng nhập diễn giải khuyến mãi tổng đơn!",
          );
          setPromoDescOpened(true);
          return;
        }

        let newListAdd: dataOrderDetailTable[];
        if (location?.state?.actionType === "doi") {
          newListAdd = listAdd
            .map((item) => {
              return {
                ...item,
                totalLineAmount: item.priceFinal * item.quality,
              };
            })
            .filter((i) => {
              return (
                i?.attribute11 !== "G" &&
                i?.attribute11 !== "H" &&
                i?.attribute11 !== "T"
              );
            });
        } else {
          newListAdd = listAdd.map((item) => {
            // Bỏ qua việc tính lại giá cho hàng tặng (gift items)
            if (item.lineTyle === "KM") {
              return {
                ...item,
                deptId: orderHeader?.deptId,
              };
            }

            // Tính thành tiền hiện tại của sản phẩm
            const currentTotalAmount = item.priceFinal * item.quality;

            // Lấy mức giảm tối đa từ currentMaxDiscounts (fresh data)
            const maxDiscount = currentMaxDiscounts[item.itemCode] || 0;

            // Giữ nguyên discountAdded hiện tại, không bị reset về 0
            let updatedDiscountAdded = item.discountAdded || 0; // Đảm bảo không undefined

            // Chỉ map maxDiscount vào discountAdded nếu isLock = true và maxDiscount > 0
            // VÀ thành tiền hiện tại > 0 (không áp dụng cho sản phẩm có thành tiền = 0)
            if (isLock && maxDiscount > 0 && currentTotalAmount > 0) {
              updatedDiscountAdded = maxDiscount;
            } else if (isLock && maxDiscount === 0) {
              // Khi isLock = true nhưng maxDiscount = 0, vẫn giữ discountAdded hiện tại
            } else {
              // Khi isLock = false (nút Lưu), giữ nguyên discountAdded hiện tại
            } // Kiểm tra nếu discount vượt quá mức cho phép
            if (
              updatedDiscountAdded &&
              updatedDiscountAdded > maxDiscount &&
              maxDiscount > 0
            ) {
              // Có thể thêm logic xử lý ở đây như hiển thị warning hoặc điều chỉnh giá
            }

            // Tính lại priceFinal với discountAdded mới
            const newPriceFinal =
              item.priceOnPriceList -
              (item.discountAmount || 0) -
              (updatedDiscountAdded || 0);

            return {
              ...item,
              discountAdded: updatedDiscountAdded,
              priceFinal: Math.max(newPriceFinal, 0), // Đảm bảo không âm
              totalLineAmount: Math.max(newPriceFinal * item.quality, 0),
              deptId: orderHeader?.deptId,
              // Có thể thêm thông tin max discount vào item nếu cần
              maxDiscountPrice: maxDiscount,
            };
          });
        }

        // Tính tổng giảm giá "xin giảm" từ currentMaxDiscounts (nhân với số lượng)
        // Chỉ tính cho những sản phẩm có thành tiền > 0
        const totalDiscountFromFreshData = listAdd.reduce((total, item) => {
          const currentTotalAmount = item.priceFinal * item.quality;
          // Chỉ cộng discount nếu thành tiền > 0
          if (currentTotalAmount > 0) {
            const itemDiscount = currentMaxDiscounts[item.itemCode] || 0;
            return total + itemDiscount * item.quality;
          }
          return total;
        }, 0);

        // Tính amountTotal đúng = payableAmount - tổng giảm giá "xin giảm"
        const correctAmountTotal = payableAmount - totalDiscountFromFreshData;

        // Sử dụng lại kết quả từ currentDiscountSuggestionData để map vào attribute83
        // Không cần gọi API lần nữa vì đã gọi ở trên trong fetchDiscountDataIfNeeded
        if (
          currentDiscountSuggestionData &&
          typeof currentDiscountSuggestionData.customerGroup !== "undefined"
        ) {
          (orderHeader as any).attribute83 = String(
            currentDiscountSuggestionData.customerGroup,
          );
        }

        openLoading();
        const response = await repositoryPos.post<
          MessageResponse<dataCreateSalesOrder>
        >("/api/v1/CreateSellItem/create", {
          orderDetail: toStoredWarranty(newListAdd),
          orderHeader: {
            ...orderHeader,
            shipngType: shipping,
            shipingVendor: shipingVendor,
            invOrgId: branchId ? branchId : 488,
            orgId: branchId ? branchId : 488,
            saleChanelId: saleChanelId ? saleChanelId : 67,
            saleId: employeeSalesId,
            deptId: departmentId,
            printInvoiceCheck: orderHeader?.printInvoiceCheck,
            attribute2: accountantId,
            attribute18: employeeSalesRevenueId,
            contractcode: contractcode,
            orderTypeId: 2,
            branchId: branchId ? branchId : 488,
            amountTotal: correctAmountTotal,
            amountDiscount: totalKMLine,
            amountVat: 0,
            attribute1: JSON.stringify({
              ...dataDeliveryInformation,
              branchId: branchId,
            }),
            createDate: orderHeader?.orderDate,
            orderNumberLink: location?.state?.orderNumberOld,
            attribute8:
              customerCheck?.name && customerCheck?.code
                ? `${customerCheck.name}||${customerCheck.code}`
                : "",
            attribute16: orderHeader?.attribute16
              ? orderHeader?.attribute16
              : customerCheck?.attribute1,
            attribute31: customerCheck?.attribute4,
            attribute53: vatEmailList || "",
            custId: orderHeader?.custId
              ? orderHeader?.custId
              : customerCheck?.id,
            attribute70: currentDiscountSuggestionData?.customerGroup ?? null,
            discountAdd: totalDiscountFromFreshData,
          },
          isRetun: location?.state?.actionType === "doi",
          isLock: isLock,
        });

        if (response && response.success) {
          setOrderStatus(isLock ? "DON_HANG_CHOT" : "DON_HANG_TAM");

          // Cập nhật lại listAdd với discountAdded mới từ newListAdd để UI hiển thị đúng
          setListAdd(newListAdd);

          setTimeout(
            () =>
              NotificationExtension.Success(
                isLock
                  ? "Chốt đơn hàng thành công !"
                  : "Lưu đơn hàng thành công !",
              ),
            500,
          );

          SocketExtension.SendMessageToTopic<any>({
            topic: CREATEORDERSUCCESS,
            data: "",
          });

          if (isLock) {
            await handleSendMessageOrderSuccsess();
          }
        } else {
          NotificationExtension.Fails(
            response?.message ||
              (isLock ? "Chốt đơn hàng thất bại !" : "Lưu đơn hàng thất bại !"),
          );
        }
      } catch (error) {
        console.error("Error creating sales order:", error);
        NotificationExtension.Fails("Có lỗi xảy ra khi tạo đơn hàng!");
      } finally {
        closeLoading();
      }
    },
    1000,
  );

  const handleExportExcel = () => {
    try {
      // map lại key để đổi tên cột
      const exportData = listAdd.map((item) => ({
        "Tên sản phẩm": item.itemName,
        "Mã sản phẩm": item.itemCode,
        "Mã kho": item.attribute23,
        "Đơn vị tính": item.primaryUomCode,
        "Số lượng": item.quality,
        "Giá bán lẻ": item.priceOnPriceList,
        "Khuyến mãi": item.discountAmount,
        "Xin giảm": item?.discountAdded,
        "Thành tiền": item.priceFinal * item.quality,
        "Bảo hành": item.attribute20,
        "Km phân bổ": item.attribute28,
        "Xin giảm phân bổ": item.attribute29,
        "Thành tiền sau bổ": item.attribute35,
        "Ghi chú": item.note,
        // thêm các cột khác nếu cần
      }));

      const worksheet = xlsx.utils.json_to_sheet(exportData);
      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, "Data");
      xlsx.writeFile(workbook, "danh-sach-san-pham.xlsx");
      toast.success("Export excel thành công", { autoClose: 1500 });
    } catch (error) {
      toast.error("Export excel thất bại", { autoClose: 1500 });
    }
  };

  const handleEditSalesOrderOld = useDebouncedCallback(
    async (isLock: boolean) => {
      const isShippingRequired = shipping !== "Nhận tại cửa hàng";
      const isMissingDeliveryInfo = [
        dataDeliveryInformation?.customerId,
        dataDeliveryInformation?.telephoneNumber,
        dataDeliveryInformation?.customerProvinceId,
        dataDeliveryInformation?.customerCommuneId,
        dataDeliveryInformation?.customerAddress,
        dataDeliveryInformation?.deliveryAppointmentTime,
        dataDeliveryInformation?.shippingVendor,
        dataDeliveryInformation?.typeShip,
      ].some((field) => field === null || field === undefined || field === "");

      if (isShippingRequired && isMissingDeliveryInfo) {
        NotificationExtension.Warn("Vui lòng điền đầy đủ thông tin giao hàng!");
        return;
      }

      if (!orderHeader.custId) {
        NotificationExtension.Warn("Chưa có thông tin khách hàng!");
        return;
      }

      const newListAdd = listAdd.map((item) => {
        return {
          ...item,
          totalLineAmount: item.priceFinal * item.quality,
          deptId: orderHeader?.deptId,
        };
      });
      openLoading();
      console.log("orderHeader", orderHeader);
      const response = await repositoryPos.post<
        MessageResponse<dataCreateSalesOrder>
      >("/api/v1/CreateSellItem/edit", {
        orderDetail: toStoredWarranty(newListAdd),
        orderHeader: {
          ...orderHeader,
          shipngType: shipping,
          shipingVendor: shipingVendor,
          invOrgId: branchId ? branchId : 488,
          orgId: branchId ? branchId : 488,
          saleChanelId: saleChanelId
            ? saleChanelId
            : orderHeader?.saleChanelId
              ? orderHeader?.saleChanelId
              : 67,
          saleId: employeeSalesId,
          deptId: departmentId,
          printInvoiceCheck: orderHeader?.printInvoiceCheck,
          attribute2: accountantId, //Nguyễn Trang Quyên-0009
          attribute18: employeeSalesRevenueId,
          contractcode: contractcode,
          orderTypeId: 2,
          branchId: branchId ? branchId : 488,
          amountTotal: payableAmount,
          amountDiscount: totalKMLine,
          amountVat: 0,
          attribute1: JSON.stringify({
            ...dataDeliveryInformation,
            branchId: branchId,
          }),
          createDate: orderHeader?.orderDate,
          orderNumberLink: location?.state?.orderNumberOld,
          attribute8:
            customerCheck?.name && customerCheck?.code
              ? `${customerCheck.name}||${customerCheck.code}`
              : "",
          attribute16: orderHeader?.attribute16
            ? orderHeader?.attribute16
            : customerCheck?.attribute1,
          attribute31: customerCheck?.attribute4,
          attribute53: vatEmailList || "",
        },
        isLock: isLock,
      });

      if (response && response.success) {
        setOrderStatus(isLock ? "DON_HANG_CHOT" : "DON_HANG_TAM");

        const messageNoti = isLock
          ? "Chốt đơn hàng thành công !"
          : "Lưu đơn hàng thành công !";
        setTimeout(() => NotificationExtension.Success(messageNoti), 500);

        SocketExtension.SendMessageToTopic<any>({
          topic: CREATEORDERSUCCESS,
          data: "",
        });

        if (isLock) {
          await handleSendMessageOrderSuccsess();
        }
        closeLoading();
        return true;
      } else {
        setTimeout(
          () =>
            NotificationExtension.Fails(
              response?.message ||
                (isLock ? "Chốt đơn hàng thất bại !" : "Lưu đơn hàng thất bại !"),
            ),
          500,
        );
        closeLoading();
        return false;
      }
    },
    1000,
  );

  const handleEditSalesOrder = useDebouncedCallback(async (isLock: boolean) => {
    // Gói BHMR phải phân bổ đủ suất trước khi chốt đơn
    if (isLock && !checkWarrantyFullyAllocated()) {
      return;
    }

    // Kiểm tra địa chỉ khách hàng đã đầy đủ chưa
    if (!checkCustomerAddress()) {
      return;
    }

    // Validate số điện thoại khách hàng và người MH
    if (!customerCheck?.telephoneNumber && !orderHeader?.attribute36) {
      NotificationExtension.Warn("Vui lòng chọn lại số điện thoại khách hàng!");
      return;
    }

    // Validate thông tin xuất hóa đơn VAT khi Có xuất VAT hoặc Nợ VAT
    if (orderHeader?.printInvoiceCheck === 1) {
      if (
        !taxInfo.TaxCode ||
        !taxInfo.TaxCompany ||
        !taxInfo.TaxEmail ||
        !taxInfo.TaxAddress
      ) {
        NotificationExtension.Warn(
          "Vui lòng nhập đầy đủ thông tin xuất hóa đơn VAT: Mã số thuế, Tên công ty, Email nhận hóa đơn và Địa chỉ công ty",
        );
        return;
      }

      if (emailError) {
        NotificationExtension.Warn(
          "Email nhận hóa đơn không đúng định dạng. Vui lòng kiểm tra lại!",
        );
        return;
      }
    }

    // Hiển thị loading ngay từ đầu
    openLoading();

    try {
      // Console log thông tin voucher khi chốt đơn (Edit mode)
      console.log("=== CONSOLE LOG VOUCHER INFO WHEN CHỐT ĐƠN (EDIT) ===");
      let hasVoucherError = false;

      listAdd.forEach((item, index) => {
        if (item.voucherInfo?.tblPromotionItemPrimary?.[0]) {
          const voucherData = item.voucherInfo.tblPromotionItemPrimary[0];
          const currentQuantity = item.quality || 0;
          const minQuantity = voucherData.min || 0;
          const maxQuantity = voucherData.max || 0;

          console.log(`Sản phẩm ${index + 1} - Voucher:`, {
            itemCode: item.itemCode,
            itemName: item.itemName,
            currentQuantity: currentQuantity,
            voucherInfo: {
              code: item.voucherInfo?.tblPromotion?.code || "N/A",
              note: item.voucherInfo?.tblPromotion?.note || "N/A",
              min: minQuantity,
              max: maxQuantity,
              maxDisplay: maxQuantity === 0 ? "Không giới hạn" : maxQuantity,
              discountPercent: voucherData.discountPercent || 0,
              discountAmount: voucherData.discountAmount || 0,
            },
          });

          // Chỉ kiểm tra số lượng tối thiểu
          // Không giới hạn số lượng tối đa vì voucher có thể áp dụng nhiều lần (mua 2 tặng 2, mua 3 tặng 3, v.v.)
          if (currentQuantity < minQuantity) {
            hasVoucherError = true;
            NotificationExtension.Fails(
              `Sản phẩm "${item.itemName}" (${item.itemCode}) có số lượng ${currentQuantity} nhỏ hơn số lượng tối thiểu ${minQuantity} của voucher "${item.voucherInfo?.tblPromotion?.code}"`,
            );
          }
        }
      });
      console.log("=== END VOUCHER INFO (EDIT) ===");

      // Nếu có lỗi voucher thì dừng lại
      if (hasVoucherError) {
        closeLoading();
        return;
      }

      // Nếu đã gửi duyệt thì không cho phép thao tác
      if (isSentForApproval) {
        NotificationExtension.Warn(
          "Đơn hàng đã gửi duyệt, không thể thực hiện thao tác này!",
        );
        closeLoading();
        return;
      }

      // Kiểm tra attribute69 để quyết định logic
      if (orderHeader?.attribute69 !== "1") {
        // Gọi hàm logic cũ
        closeLoading(); // Tắt loading trước khi gọi hàm cũ vì hàm cũ có loading riêng
        await handleEditSalesOrderOld(isLock);
        return;
      }
      // Lấy discount data mới nhất trực tiếp từ API
      let currentMaxDiscounts: { [itemCode: string]: number } = {};
      let currentDiscountSuggestionData: any = null;

      // Fetch discount data để lấy customerGroup cho attribute70
      // Fetch khi có "xin giảm" hoặc khi cần lấy customerGroup
      if (orderHeader?.attribute69 === "1" || customerCheck?.code) {
        const freshDiscountData = await fetchDiscountDataIfNeeded();
        currentDiscountSuggestionData = freshDiscountData;

        // Extract maxDiscounts từ fresh data với key là itemCode
        if (freshDiscountData?.itemPrices) {
          freshDiscountData.itemPrices.forEach((item: any) => {
            currentMaxDiscounts[item.itemCode] = item.maxDiscountPrice || 0;
          });
        }
      } else {
        // Nếu không fetch mới thì dùng state hiện tại (có thể bị stale)
        currentMaxDiscounts = itemMaxDiscounts;
        currentDiscountSuggestionData = discountSuggestionData;
      }

      const isShippingRequired = shipping !== "Nhận tại cửa hàng";
      const isMissingDeliveryInfo = [
        dataDeliveryInformation?.customerId,
        dataDeliveryInformation?.telephoneNumber,
        dataDeliveryInformation?.customerProvinceId,
        dataDeliveryInformation?.customerCommuneId,
        dataDeliveryInformation?.customerAddress,
        dataDeliveryInformation?.deliveryAppointmentTime,
        dataDeliveryInformation?.shippingVendor,
        dataDeliveryInformation?.typeShip,
      ].some((field) => field === null || field === undefined || field === "");

      if (isShippingRequired && isMissingDeliveryInfo) {
        NotificationExtension.Warn("Vui lòng điền đầy đủ thông tin giao hàng!");
        return;
      }

      if (!orderHeader.custId) {
        NotificationExtension.Warn("Chưa có thông tin khách hàng!");
        return;
      }

      const newListAdd = listAdd.map((item) => {
        // Lấy mức giảm tối đa cho sản phẩm này
        const maxDiscount = getMaxDiscountForItem(item.itemCode);

        // Map maxDiscount vào discountAdded nếu isLock = true và maxDiscount > 0
        let updatedDiscountAdded = item.discountAdded;
        if (isLock && maxDiscount > 0) {
          updatedDiscountAdded = maxDiscount;
        }

        // Tính lại priceFinal với discountAdded mới
        const newPriceFinal =
          item.priceOnPriceList -
          (item.discountAmount || 0) -
          (updatedDiscountAdded || 0);

        return {
          ...item,
          discountAdded: updatedDiscountAdded,
          priceFinal: Math.max(newPriceFinal, 0), // Đảm bảo không âm
          totalLineAmount: Math.max(newPriceFinal * item.quality, 0),
          deptId: orderHeader?.deptId,
          maxDiscountPrice: maxDiscount,
        };
      });

      // Tính tổng giảm giá "xin giảm" từ currentMaxDiscounts (nhân với số lượng)
      const totalDiscountForEdit = listAdd.reduce((total, item) => {
        const itemDiscount = currentMaxDiscounts[item.itemCode] || 0;
        return total + itemDiscount * item.quality;
      }, 0);

      // Tính amountTotal đúng = payableAmount - tổng giảm giá "xin giảm"
      const correctAmountTotalForEdit = payableAmount - totalDiscountForEdit;

      // Sử dụng lại kết quả từ currentDiscountSuggestionData để map vào attribute83
      // Không cần gọi API lần nữa vì đã gọi ở trên trong fetchDiscountDataIfNeeded
      if (
        currentDiscountSuggestionData &&
        typeof currentDiscountSuggestionData.customerGroup !== "undefined"
      ) {
        (orderHeader as any).attribute83 = String(
          currentDiscountSuggestionData.customerGroup,
        );
      }

      openLoading();
      const response = await repositoryPos.post<
        MessageResponse<dataCreateSalesOrder>
      >("/api/v1/CreateSellItem/edit", {
        orderDetail: toStoredWarranty(newListAdd),
        orderHeader: {
          ...orderHeader,
          shipngType: shipping,
          shipingVendor: shipingVendor,
          invOrgId: branchId ? branchId : 488,
          orgId: branchId ? branchId : 488,
          saleChanelId: saleChanelId
            ? saleChanelId
            : orderHeader?.saleChanelId
              ? orderHeader?.saleChanelId
              : 67,
          saleId: employeeSalesId,
          deptId: departmentId,
          printInvoiceCheck: orderHeader?.printInvoiceCheck,
          attribute2: accountantId, //Nguyễn Trang Quyên-0009
          attribute18: employeeSalesRevenueId,
          contractcode: contractcode,
          orderTypeId: 2,
          branchId: branchId ? branchId : 488,
          amountTotal: correctAmountTotalForEdit,
          amountDiscount: totalKMLine,
          amountVat: 0,
          attribute1: JSON.stringify({
            ...dataDeliveryInformation,
            branchId: branchId,
          }),
          createDate: orderHeader?.orderDate,
          orderNumberLink: location?.state?.orderNumberOld,
          attribute8:
            customerCheck?.name && customerCheck?.code
              ? `${customerCheck.name}||${customerCheck.code}`
              : "",
          attribute16: orderHeader?.attribute16
            ? orderHeader?.attribute16
            : customerCheck?.attribute1,
          attribute31: customerCheck?.attribute4,
          attribute53: vatEmailList || "",
          attribute70: currentDiscountSuggestionData?.customerGroup ?? null,
          discountAdd: totalDiscountForEdit,
        },
        isLock: isLock,
      });

      if (response && response.success) {
        setOrderStatus(isLock ? "DON_HANG_CHOT" : "DON_HANG_TAM");

        const messageNoti = isLock
          ? "Chốt đơn hàng thành công !"
          : "Lưu đơn hàng thành công !";
        setTimeout(() => NotificationExtension.Success(messageNoti), 500);

        SocketExtension.SendMessageToTopic<any>({
          topic: CREATEORDERSUCCESS,
          data: "",
        });

        if (isLock) {
          await handleSendMessageOrderSuccsess();
        }
        return true;
      } else {
        NotificationExtension.Fails(
          response?.message ||
            (isLock ? "Chốt đơn hàng thất bại !" : "Lưu đơn hàng thất bại !"),
        );
        return false;
      }
    } catch (error) {
      console.error("Error editing sales order:", error);
      NotificationExtension.Fails("Có lỗi xảy ra khi cập nhật đơn hàng!");
      return false;
    } finally {
      closeLoading();
    }
  }, 1000);

  //#region render ui
  const TableSelect: React.FC<TableSelectProps> = ({
    dataProducts,
    onSelectProduct,
    rowIndex,
  }: any) => {
    return (
      <Table.ScrollContainer mih={400} mah={600} minWidth={500} type="native">
        <div style={{ overflowY: "auto", height: "500px" }}>
          <Table striped withTableBorder style={{ tableLayout: "fixed" }}>
            <Table.Thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "white",
                zIndex: 10,
              }}
            >
              <Table.Tr>
                <Table.Th>Chọn</Table.Th>
                <Table.Th style={{ width: "70px" }}>Mã sản phẩm</Table.Th>
                <Table.Th style={{ width: "200px" }}>
                  Tên sản phẩm
                </Table.Th>{" "}
                {/* Đặt độ rộng cho cột "Tên sản phẩm" */}
                <Table.Th>Giá</Table.Th>
                <Table.Th>ĐVT</Table.Th>
                <Table.Th>Tồn kho</Table.Th>
                <Table.Th>SL chờ xuất</Table.Th>
                <Table.Th>SL khả dụng</Table.Th>
                <Table.Th>Bảo hành</Table.Th>
                <Table.Th>Mã kho</Table.Th>
                <Table.Th>Kho</Table.Th>
              </Table.Tr>
            </Table.Thead>

            {dataProducts?.length > 0 ? (
              <Table.Tbody>
                {dataProducts?.map((product: any, index: any) => (
                  <Table.Tr key={index}>
                    <Table.Td>
                      <Button
                        size="compact-sm"
                        variant="filled"
                        onClick={() => {
                          onSelectProduct(product, rowIndex);
                          table.setCreatingRow(null);
                        }}
                        disabled={
                          handleCheckChooseProduct(product, listAdd) ||
                          product.tons - product.tonao <= 0
                        }
                      >
                        {handleCheckChooseProduct(product, listAdd)
                          ? "Đã chọn"
                          : "Chọn"}
                      </Button>
                    </Table.Td>
                    <Table.Td>{product.productCode}</Table.Td>
                    <Table.Td style={{ width: "200px" }}>
                      {product.productName}
                    </Table.Td>{" "}
                    {/* Đặt độ rộng cho ô "Tên sản phẩm" */}
                    <Table.Td>
                      <NumberFormatter
                        value={product.price}
                        thousandSeparator="."
                        decimalSeparator=","
                      />
                    </Table.Td>
                    <Table.Td>{product.unit}</Table.Td>
                    <Table.Td>{product.tons}</Table.Td>
                    <Table.Td>{product.tonao}</Table.Td>
                    <Table.Td>{product.tons - product.tonao}</Table.Td>
                    <Table.Td>{`${product.warranty}`}</Table.Td>
                    <Table.Td>{product.wareHouseCode}</Table.Td>
                    <Table.Td>{product.warehouse}</Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            ) : (
              <Box
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Text>Hãy nhập ID hoặc mã sản phẩm!</Text>
              </Box>
            )}
          </Table>
        </div>
      </Table.ScrollContainer>
    );
  };

  const TableSelectDV: React.FC<TableSelectProps> = ({
    dataProducts,
    onSelectProduct,
    rowIndex,
  }: any) => {
    return (
      <Table.ScrollContainer mih={400} mah={600} minWidth={500} type="native">
        <div style={{ overflowY: "auto", height: "500px" }}>
          {/* Table Header (Fixed) */}
          <Table striped withTableBorder style={{ tableLayout: "fixed" }}>
            <Table.Thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "white",
                zIndex: 10, // Đảm bảo tiêu đề luôn nằm trên cùng
              }}
            >
              <Table.Tr>
                <Table.Th>Chọn</Table.Th>
                <Table.Th>Mã sản phẩm</Table.Th>
                <Table.Th>Tên sản phẩm</Table.Th>
                <Table.Th>Giá</Table.Th>
                <Table.Th>ĐVT</Table.Th>
              </Table.Tr>
            </Table.Thead>
          </Table>

          {/* Table Body */}
          {dataProducts?.length > 0 ? (
            <Table striped withTableBorder>
              <Table.Tbody>
                {dataProducts?.map((product: any, index: any) => (
                  <Table.Tr key={index}>
                    <Table.Td>
                      <Button
                        size="xs"
                        variant="filled"
                        onClick={() => {
                          onSelectProduct(product, rowIndex);
                          table.setCreatingRow(null);
                        }}
                        disabled={handleCheckChooseProduct(product, listAdd)}
                      >
                        {handleCheckChooseProduct(product, listAdd)
                          ? "Đã chọn"
                          : "Chọn"}
                      </Button>
                    </Table.Td>
                    <Table.Td>{product.productCode}</Table.Td>
                    <Table.Td>{product.productName}</Table.Td>
                    <Table.Td>
                      <NumberFormatter
                        value={product.price}
                        thousandSeparator="."
                        decimalSeparator=","
                      />
                    </Table.Td>
                    <Table.Td>{product.unit}</Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            </Table>
          ) : (
            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Text>Hãy nhập ID hoặc mã sản phẩm!</Text>
            </Box>
          )}
        </div>
      </Table.ScrollContainer>
    );
  };

  const handleOnClickPrint = (id: any) => {
    setIsPrinting(true);
    setIdPrint(id);
  };

  const handleGetDetailDataVoucher = async (voucher: string) => {
    if (!voucher.trim()) {
      // Nếu voucher rỗng, đặt lại amountDiscountTotal = 0
      setOrderHeader({
        ...orderHeader,
        amountDiscountTotal: 0,
      });
      return;
    }

    try {
      // Lấy danh sách sản phẩm từ đơn hàng với thông tin itemCode và lineTyle
      const items = listAdd.map((item) => ({
        itemCode: item.itemCode,
        lineTyle: item.lineTyle || "HH", // Mặc định là "HH" nếu không có lineTyle
      }));

      // Lấy tất cả các idPromote từ listAdd, lọc ra những ID hợp lệ (> 0)
      const promotionIds = listAdd
        .map((item) => item.idPromote)
        .filter((id) => id && id > 0);

      const response = await repositoryPos.post<MessageResponse<any>>(
        `api/v1/TblVoucherDetail/check-conditions`,
        {
          voucherCode: voucher,
          customerPhone: customerCheck?.telephoneNumber || "",
          totalAmount:
            location?.state?.actionType === "view"
              ? orderHeader?.amountTotal
              : payableAmount - orderHeader?.amountPaid,
          branchId: branchId || 0,
          customerId: customerCheck?.id || 0,
          items: items,
          PromotionIds: promotionIds,
        },
      );

      if (response?.success) {
        // Tính số tiền giảm theo loại voucher
        const voucherType = response?.data?.voucherType;
        const vourcherValue = response?.data?.vourcherValue || 0;
        const maxDiscountAmount = response?.data?.maxDiscountAmount ?? Infinity;
        const orderTotal =
          location?.state?.actionType === "view"
            ? (orderHeader?.amountTotal ?? 0)
            : payableAmount - (orderHeader?.amountPaid ?? 0);

        let discountAmount = 0;
        if (voucherType === 2) {
          // Giảm theo % → vourcherValue là %, cap bởi maxDiscountAmount
          discountAmount = Math.min(
            Math.round((orderTotal * vourcherValue) / 100),
            maxDiscountAmount,
          );
        } else {
          // voucherType === 1: giảm tiền mặt trực tiếp
          discountAmount = vourcherValue;
        }

        setOrderHeader({
          ...orderHeader,
          amountDiscountTotal: discountAmount,
          amountVoucher: discountAmount,
        });

        // Thông báo thành công
        NotificationExtension.Success("Đã áp mã giảm giá thành công!");
      } else {
        // Reset về 0 nếu voucher không hợp lệ
        setOrderHeader({
          ...orderHeader,
          amountDiscountTotal: 0,
        });

        // Hiển thị thông báo lỗi từ API nếu có
        if (response?.message) {
          NotificationExtension.Fails(response.message);
        }
      }
    } catch (error) {
      console.error("Lỗi khi gọi API voucher:", error);
      // Reset về 0 nếu có lỗi
      setOrderHeader({
        ...orderHeader,
        amountDiscountTotal: 0,
      });
      NotificationExtension.Fails("Lỗi khi kiểm tra voucher");
    }
  };
  const titleSell = () => {
    return (
      <>
        <_breadcrumb></_breadcrumb>
        <Group align="center" p={"0 10 10 10"} justify="space-between">
          <Flex gap={"xs"}>
            <Button
              disabled={orderStatus === "noCreate"}
              color={"blue"}
              size="xs"
              style={{
                pointerEvents: "auto",
              }}
              onClick={() => {
                navigate("/sell/retail-order");
                window.location.reload();
              }}
            >
              Tạo mới
            </Button>
            <Tooltip
              label={isCollapse ? "Mở rộng" : "Thu gọn"}
              position="bottom"
            >
              <Group align="center">
                <Switch
                  size="sm"
                  color={isCollapse ? "red" : "green"}
                  checked={!isCollapse}
                  onChange={toggleCollapse}
                  label={isCollapse ? "Thu gọn (Ctrl+M)" : "Mở rộng (Ctrl+M)"}
                  thumbIcon={
                    !isCollapse ? (
                      <IconMaximize
                        style={{ width: 16, height: 16 }}
                        stroke={2.5}
                        color="white"
                      />
                    ) : (
                      <IconMaximizeOff
                        style={{ width: 16, height: 16 }}
                        stroke={2.5}
                        color="white"
                      />
                    )
                  }
                />
              </Group>
            </Tooltip>
          </Flex>
          <Flex
            gap="md"
            justify="flex-start"
            align="center"
            direction="row"
            wrap="wrap"
          >
            <OrderStatus status={orderStatus || "noCreate"}></OrderStatus>
          </Flex>

          <Flex
            gap="md"
            justify={{ sm: "flex-start", lg: "flex-end" }}
            wrap="wrap"
            align="center"
            direction="row"
          >
            {(orderStatus === "DON_HANG_HOAN_THANH" ||
              orderStatus === "DON_HANG_CHOT") && (
              <>
                <Button
                  leftSection={<IconPrinter size={14} />}
                  style={{
                    pointerEvents: "auto",
                  }}
                  onClick={() => openOptionPrintHandover()}
                >
                  In biên bản bàn giao
                </Button>
              </>
            )}
            {orderStatus === "DON_HANG_HOAN_THANH" &&
              orderHeader?.attribute3 === "DA_XUAT" && (
                <>
                  <Button
                    leftSection={<IconPrinter size={14} />}
                    style={{
                      pointerEvents: "auto",
                    }}
                    color="violet"
                    onClick={() =>
                      openPrintOutWardModal(orderHeader?.orderNumber)
                    }
                  >
                    In phiếu xuất kho
                  </Button>
                </>
              )}
            {orderStatus === "DON_HANG_HOAN_THANH" &&
            // !location?.state?.isReadOnly ? (
            true ? (
              <>
                <Button
                  leftSection={<IconPrinter size={20} />}
                  variant="outline"
                  color="indigo"
                  style={{
                    cursor: "pointer",
                    pointerEvents: "auto",
                  }}
                  size="xs"
                  onClick={() => handleOnClickPrint(location?.state?.id)}
                  loading={isPrinting}
                >
                  In hóa đơn
                </Button>
              </>
            ) : (
              <></>
            )}
            <Button
              disabled={
                location?.state?.actionType === "view" ||
                location?.state?.actionType === "approved" ||
                location?.state?.actionType === "payment" ||
                orderStatus === "DON_HANG_CHOT"
              }
              leftSection={<IconPlus size={14} />}
              variant="outline"
              color="blue"
              size="xs"
              onClick={() => {
                setModeSearch("SP");
                setDataProducts([]);
                table.setCreatingRow(true);
                setIsCreating(true);
              }}
            >
              Thêm sản phẩm
            </Button>
            <Button
              disabled={
                location?.state?.actionType === "view" ||
                location?.state?.actionType === "approved" ||
                location?.state?.actionType === "payment" ||
                orderStatus === "DON_HANG_CHOT"
              }
              leftSection={<IconPlus size={14} />}
              variant="outline"
              color="blue"
              size="xs"
              onClick={() => {
                setModeSearch("DV");
                setDataProducts([]);
                table.setCreatingRow(true);
                setIsCreating(true);
              }}
            >
              Thêm dịch vụ
            </Button>
            <Box
              style={{
                ...getStyle(),
              }}
            >
              <Menu shadow="md" width={200}>
                <Menu.Target>
                  <ActionIcon
                    style={{
                      pointerEvents: "auto",
                    }}
                    // disabled={
                    //   location?.state?.actionType === "view" ||
                    //   location?.state?.actionType === "approved" ||
                    //   location?.state?.actionType === "payment"
                    // }
                    size="md"
                    variant="outline"
                    color="blue"
                  >
                    <IconMenu2 style={{ width: rem(18), height: rem(18) }} />
                  </ActionIcon>
                </Menu.Target>
                <Menu.Dropdown>
                  <Menu.Label>Chức năng</Menu.Label>

                  <Menu.Item>
                    <Button
                      disabled={
                        orderStatus !== "DON_HANG_TAM" &&
                        orderStatus !== "DON_HANG_CHOT"
                      }
                      color={"red"}
                      size="xs"
                      onClick={() => handleClickCancelSalesOrder()}
                    >
                      Hủy đơn
                    </Button>
                  </Menu.Item>
                  <Menu.Item>
                    <Button
                      color={"blue"}
                      size="xs"
                      onClick={() => handleCopyItemCodes()}
                    >
                      copy mã hàng
                    </Button>
                  </Menu.Item>
                  <Menu.Item>
                    <Button
                      color={"green"}
                      size="xs"
                      onClick={() => handleExportExcel()}
                    >
                      Export excel
                    </Button>
                  </Menu.Item>
                  <Menu.Item>
                    <Button
                      color={"grape"}
                      size="xs"
                      onClick={() => chooseWareHouse()}
                      disabled={
                        !location.pathname.includes("revise-order") &&
                        !location.search.includes("revise-order")
                      }
                    >
                      Chọn kho sản phẩm
                    </Button>
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
            </Box>
          </Flex>
        </Group>
      </>
    );
  };
  const openOptionPrintHandover = () => {
    modals.openConfirmModal({
      title: "Nhập thông tin",
      closeOnConfirm: false,
      size: "550px",
      children: (
        <OptionPrintOrder
          setValuePrintOrderModal={setValuePrintOrderModal}
          setPrintOrderModalOpened={setPrintOrderModalOpened}
          customerCheck={customerCheck}
        />
      ),
      style: {
        height: "auto",
      },
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  function getStyle(includePayment = false): CSSProperties {
    const isDisabled =
      location?.state?.actionType === "view" ||
      location?.state?.actionType === "approved" ||
      orderStatus === "DON_HANG_HOAN_THANH" ||
      (includePayment && location?.state?.actionType === "payment") ||
      (orderStatus === "DON_HANG_CHOT" &&
        location?.state?.actionType !== "payment") ||
      (!includePayment && isHaveShiping); // Chỉ disable phần thông tin đơn hàng, không disable phần thanh toán

    return {
      opacity: isDisabled ? 0.9 : 1,
      pointerEvents: isDisabled ? "none" : "auto",
    };
  }

  const formOrderHeader = () => {
    return (
      <Box
        style={{
          padding: 5,
          height: "100%",
          position: "relative",
          ...getStyle(),
        }}
      >
        <Box
          style={{
            ...getStyle(true),
          }}
        >
          <Grid>
            <Grid.Col span={6}>
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>
                  Mã đơn hàng:<span style={{ color: "red" }}>*</span>
                </Text>
                <Text fw={500}>{orderHeader?.orderNumber}</Text>
              </Flex>
              {(location?.state?.orderNumberOld ||
                orderHeader?.orderNumberLink) && (
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 100px" }}>
                    Mã ĐH cũ:<span style={{ color: "red" }}>*</span>
                  </Text>
                  <Text fw={500}>
                    {orderHeader?.orderNumberLink
                      ? orderHeader?.orderNumberLink
                      : location?.state?.orderNumberOld}
                  </Text>
                </Flex>
              )}
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  required
                  label="Chi nhánh:"
                  value={branchName}
                  options={handleGetNameBranch(listBranch) || []}
                  onChange={(value: any) => {
                    setBranchName(value);
                    const BranchId = listBranch.find((item) => {
                      return item.text == value;
                    });
                    setBranchId(Number(BranchId?.value));
                    setListAdd([]);
                    setDataProducts([]);
                  }}
                  width="280px"
                />
              </Flex>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  readOnly
                  required
                  label="Bộ phận:"
                  value={department}
                  options={handleGetNameDepartment(listDepartment)}
                  onChange={(value) => {
                    setDepartment(value);
                    const departmentId = listDepartment?.find((item) => {
                      return item?.name === value;
                    });
                    setDepartmentId(departmentId?.departmentId);
                  }}
                  width="280px"
                />
              </Flex>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  readOnly
                  required
                  label="NV tạo đơn:"
                  value={employeeSalesName}
                  options={[]}
                  onChange={(value: any) => {
                    alert("");
                  }}
                  width="250px"
                />
              </Flex>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  required
                  label="NV hưởng số:"
                  value={employeeSalesRevenueName}
                  options={handleGetNameEmployeeAll(listEmployeeSales) || []}
                  onChange={(value: any) => {
                    setEmployeeSalesRevenueName(value);
                    const saleRevenueId = listEmployeeSales.find((item) => {
                      return `${item?.fullname} - ${item?.code}` === value;
                    });
                    setEmployeeSalesRevenueId(saleRevenueId?.id);
                  }}
                  width="250px"
                />
              </Flex>
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>Mã ĐTCN:</Text>
                <Box style={{ position: "relative", maxWidth: "200px" }}>
                  <Tooltip
                    label={
                      orderHeader?.attribute16 || customerCheck?.attribute1
                    }
                    disabled={
                      !orderHeader?.attribute16 && !customerCheck?.attribute1
                    }
                  >
                    <Text fw={500} truncate>
                      {orderHeader?.attribute16 ||
                        customerCheck?.attribute1 ||
                        "Tìm mã ĐTCN"}
                    </Text>
                  </Tooltip>
                  <IconSearch
                    size={20}
                    style={{
                      position: "absolute",
                      right: -30,
                      top: 0,
                      cursor: orderHeader?.attribute39
                        ? "not-allowed"
                        : "pointer",
                      color: orderHeader?.attribute39
                        ? "#ccc"
                        : cobalt_blue.base,
                      opacity: orderHeader?.attribute39 ? 0.5 : 1,
                    }}
                    onClick={() => {
                      if (!orderHeader?.attribute39) {
                        openFormCustomer(true);
                      } else {
                        NotificationExtension.Warn(
                          "Vui lòng xóa mã voucher trước khi thay đổi thông tin khách hàng!",
                        );
                      }
                    }}
                  />
                </Box>
              </Flex>
              <Box>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 100px" }}>
                    Khách hàng:<span style={{ color: "red" }}>*</span>
                  </Text>
                  <Box style={{ position: "relative", maxWidth: "200px" }}>
                    <Tooltip
                      label={customerCheck?.name}
                      disabled={!customerCheck?.name}
                    >
                      <Text fw={500} truncate>
                        {customerCheck?.type === 1
                          ? customerCheck?.name || "Tìm khách hàng"
                          : customerCheck?.companyName || "Tìm khách hàng"}
                      </Text>
                    </Tooltip>
                    <IconSearch
                      size={20}
                      style={{
                        position: "absolute",
                        right: -30,
                        top: 0,
                        cursor: orderHeader?.attribute39
                          ? "not-allowed"
                          : "pointer",
                        color: orderHeader?.attribute39
                          ? "#ccc"
                          : cobalt_blue.base,
                        opacity: orderHeader?.attribute39 ? 0.5 : 1,
                      }}
                      onClick={() => {
                        if (!orderHeader?.attribute39) {
                          openFormCustomer(false);
                        } else {
                          NotificationExtension.Warn(
                            "Vui lòng xóa mã voucher trước khi thay đổi thông tin khách hàng!",
                          );
                        }
                      }}
                    />
                  </Box>
                </Flex>

                {/* {orderHeader?.attribute61 &&
                  (() => {
                    try {
                      const buyerData = JSON.parse(orderHeader.attribute61);
                      const tooltipContent = [
                        buyerData.BuyerName && `Tên: ${buyerData.BuyerName}`,
                        buyerData.BuyerTelephone &&
                          `SĐT: ${buyerData.BuyerTelephone}`,
                        buyerData.BuyerEmail &&
                          `Email: ${buyerData.BuyerEmail}`,
                      ]
                        .filter(Boolean)
                        .join(" | ");
                      const allInfo = tooltipContent;
                      return (
                        <>
                          <Tooltip label={tooltipContent} multiline>
                            <Text
                              size="sm"
                              style={{
                                color: "#ffa500",
                                fontWeight: 500,
                                cursor: "pointer",
                                marginLeft: "100px",
                                display: "inline-block",
                              }}
                            >
                              ⚠️ Có người mua mới
                            </Text>
                          </Tooltip>
                          <Popover
                            opened={buyerPopoverOpened}
                            onChange={setBuyerPopoverOpened}
                            width={320}
                            position="bottom"
                            withArrow
                          >
                            <Popover.Target>
                              <Button
                                size="xs"
                                variant="light"
                                ml={8}
                                onClick={() => setBuyerPopoverOpened((o) => !o)}
                                style={{ verticalAlign: "middle" }}
                              >
                                Xem & Copy
                              </Button>
                            </Popover.Target>
                            <Popover.Dropdown>
                              <div style={{ marginBottom: 12 }}>
                                {buyerData.BuyerName && (
                                  <div style={{ marginBottom: 8 }}>
                                    <b>Tên:</b> {buyerData.BuyerName}
                                    <Button
                                      size="xs"
                                      ml={8}
                                      onClick={() =>
                                        handleCopyBuyer(buyerData.BuyerName)
                                      }
                                    >
                                      Copy
                                    </Button>
                                  </div>
                                )}
                                {buyerData.BuyerTelephone && (
                                  <div style={{ marginBottom: 8 }}>
                                    <b>SĐT:</b> {buyerData.BuyerTelephone}
                                    <Button
                                      size="xs"
                                      ml={8}
                                      onClick={() =>
                                        handleCopyBuyer(
                                          buyerData.BuyerTelephone
                                        )
                                      }
                                    >
                                      Copy
                                    </Button>
                                  </div>
                                )}
                                {buyerData.BuyerEmail && (
                                  <div style={{ marginBottom: 8 }}>
                                    <b>Email:</b> {buyerData.BuyerEmail}
                                    <Button
                                      size="xs"
                                      ml={8}
                                      onClick={() =>
                                        handleCopyBuyer(buyerData.BuyerEmail)
                                      }
                                    >
                                      Copy
                                    </Button>
                                  </div>
                                )}
                              </div>
                            </Popover.Dropdown>
                          </Popover>
                        </>
                      );
                    } catch (error) {
                      console.error("Error parsing attribute61:", error);
                      return null;
                    }
                  })()} */}
              </Box>
              {(listBuyerName?.length > 0 || orderHeader?.attribute36) && (
                <Flex align="center" gap="xs">
                  <EditableTextWithOptions
                    required
                    label="Người MH:"
                    value={orderHeader?.attribute36 || ""}
                    options={listBuyerName}
                    onChange={(value: any) => {
                      setOrderHeader((prev) => ({
                        ...prev,
                        attribute36: value,
                      }));
                    }}
                    width="250px"
                  />
                </Flex>
              )}

              <Flex align="center" gap="xs">
                {!orderHeader?.attribute36 && (
                  <>
                    <Text style={{ flex: "0 0 100px" }}>
                      Số điện thoại:<span style={{ color: "red" }}>*</span>
                    </Text>
                    <Text style={{ flex: "0 0 100px", fontWeight: "500" }}>
                      {customerCheck?.telephoneNumber}
                    </Text>
                  </>
                )}
                <CustomerDetail
                  customerCheck={customerCheck}
                  attribute36={orderHeader?.attribute36}
                  orderType={2}
                  taxInfo={taxInfo}
                ></CustomerDetail>
              </Flex>
              {location?.state?.actionType === "view" &&
                approvalHistory &&
                approvalHistory.length > 0 && (
                  <Flex align="center" gap="xs">
                    <Text style={{ flex: "0 0 100px" }}>Duyệt giá:</Text>
                    <Box>
                      {approvalHistory.map((item, index) => (
                        <Text key={index} fw={500} size="sm">
                          {item.fullName} - {formatDateString(item.createDate)}
                        </Text>
                      ))}
                    </Box>
                  </Flex>
                )}
            </Grid.Col>
            <Grid.Col span={6}>
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>Thời gian tạo:</Text>
                <Text fw={500}>
                  {formatDateString(orderHeader?.createDate)}
                </Text>
              </Flex>
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>Thời gian HT:</Text>
                <Text fw={500}>
                  {formatDateString(formatOrderDate(orderHeader?.orderDate))}
                </Text>
              </Flex>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  required
                  label="Kênh bán:"
                  value={saleChanel}
                  options={handlerRenderOptionSelect(saleChanelList)}
                  onChange={(value) => {
                    setSaleChanel(value);
                    const id = saleChanelList?.find((item) => {
                      return item.name === value;
                    });
                    setSaleChanelId(id.id);
                  }}
                  width="280px"
                />
              </Flex>
              {location?.state?.actionType === "payment" && (
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 100px" }}>Thu ngân:</Text>
                  <Text fw={500}>{userLogin?.fullname}</Text>
                </Flex>
              )}
              {location?.state?.actionType === "view" &&
                orderHeader?.orderStatus === "DON_HANG_HOAN_THANH" && (
                  <Flex align="center" gap="xs">
                    <Text style={{ flex: "0 0 100px" }}>Thu ngân:</Text>
                    <Text fw={500}>{accountantName}</Text>
                  </Flex>
                )}
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>
                  Loại KH:<span style={{ color: "red" }}>*</span>
                </Text>
                <Text fw={500}>
                  {customerCheck?.type
                    ? customerCheck?.type === 1
                      ? "Khách lẻ"
                      : "Khách doanh nghiệp"
                    : ""}
                </Text>
              </Flex>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  required
                  label="Thông tin HĐ:"
                  popoverLabel="Chọn thông tin HĐ:"
                  value={
                    (orderHeader?.printInvoiceCheck ?? 0) === 0
                      ? "Không"
                      : orderHeader?.printInvoiceCheck === 1
                        ? "Có"
                        : "Nợ"
                  }
                  options={["Không", "Có", "Nợ"]}
                  optionLabels={{
                    Không: "KH tiêu dùng – HĐ khách lẻ",
                    Có: "Có lấy hóa đơn",
                    Nợ: "Nợ hóa đơn",
                  }}
                  onChange={(e) => {
                    setOrderHeader((prev) => ({
                      ...prev,
                      printInvoiceCheck:
                        e === "Không"
                          ? 0
                          : e === "Có"
                            ? 1
                            : e === "Nợ"
                              ? 2
                              : prev.printInvoiceCheck,
                    }));
                  }}
                />
              </Flex>
              {/* Icon để mở modal thông tin VAT - style giống các trường khác */}
              {(orderHeader?.printInvoiceCheck === 1 ||
                orderHeader?.printInvoiceCheck === 2) && (
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 100px" }}>
                    Thông tin xuất hóa đơn VAT:
                  </Text>
                  <ActionIcon
                    color="blue"
                    variant="light"
                    onClick={() => setTaxInfoModalOpened(true)}
                    title={
                      location?.state?.actionType === "view"
                        ? "Xem thông tin xuất hóa đơn VAT"
                        : "Chỉnh sửa thông tin xuất hóa đơn VAT"
                    }
                    style={{ pointerEvents: "auto" }}
                  >
                    <IconEdit size={18} />
                  </ActionIcon>
                </Flex>
              )}
              {orderHeader?.attribute27 && (
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 100px" }}>Số hoá đơn VAT:</Text>
                  <Text fw={500}>{orderHeader?.attribute27}</Text>
                </Flex>
              )}
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  required
                  label="Yêu cầu DV:"
                  value={handleGetTechnicialRequireName(
                    orderHeader?.technicalRequired ?? 0,
                  )}
                  options={[
                    "Không",
                    "Lắp ráp(mới)",
                    "Kiểm tra(mới)",
                    "Lắp ráp(mới) + Kiểm tra(mới)",
                  ]}
                  onChange={(e) =>
                    setOrderHeader((prev) => ({
                      ...prev,
                      technicalRequired: handleGetTechnicialRequireId(e) ?? 0,
                    }))
                  }
                />
              </Flex>
              <Flex>
                <SelectBuildPc
                  value={parseAttribute19(orderHeader?.attribute19)}
                  onChange={(data) => {
                    const updatedAttribute19 = JSON.stringify({
                      machineCode: data.machineCode,
                      quantity: data.quantity,
                    });
                    setOrderHeader((prev) => ({
                      ...prev,
                      attribute19: updatedAttribute19,
                    }));
                  }}
                  required
                  label="Build Pc"
                />
              </Flex>
              <Flex align="center" gap="xs">
                <SelectPaymentMethod
                  customerCheck={customerCheck}
                  required
                  width="230px"
                  label="PT thanh toán:"
                  value={orderHeader?.attribute24 || "Thu Tiền Ngay"}
                  shipping={shipping}
                  options={[
                    "Thu Tiền Ngay",
                    ...(shipping === "Giao hàng" ? [] : ["Thu tiền sau lắp đặt"]),
                    "Giao Hàng Thu Tiền(COD)",
                    "Đã chuyển khoản",
                    "Trả góp",
                    "Đối Trừ Công Nợ",
                    "Công nợ nội bộ",
                    "Công Nợ 3 Ngày",
                    "Công Nợ 4 Ngày",
                    "Công Nợ 5 Ngày",
                    "Công Nợ 7 Ngày",
                    "Công Nợ 10 Ngày",
                    "Công Nợ 15 Ngày",
                    "Công Nợ 20 Ngày",
                    "Công Nợ 21 Ngày",
                    "Công Nợ 30 Ngày",
                  ]}
                  onChange={(e) =>
                    setOrderHeader((prev) => ({
                      ...prev,
                      attribute24: e ?? "",
                    }))
                  }
                />
              </Flex>
              <Flex align="center" gap="xs" mt={-4}>
                <Text style={{ flex: "0 0 100px" }}>Mã hợp đồng:</Text>
                <TextInput
                  value={contractcode}
                  onChange={(e) => setContractcode(e.target.value)}
                  variant="unstyled"
                  size="sm"
                  fs={"14px"}
                  fw={"500"}
                  placeholder="Nhập mã đợp đồng"
                />
              </Flex>
              <Flex
                style={{
                  position: "relative",
                }}
                align="center"
                gap="xs"
                mt={-4}
              >
                <Text style={{ flex: "0 0 100px" }}>Thông tin marketing:</Text>
                <DetailPopup attribute86={orderHeader?.attribute86} />
              </Flex>
            </Grid.Col>
          </Grid>
          {/* Hiển thị ô ghi chú kỹ thuật khi chọn yêu cầu dịch vụ - Full width */}
          {(orderHeader?.technicalRequired === 1 ||
            orderHeader?.technicalRequired === 2 ||
            orderHeader?.technicalRequired === 3) && (
            <Grid>
              <Grid.Col span={12}>
                <Flex align="flex-start" gap="xs">
                  <Text style={{ flex: "0 0 100px", marginTop: "8px" }}>
                    Ghi chú KT:
                  </Text>
                  <Textarea
                    placeholder="Nhập ghi chú kỹ thuật"
                    size="sm"
                    style={{ flex: 1 }}
                    value={orderHeader?.attribute5 || ""}
                    readOnly={location?.state?.actionType === "view"}
                    onChange={(e) =>
                      setOrderHeader((prev) => ({
                        ...prev,
                        attribute5: e.target.value,
                      }))
                    }
                    minRows={2}
                    autosize
                  />
                </Flex>
              </Grid.Col>
            </Grid>
          )}
          <Divider my="sm" mt={0} />
          <Grid mt={10}>
            <Grid.Col span={6}>
              <Flex
                align="center"
                gap="xs"
                style={isHaveShiping ? { pointerEvents: "auto" } : undefined}
              >
                <EditableTextWithOptions
                  required
                  label="Giao hàng:"
                  value={shipping}
                  options={["Nhận tại cửa hàng", "Giao hàng"]}
                  onChange={(val) => {
                    setShipping(val);
                    if (
                      val === "Nhận tại cửa hàng" &&
                      (orderHeader?.attribute24 === "Giao Hàng Thu Tiền(COD)" ||
                        orderHeader?.attribute24?.toLowerCase()?.includes("giao hàng thu tiền"))
                    ) {
                      setOrderHeader((prev) => ({
                        ...prev,
                        attribute24: "Thu Tiền Ngay",
                      }));
                      NotificationExtension.Warn(
                        "Đã tự động chuyển PT thanh toán về 'Thu Tiền Ngay' do nhận tại cửa hàng!",
                      );
                    } else if (
                      val === "Giao hàng" &&
                      orderHeader?.attribute24 === "Thu tiền sau lắp đặt"
                    ) {
                      setOrderHeader((prev) => ({
                        ...prev,
                        attribute24: "Thu Tiền Ngay",
                      }));
                      NotificationExtension.Warn(
                        "Không thể chọn 'Thu tiền sau lắp đặt' khi chọn Giao hàng. Đã tự động chuyển PT thanh toán về 'Thu Tiền Ngay'!",
                      );
                    }
                  }}
                />
              </Flex>
            </Grid.Col>
            <Grid.Col span={6}>
              <Grid>
                {shipping === "Nhận tại cửa hàng" && (
                  <Grid.Col span={12}>
                    <Flex align="center" gap="xs">
                      <Text style={{ flex: "0 0 100px" }}>
                        Địa chỉ lấy hàng:
                      </Text>
                      <Text fw={500}>
                        {orderHeader?.attribute62 || "Chưa có địa chỉ"}
                      </Text>
                    </Flex>
                  </Grid.Col>
                )}
                {(shipping === "Nội bộ" ||
                  shipping === "Đối tác vận chuyển" ||
                  shipping === "Giao hàng") && (
                  <Grid.Col span={6}>
                    <Flex>
                      <Text style={{ flex: "0 0 57px" }}>
                        Chi tiết: <span style={{ color: "red" }}>*</span>
                      </Text>
                      <Button
                        style={{
                          pointerEvents:
                            location?.state?.actionType === "payment" ||
                            location?.state?.actionType === "approved"
                              ? "none"
                              : "auto",
                        }}
                        ml={10}
                        size="xs"
                        onClick={() => {
                          if (listAdd.length > 0) {
                            if (shipingVendor || true) {
                              openModalDeliveryInformation();
                            } else {
                              NotificationExtension.Warn(
                                "Chưa chọn đơn vị tiếp nhận !",
                              );
                            }
                          } else {
                            NotificationExtension.Warn(
                              "Chưa có sản phẩm trong đơn !",
                            );
                          }
                        }}
                        variant="transparent"
                      >
                        <IconTruck size={22} /> {/* Biểu tượng xe tải */}
                      </Button>
                    </Flex>
                  </Grid.Col>
                )}
              </Grid>
            </Grid.Col>
          </Grid>
        </Box>
        <Divider my={"sm"} />
        {/* {!location?.state?.isReadOnly && ( */}
        {true && (
          <Box>
            <Grid>
              <Grid.Col span={12} pt={0} pb={0} mt={-4}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Xin giảm:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <Checkbox
                    checked={orderHeader?.attribute69 === "1"}
                    onChange={(event) => {
                      const isChecked = event.currentTarget.checked;
                      setOrderHeader({
                        ...orderHeader,
                        attribute69: isChecked ? "1" : "0",
                      });
                    }}
                    disabled={
                      totalXGDetail > 0 ||
                      location?.state?.actionType === "payment" ||
                      location?.state?.actionType === "view" ||
                      location?.state?.actionType === "approved" ||
                      listAdd.length === 0
                    }
                    styles={{
                      label: {
                        fontSize: "14px",
                        fontWeight: 500,
                      },
                    }}
                  />
                  {((location?.state?.actionType === "approved" &&
                    orderStatus === "DON_HANG_CHO_DUYET_GIAM") ||
                    (location?.state?.actionType === "view" &&
                      location?.state?.fromCompletedList)) && (
                    <Tooltip label="Xem gợi ý chiết khấu">
                      <ActionIcon
                        variant="outline"
                        color="blue"
                        size="sm"
                        onClick={(e) =>
                          handleOpenDiscountSuggestion(
                            e,
                            location?.state?.fromCompletedList,
                          )
                        }
                        disabled={!customerCheck?.code || listAdd.length === 0}
                        style={{ marginLeft: "10px", pointerEvents: "auto" }}
                      >
                        <IconEye size={16} />
                      </ActionIcon>
                    </Tooltip>
                  )}
                </Flex>
              </Grid.Col>

              {/* Nợ khuyến mãi - đặt gần với xin giảm */}
              <Grid.Col span={12} pt={2} pb={0}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Nợ khuyến mãi:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <Checkbox
                    checked={orderHeader?.attribute80 === "1"}
                    onChange={(event) => {
                      const isChecked = event.currentTarget.checked;
                      setOrderHeader({
                        ...orderHeader,
                        attribute80: isChecked ? "1" : "0",
                      });
                    }}
                    disabled={
                      location?.state?.actionType === "payment" ||
                      location?.state?.actionType === "view" ||
                      location?.state?.actionType === "approved" ||
                      listAdd.length === 0
                    }
                    styles={{
                      label: {
                        fontSize: "14px",
                        fontWeight: 500,
                      },
                    }}
                  />
                </Flex>
              </Grid.Col>

              {/* Ô nhập mới: Khuyến mãi tổng đơn */}
              {!location?.state?.fromTMDTList && (
                <>
                  <Grid.Col span={12} pt={0} pb={0}>
                    <Flex align="center" gap="xs">
                      <Text style={{ flex: "0 0 150px", whiteSpace: "nowrap" }}>
                        Khuyến mãi tổng đơn:
                      </Text>
                      <Flex
                        align="center"
                        gap={6}
                        style={{ width: "25%", pointerEvents: "auto" }}
                      >
                        <PromotionDescriptionPopover
                          value={orderHeader?.attribute97 || ""}
                          onChange={(val) =>
                            setOrderHeader((prev) => ({
                              ...prev,
                              attribute97: val,
                              amountDiscountTotal:
                                !val.trim() && !prev?.attribute39
                                  ? 0
                                  : prev.amountDiscountTotal,
                            }))
                          }
                          amountDiscountTotal={
                            orderHeader?.amountDiscountTotal || 0
                          }
                          hasVoucher={!!orderHeader?.attribute39}
                          readOnly={
                            location?.pathname === "/sell/view-order" ||
                            location?.state?.actionType === "payment" ||
                            location?.state?.actionType === "view" ||
                            location?.state?.actionType === "approved"
                          }
                          disabled={
                            location?.pathname === "/sell/retail-order" &&
                            listAdd.length === 0
                          }
                          opened={promoDescOpened}
                          onOpenedChange={setPromoDescOpened}
                        />
                      </Flex>

                      {/* Ô nhập số tiền khuyến mãi */}
                      <NumberInput
                        disabled={
                          location?.state?.actionType === "payment" ||
                          location?.state?.actionType === "view" ||
                          location?.state?.actionType === "approved" ||
                          listAdd.length === 0 ||
                          (!orderHeader?.attribute97?.trim() &&
                            !orderHeader?.attribute39)
                        }
                        variant="unstyled"
                        style={{ height: 38 }}
                        size="md"
                        fw={"500"}
                        placeholder={
                          !orderHeader?.attribute97?.trim() &&
                          !orderHeader?.attribute39
                            ? "Cần nhập diễn giải KM"
                            : "Nhập số tiền khuyến mãi"
                        }
                        hideControls
                        value={orderHeader?.amountDiscountTotal || ""}
                        thousandSeparator="."
                        decimalSeparator=","
                        onChange={(e) =>
                          setOrderHeader({
                            ...orderHeader,
                            amountDiscountTotal: Number(e),
                          })
                        }
                        clampBehavior="strict"
                        min={1}
                        max={1000000000}
                        allowDecimal={false}
                        allowNegative={false}
                      />

                      {/* Ô nhập mã khuyến mãi */}
                      <Flex align="center" gap="xs">
                        <TextInput
                          style={{
                            width: "110px",
                            pointerEvents:
                              orderStatus === "DON_HANG_TAM" ||
                              orderStatus === "noCreate"
                                ? "auto"
                                : "none",
                            backgroundColor: orderHeader?.attribute39
                              ? "#e7f5ff"
                              : "transparent",
                          }}
                          size="sm"
                          placeholder="Nhập voucher"
                          value={orderHeader?.attribute39 || ""}
                          onChange={(e) =>
                            setOrderHeader({
                              ...orderHeader,
                              attribute39: e.target.value,
                            })
                          }
                          onKeyDown={async (e: any) => {
                            if (e.key === "Enter") {
                              // Xử lý voucher - tất cả logic check đã được xử lý ở BE
                              handleGetDetailDataVoucher(e.target.value);
                            }
                          }}
                        />
                        {orderHeader?.attribute39 && (
                          <Button
                            size="xs"
                            variant="outline"
                            color="red"
                            disabled={
                              location?.state?.actionType === "payment" ||
                              location?.state?.actionType === "view" ||
                              location?.state?.actionType === "approved"
                            }
                            onClick={() => {
                              setOrderHeader({
                                ...orderHeader,
                                attribute39: "",
                                amountDiscountTotal: 0,
                              });
                              NotificationExtension.Success("Đã xóa mã voucher");
                            }}
                            title="Xóa voucher"
                          >
                            ✕
                          </Button>
                        )}
                      </Flex>
                    </Flex>
                  </Grid.Col>
                </>
              )}
            </Grid>

            <Divider my="sm" />
            <Grid>
              <Grid.Col span={12} pt={0} pb={0}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Tổng tiền hàng:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <Text fw={"500"}>
                    <NumberFormatter
                      value={
                        containsDT(orderHeader?.orderNumber) &&
                        location?.state?.actionType !== "doi"
                          ? orderHeader?.amountTotal
                          : totalAmount || 0
                      }
                      thousandSeparator="."
                      decimalSeparator=","
                    />
                  </Text>
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pt={0} pb={0}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>
                    {" "}
                    {location?.state?.fromTMDTList
                      ? "Tổng phí sàn:"
                      : "Tổng giảm trừ:"}
                  </Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <Text fw={"500"}>
                    <NumberFormatter
                      value={
                        (totalKM +
                          (totalXGDetail ?? 0) +
                          (orderHeader?.discountAddedTotal ?? 0) || 0) === 0
                          ? 0
                          : `-${
                              totalKM +
                                (totalXGDetail ?? 0) +
                                (orderHeader?.discountAddedTotal ?? 0) || 0
                            }`
                      }
                      thousandSeparator="."
                      decimalSeparator=","
                    />
                  </Text>
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pt={0} pb={0}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Phí ship:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <Text fw={"500"}>
                    <NumberFormatter
                      value={
                        listAdd.length > 0
                          ? ["view", "payment", "approved"].includes(
                              location?.state?.actionType || "",
                            )
                            ? Number(orderHeader?.attributeValue3) || 0
                            : Number(dataDeliveryInformation?.deliveryFee) ||
                              Number(orderHeader?.attributeValue3) ||
                              0
                          : 0
                      }
                      thousandSeparator="."
                      decimalSeparator=","
                    />
                  </Text>
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pt={0} pb={0}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>
                    Số tiền cần thanh toán:
                  </Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <Text fw={"500"} style={{ color: "red" }}>
                    <NumberFormatter
                      style={{ fontSize: "17px" }}
                      value={
                        location?.state?.actionType === "view"
                          ? // ||
                            //   location?.state?.fromWebsiteOrderList
                            // Commnet chỗ check biến fromWebsiteOrrderList lại vì khi đơn web về vẫn cho chỉnh sửa địa chỉ và mình sẽ phải tính lại số tiền cần thanh toán hiển thị nên k cần check fromWebsiteOrderList
                            orderHeader?.amountTotal
                          : payableAmount - orderHeader?.amountPaid
                      }
                      thousandSeparator="."
                      decimalSeparator=","
                    />
                    {` (Đã VAT) `}
                  </Text>
                </Flex>
              </Grid.Col>
            </Grid>
            <Divider my={"sm"} />
            <Grid>
              <Grid.Col span={12} pt={0} pb={0} h={"fit-content"}>
                <Flex align="center" gap="xs" style={{ pointerEvents: "auto" }}>
                  <Text fs={"16px"} fw={"500"} style={{ flex: "0 0 180px" }}>
                    Thanh toán trước :
                  </Text>

                  <>
                    <PaymentDetails
                      orderNumber={orderHeader?.orderNumber}
                    ></PaymentDetails>
                  </>

                  {/* Icon tiền cọc - hiển thị khi actionType là payment hoặc view */}
                  {(location?.state?.actionType === "payment" ||
                    location?.state?.actionType === "view") && (
                    <IconCoin
                      size={24}
                      style={{
                        cursor: "pointer",
                        color: cobalt_blue.base,
                        marginLeft: "8px",
                      }}
                      onClick={handleOpenDepositModal}
                    />
                  )}

                  {/* Hiển thị số tiền cọc nếu có */}
                  {orderHeader?.deposit && (
                    <Text
                      fw={500}
                      style={{
                        color: "green",
                        fontSize: "14px",
                        marginLeft: "4px",
                      }}
                    >
                      ({Number(orderHeader.deposit).toLocaleString("vi-VN")} VNĐ
                      {orderHeader?.receiptNumber &&
                        ` - ${orderHeader.receiptNumber}`}
                      )
                      {/* Debug: {JSON.stringify({deposit: orderHeader.deposit, receipt: orderHeader.receiptNumber})} */}
                    </Text>
                  )}
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pb={0} h={"fit-content"}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Tiền mặt:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <NumberInput
                    disabled={location?.state?.actionType !== "payment"}
                    variant="unstyled"
                    autoFocus
                    style={{ height: 32, pointerEvents: "auto" }}
                    size="md"
                    fw={"500"}
                    placeholder={"Nhập số tiền"}
                    hideControls
                    value={
                      dataPayment
                        ? getPayAmountByPayType("02")
                        : cashPayment || ""
                    }
                    thousandSeparator="."
                    decimalSeparator=","
                    onChange={(e) => handleChangePrice(e, "cashPayment")}
                    clampBehavior="strict"
                    min={1}
                    max={100000000000}
                    allowNegative={false}
                    allowDecimal={false}
                  />
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pb={0} h={"fit-content"}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Chuyển khoản:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <NumberInput
                    disabled={location?.state?.actionType !== "payment"}
                    variant="unstyled"
                    autoFocus
                    style={{ height: 32, pointerEvents: "auto" }}
                    size="md"
                    fw={"500"}
                    placeholder={"Nhập số tiền"}
                    hideControls
                    value={
                      dataPayment
                        ? getPayAmountByPayType("01")
                        : bankTransfer || ""
                    }
                    thousandSeparator="."
                    decimalSeparator=","
                    onChange={(e) => handleChangePrice(e, "bankTransfer")}
                    min={1}
                    max={10000000000}
                    clampBehavior="strict"
                    allowNegative={false}
                    allowDecimal={false}
                  />
                  {!(
                    location?.state?.actionType == "approved" ||
                    location?.state?.actionType !== "payment"
                  ) &&
                    bankTransfer && (
                      <IconCreditCard
                        style={{
                          cursor:
                            location?.state?.actionType === "payment"
                              ? "pointer"
                              : "not-allowed",
                          color: cobalt_blue.base,
                          pointerEvents:
                            location?.state?.actionType === "payment"
                              ? "auto"
                              : "none",
                        }}
                        onClick={() => {
                          if (location?.state?.actionType !== "payment") return;
                          openModalPaymentMb(bankTransfer, anotherPayment);
                        }}
                      />
                    )}
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pb={0} h={"fit-content"}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>CK khác:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <NumberInput
                    disabled={location?.state?.actionType !== "payment"}
                    variant="unstyled"
                    autoFocus
                    style={{ height: 32, pointerEvents: "auto" }}
                    size="md"
                    fw={"500"}
                    placeholder={"Nhập số tiền"}
                    hideControls
                    value={
                      dataPayment
                        ? getPayAmountByPayType("08")
                        : anotherPayment || ""
                    }
                    thousandSeparator="."
                    decimalSeparator=","
                    onChange={(e) => handleChangePrice(e, "anotherPayment")}
                    min={1}
                    max={10000000000}
                    clampBehavior="strict"
                    allowNegative={false}
                    allowDecimal={false}
                  />
                </Flex>
              </Grid.Col>

              <Grid.Col span={12} pb={0} h={"fit-content"}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Thanh toán thẻ:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>

                  {/* Chế độ view - hiển thị số tiền như các dòng khác */}
                  {location?.state?.actionType === "view" ? (
                    <Text fw={"500"}>
                      <NumberFormatter
                        value={getPayAmountByPayType("03") || 0}
                        thousandSeparator="."
                        decimalSeparator=","
                      />
                    </Text>
                  ) : (
                    /* Chế độ payment - UI nhập liệu */
                    <>
                      <NumberInput
                        disabled={location?.state?.actionType !== "payment"}
                        variant="unstyled"
                        autoFocus
                        style={{ height: 32, pointerEvents: "auto" }}
                        size="md"
                        fw={"500"}
                        placeholder={"Nhập số tiền"}
                        hideControls
                        value={
                          dataPayment
                            ? getPayAmountByPayType("03")
                            : cardPayment || ""
                        }
                        thousandSeparator="."
                        decimalSeparator=","
                        onChange={(value) =>
                          handleChangePrice(value, "cardPayment")
                        }
                        min={1}
                        max={10000000000}
                        clampBehavior="strict"
                        allowNegative={false}
                        allowDecimal={false}
                      />
                      {(dataPayment
                        ? getPayAmountByPayType("03")
                        : false || cardPayment != 0) && (
                        <>
                          <Select
                            placeholder="Chọn ngân hàng"
                            data={bankOptions}
                            value={
                              dataPayment ? getCardBank() : selectedBank || ""
                            }
                            onChange={(e) => setSelectedBank(e || "")}
                            style={{
                              width: "200px",
                              marginLeft: "8px",
                              pointerEvents:
                                location?.state?.actionType === "payment"
                                  ? "auto"
                                  : "none",
                            }}
                            disabled={location?.state?.actionType !== "payment"}
                          />
                          {/* Hiển thị ô nhập mã giao dịch khi chọn PAYOO, VN PAY, Alepay hoặc ONEPAY */}
                          {(selectedBank === "113106" ||
                            selectedBank === "113101" ||
                            selectedBank === "113105" ||
                            selectedBank === "113107") && (
                            <TextInput
                              placeholder="Nhập mã giao dịch"
                              value={transactionCodeCard || ""}
                              onChange={(e) =>
                                setTransactionCodeCard(e.target.value)
                              }
                              style={{
                                width: "180px",
                                marginLeft: "8px",
                                pointerEvents:
                                  location?.state?.actionType === "payment"
                                    ? "auto"
                                    : "none",
                              }}
                              disabled={
                                location?.state?.actionType !== "payment"
                              }
                            />
                          )}
                        </>
                      )}
                    </>
                  )}
                </Flex>

                {/* Hiển thị thông tin ngân hàng và mã giao dịch ở dòng riêng cho chế độ view */}
                {location?.state?.actionType === "view" &&
                  (getCardBank() || getBankCode()) && (
                    <Flex align="flex-start" gap="xs" mt={6} ml={0}>
                      <Text style={{ flex: "0 0 150px" }}></Text>
                      <Text fw={500} style={{ width: "25%" }}></Text>
                      <Flex direction="row" gap={8} align="center">
                        {getCardBank() && (
                          <Text
                            style={{
                              fontSize: "13px",
                              color: "#1976d2",
                              fontWeight: 500,
                              backgroundColor: "#e3f2fd",
                              padding: "2px 8px",
                              borderRadius: "4px",
                              display: "inline-block",
                              width: "fit-content",
                            }}
                          >
                            Ngân hàng:{" "}
                            {bankOptions.find((b) => b.value === getCardBank())
                              ?.label || getCardBank()}
                          </Text>
                        )}
                        {getBankCode() && (
                          <Text
                            style={{
                              fontSize: "13px",
                              color: "#f57c00",
                              fontWeight: 500,
                              backgroundColor: "#fff3e0",
                              padding: "2px 8px",
                              borderRadius: "4px",
                              display: "inline-block",
                              width: "fit-content",
                            }}
                          >
                            Mã GD: {getBankCode()}
                          </Text>
                        )}
                      </Flex>
                    </Flex>
                  )}
              </Grid.Col>
              <Grid.Col span={12} pb={0} h={"fit-content"}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Tổng:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <Text fw={"500"}>
                    <NumberFormatter
                      value={totalPaid || 0}
                      thousandSeparator="."
                      decimalSeparator=","
                    />
                  </Text>
                </Flex>
              </Grid.Col>
              <>
                <Grid.Col span={12} py={0} h={"fit-content"}>
                  <Flex align="center" gap="xs">
                    <Text style={{ flex: "0 0 150px", fontWeight: "500" }}>
                      Thanh toán sau:
                    </Text>
                    <Box
                      style={{
                        width: "25%",
                        pointerEvents:
                          location?.state?.actionType === "payment" &&
                          orderStatus !== "DON_HANG_HOAN_THANH"
                            ? "auto"
                            : "none",
                      }}
                    >
                      {/* <EditableTextWithOptions
                          isCod
                          label=""
                          value={
                            dataPaymentLatter
                              ? dataPaymentLatter?.payLaterMethod
                              : payLaterMethod
                          }
                          options={["Không", "COD", "Công nợ", "Trả góp"]}
                          onChange={setPayLaterMethod}
                        /> */}
                    </Box>
                    <Text fw={"500"} style={{ color: "red" }}>
                      <NumberFormatter
                        style={{ fontSize: "17px" }}
                        value={
                          location?.state?.actionType === "view"
                            ? orderHeader?.amountRemaining
                            : deferredPayment - orderHeader?.amountPaid
                        }
                        thousandSeparator="."
                        decimalSeparator=","
                      />
                    </Text>
                    {/* Nút bấm hiển thị modal nếu điều kiện phù hợp */}
                    {/* {payLaterMethod === "Công nợ" && (
                        <Button
                          size="xs"
                          onClick={() => handleOpenModal("Công nợ")}
                          style={{
                            marginLeft: "10px",
                            pointerEvents:
                              location?.state?.actionType === "view" ||
                              location?.state?.actionType === "payment"
                                ? "auto"
                                : "none",
                          }}
                        >
                          Nhập công nợ
                        </Button>
                      )} */}
                    {payLaterMethod === "Trả góp" && (
                      <Button
                        size="xs"
                        onClick={() => handleOpenModal("Trả góp")}
                        style={{
                          marginLeft: "10px",
                          pointerEvents:
                            location?.state?.actionType === "view" ||
                            location?.state?.actionType === "payment"
                              ? "auto"
                              : "none",
                        }}
                      >
                        Nhập trả góp
                      </Button>
                    )}
                  </Flex>
                </Grid.Col>

                {/* Modal Công nợ */}
                <Modal
                  style={{
                    pointerEvents:
                      location?.state?.actionType === "payment" &&
                      orderStatus !== "DON_HANG_HOAN_THANH"
                        ? "auto"
                        : "none",
                  }}
                  opened={modalType === "Công nợ"}
                  onClose={handleCloseModal}
                  title="Nhập thông tin Công nợ"
                  centered
                >
                  {/* Hiển thị thông báo thời hạn công nợ mặc định */}
                  <Text size="sm" color="dimmed" mb="sm" mt={10}>
                    Thời hạn công nợ là{" "}
                    <strong>{customerCheck?.debtTerm || 0}</strong> ngày. Tối đa
                    có thể nhập là{" "}
                    <strong>{(customerCheck?.debtTerm || 0) * 2}</strong> ngày.
                  </Text>

                  {/* Hiển thị hạn mức công nợ với dấu chấm ngăn cách */}
                  <Text size="sm" color="dimmed" mb="sm">
                    Hạn mức công nợ:
                    <strong>
                      {(customerCheck?.debtLimit || 0).toLocaleString("vi-VN")}{" "}
                      VNĐ
                    </strong>
                  </Text>

                  <TextInput
                    label="Thời hạn công nợ"
                    placeholder={`Nhập thời hạn (tối đa ${
                      (customerCheck?.debtTerm || 0) * 2
                    } ngày)`}
                    withAsterisk
                    type="number"
                    value={
                      dataPaymentLatter
                        ? dataPaymentLatter?.debtInfo?.dueDate
                        : debtInfo.dueDate || ""
                    }
                    onChange={(e) => {
                      const newValue = e.target.value; // Lấy giá trị nhập vào
                      const numericValue = parseInt(newValue, 10);

                      // Cho phép giá trị rỗng hoặc số hợp lệ
                      if (
                        newValue === "" ||
                        (numericValue > 0 &&
                          numericValue <= (customerCheck?.debtTerm || 0) * 2)
                      ) {
                        setDebtInfo({ ...debtInfo, dueDate: newValue });
                      }
                    }}
                    onKeyDown={(e) => {
                      // Chặn nhập dấu '-' và ký tự 'e'
                      if (
                        e.key === "e" ||
                        e.key === "E" ||
                        e.key === "-" ||
                        e.key === "+"
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />

                  <Flex
                    justify="end"
                    mt="lg"
                    style={{
                      pointerEvents:
                        location?.state?.actionType === "payment" &&
                        orderStatus !== "DON_HANG_HOAN_THANH"
                          ? "auto"
                          : "none",
                    }}
                  >
                    <Button onClick={handleCloseModal} color="gray" mr="sm">
                      Hủy
                    </Button>
                    <Button
                      onClick={() => {
                        if (
                          debtInfo.dueDate === "" ||
                          parseInt(debtInfo.dueDate, 10) === 0
                        ) {
                          // Nếu giá trị nhập không hợp lệ (rỗng hoặc 0), có thể xử lý tại đây
                          return;
                        }
                        handleSaveDebt();
                      }}
                    >
                      Lưu
                    </Button>
                  </Flex>
                </Modal>

                {/* Modal Trả góp */}
                <Modal
                  opened={modalType === "Trả góp"}
                  onClose={handleCloseModal}
                  title="Nhập thông tin Trả góp"
                  centered
                >
                  <Tabs defaultValue="financialCompany">
                    {/* Tab Công ty tài chính */}
                    <Tabs.List>
                      <Tabs.Tab value="financialCompany">
                        Công ty tài chính
                      </Tabs.Tab>
                      <Tabs.Tab value="creditCard">Thẻ tín dụng</Tabs.Tab>
                    </Tabs.List>

                    <Tabs.Panel
                      value="financialCompany"
                      pt="sm"
                      style={{
                        pointerEvents:
                          location?.state?.actionType === "payment" &&
                          orderStatus !== "DON_HANG_HOAN_THANH"
                            ? "auto"
                            : "none",
                      }}
                    >
                      {/* <TextInput
                      label="Tên công ty"
                      placeholder="Nhập tên công ty"
                      withAsterisk
                      value={installmentInfo.companyName}
                      onChange={(e) =>
                        setInstallmentInfo({
                          ...installmentInfo,
                          companyName: e.target.value,
                        })
                      }
                    /> */}

                      <Select
                        label="Tên công ty"
                        placeholder="Chọn công ty"
                        data={[{ value: "hdsaigon", label: "HDSAISON" }]}
                        withAsterisk
                        value={
                          dataPaymentLatter?.installmentInfo?.companyName ||
                          installmentInfo.companyName
                        }
                        onChange={(value) =>
                          setInstallmentInfo({
                            ...installmentInfo,
                            companyName: value || "",
                          })
                        }
                      />
                      <TextInput
                        label="Mã hợp đồng"
                        placeholder="Nhập mã hợp đồng"
                        withAsterisk
                        value={
                          dataPaymentLatter?.installmentInfo?.contractCode ||
                          installmentInfo.contractCode
                        }
                        onChange={(e) =>
                          setInstallmentInfo({
                            ...installmentInfo,
                            contractCode: e.target.value,
                          })
                        }
                      />
                    </Tabs.Panel>

                    {/* Tab Thẻ tín dụng */}
                    <Tabs.Panel
                      value="creditCard"
                      pt="sm"
                      style={{
                        pointerEvents:
                          location?.state?.actionType === "payment" &&
                          orderStatus !== "DON_HANG_HOAN_THANH"
                            ? "auto"
                            : "none",
                      }}
                    >
                      <Select
                        label="Loại thẻ"
                        placeholder="Chọn loại thẻ"
                        data={[
                          { value: "payoo", label: "PAYOO" },
                          { value: "alepay", label: "ALEPAY" },
                        ]}
                        withAsterisk
                        value={
                          dataPaymentLatter?.installmentInfo?.cardType ||
                          installmentInfo.cardType
                        }
                        onChange={(value) =>
                          setInstallmentInfo({
                            ...installmentInfo,
                            cardType: value || "",
                          })
                        }
                      />
                    </Tabs.Panel>
                  </Tabs>

                  <Flex
                    justify="end"
                    mt="lg"
                    style={{
                      pointerEvents:
                        location?.state?.actionType === "payment" &&
                        orderStatus !== "DON_HANG_HOAN_THANH"
                          ? "auto"
                          : "none",
                    }}
                  >
                    <Button onClick={handleCloseModal} color="gray" mr="sm">
                      Hủy
                    </Button>
                    <Button
                      onClick={() => {
                        handleSaveInstallment();
                      }}
                    >
                      Lưu
                    </Button>
                  </Flex>
                </Modal>

                {/* Modal Tiền cọc */}
                <Modal
                  opened={depositModalOpened}
                  onClose={handleCloseDepositModal}
                  title="Nhập thông tin tiền cọc"
                  centered
                >
                  <TextInput
                    label="Mã báo có"
                    placeholder="Nhập mã báo có"
                    withAsterisk={location?.state?.actionType !== "view"}
                    value={depositCode}
                    onChange={(e) => setDepositCode(e.target.value)}
                    disabled={location?.state?.actionType === "view"}
                    mb="md"
                  />

                  <NumberInput
                    label="Số tiền"
                    placeholder="Nhập số tiền cọc"
                    withAsterisk={location?.state?.actionType !== "view"}
                    value={depositAmount}
                    onChange={(value) =>
                      setDepositAmount(value?.toString() || "")
                    }
                    disabled={location?.state?.actionType === "view"}
                    thousandSeparator="."
                    decimalSeparator=","
                    min={0}
                    max={100000000000}
                    allowNegative={false}
                    allowDecimal={false}
                    hideControls
                  />

                  <Flex justify="end" mt="lg">
                    <Button
                      onClick={handleCloseDepositModal}
                      color="gray"
                      mr="sm"
                    >
                      {location?.state?.actionType === "view" ? "Đóng" : "Hủy"}
                    </Button>
                    {location?.state?.actionType !== "view" && (
                      <Button onClick={handleSaveDeposit}>Lưu</Button>
                    )}
                  </Flex>
                </Modal>
              </>
            </Grid>
          </Box>
        )}
        <Box>
          <Grid mt={5}>
            <Grid.Col span={12}>
              <Flex
                gap="xs"
                direction={{ base: "column", sm: "row" }}
                align="center"
                style={{
                  pointerEvents: "auto",
                }}
              >
                {/* Ghi chú đơn hàng */}
                <Textarea
                  readOnly={
                    location?.state?.actionType === "payment" ||
                    location?.state?.actionType === "approved"
                  }
                  placeholder="Ghi chú đơn hàng"
                  size="lg"
                  style={{ flex: 1, cursor: "pointer" }}
                  defaultValue={orderHeader?.note || ""}
                  onChange={(e) => debouncedNoteChange(e.target.value)}
                />
                {/* Ghi chú thu ngân */}
                <Textarea
                  readOnly={
                    location?.state?.actionType !== "payment" ||
                    location?.state?.actionType === "approved"
                  }
                  placeholder="Ghi chú thu ngân"
                  size="lg"
                  style={{ flex: 1 }}
                  defaultValue={orderHeader?.attribute23 || ""}
                  onChange={(e) => debouncedCashierNoteChange(e.target.value)}
                />
              </Flex>
            </Grid.Col>
          </Grid>
        </Box>

        <Flex columnGap={5}>
          {orderStatus === "DON_HANG_TAM" ? (
            <Flex mt={10} gap={"xs"}>
              <>
                {location?.state?.actionType !== "doi" &&
                  !isHaveShiping &&
                  orderHeader?.attribute69 !== "1" && (
                    <Button
                      style={{ pointerEvents: "auto" }}
                      color="blue"
                      size="sm"
                      loading={loading}
                      disabled={
                        listAdd.length === 0 ||
                        location?.state?.actionType === "approved" ||
                        location?.state?.actionType === "view" ||
                        isSentForApproval
                      }
                      onClick={() => handleEditSalesOrder(false)}
                    >
                      Lưu
                    </Button>
                  )}
                <Button
                  style={{ pointerEvents: "auto" }}
                  color="green"
                  size="sm"
                  loading={loading}
                  disabled={
                    listAdd.length === 0 ||
                    location?.state?.actionType === "approved" ||
                    location?.state?.actionType === "view" ||
                    isSentForApproval
                  }
                  onClick={() => handleEditSalesOrder(true)}
                >
                  Chốt đơn
                </Button>
              </>
            </Flex>
          ) : isSentForApproval ? (
            <Flex mt={10} gap={"xs"}>
              {/* Chỉ hiển thị thông báo chờ duyệt nếu user không có quyền duyệt VÀ isLimitApproval = true */}
              {!canUserApproveDiscount() && isLimitApproval && (
                <Text c="orange" fw={500} size="sm">
                  🔒 Đơn hàng đang chờ duyệt giảm giá...
                </Text>
              )}
            </Flex>
          ) : (
            orderStatus !== "DON_HANG_HOAN_THANH" && (
              <>
                {location?.state?.actionType === "payment" ? (
                  <>
                    <Flex mt={10} gap={"xs"}>
                      <Button
                        color="green"
                        size="sm"
                        disabled={deferredPayment < 0 || isDisableHoanThanh()}
                        onClick={() => openModalPaymentBase()}
                        mt={10}
                        style={{ pointerEvents: "auto" }}
                      >
                        Hoàn thành
                      </Button>
                    </Flex>
                    {(orderHeader?.amountDiscountTotal ||
                      orderHeader?.discountAddedTotal) && (
                      <Flex mt={10} gap={"xs"}>
                        <Button
                          color="blue"
                          size="sm"
                          disabled={isDisablePhanBo}
                          onClick={() => handleAllocateItems()}
                          mt={10}
                          style={{ pointerEvents: "auto" }}
                        >
                          Phân bổ
                        </Button>
                      </Flex>
                    )}
                  </>
                ) : (
                  <>
                    <Flex mt={10} gap={"xs"}>
                      {location?.state?.actionType !== "doi" &&
                        !isHaveShiping &&
                        orderHeader?.attribute69 !== "1" && (
                          <Button
                            style={{ pointerEvents: "auto" }}
                            color="cyan"
                            size="sm"
                            loading={loading}
                            disabled={
                              orderStatus === "DON_HANG_CHOT" ||
                              orderStatus === "DON_HANG_HUY" ||
                              location?.state?.actionType === "approved" ||
                              location?.state?.actionType === "view" ||
                              isSentForApproval
                            }
                            onClick={() => handleCreateSalesOrder(false)}
                          >
                            Lưu
                          </Button>
                        )}
                    </Flex>
                    <Flex mt={10} gap={"xs"}>
                      <Button
                        style={{ pointerEvents: "auto" }}
                        leftSection={<IconCheck size={18} />}
                        color="green"
                        size="sm"
                        loading={loading}
                        disabled={
                          orderStatus === "DON_HANG_CHOT" ||
                          orderStatus === "DON_HANG_HUY" ||
                          location?.state?.actionType === "approved" ||
                          location?.state?.actionType === "view" ||
                          isSentForApproval
                        }
                        onClick={() => handleCreateSalesOrder(true)}
                      >
                        Chốt đơn
                      </Button>
                    </Flex>
                  </>
                )}
              </>
            )
          )}
          {location?.state?.actionType === "approved" &&
            orderStatus === "DON_HANG_CHO_DUYET_GIAM" &&
            !isSentForApproval && (
              <>
                <Flex mt={10} gap={"xs"}>
                  <Button
                    color="cyan"
                    size="sm"
                    onClick={() => handleApprovedSalesOrder()}
                    style={{ pointerEvents: "auto" }}
                  >
                    Duyệt giảm
                  </Button>
                </Flex>
                <Flex mt={10} gap={"xs"}>
                  <Button
                    color="red"
                    size="sm"
                    onClick={handleCancelApprovalWithDraftChoice}
                    style={{ pointerEvents: "auto" }}
                  >
                    Hủy duyệt
                  </Button>
                </Flex>
              </>
            )}
        </Flex>
      </Box>
    );
  };

  //#region openConfirmModal
  function openFormCustomer(isChooseCongNo: boolean) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Thông tin danh sách khách hàng</Title>
        </>
      ),
      size: "90vw",
      children: (
        <CustomerInformation
          isChooseCongNo={isChooseCongNo}
          handleChooseCustomer={handleChooseCustomer}
          navigate={navigate}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function openFormVoucher(row: MRT_Row<dataOrderDetailTable>) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Màn hình chọn chính sách khuyến mãi</Title>
        </>
      ),
      size: "70vw",
      children: (
        <VoucherRefactor
          branchId={branchId || 0}
          idItem={row?.id}
          price={row.original.priceOnPriceList}
          handleSelectProductAddOn={handleSelectProductAddOn}
          handleSelectProductGift={handleSelectProductGift}
          handleSelectPromotionMain={handleSelectPromotionMain}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  const openModalPaymentMb = (price: number, anotherPayment: number) =>
    modals.openConfirmModal({
      title: <Title order={5}>Thanh toán chuyển khoản</Title>,
      children: (
        <PaymentMethodMb
          isDVT={
            listBranch?.find(
              (item: any) => Number(item.value) === Number(branchId),
            )?.attr6 === "DVT"
          }
          isPaymentMbSuccess={isPaymentMbSuccess}
          setIsPaymentMbSuccess={setIsPaymentMbSuccess}
          setTransactionCodeMb={setTransactionCodeMb}
          selectedBankReserve={selectedBankReserve}
          transactionCodeReserve={transactionCodeReserve}
          setTransactionCodeReserve={setTransactionCodeReserve}
          setSelectedBankReserve={setSelectedBankReserve}
          customerCheck={customerCheck}
          orderNumber={orderHeader.orderNumber}
          setPaymentDone={setPaymentDone}
          paymentDone={paymentDone}
          price={price + anotherPayment}
          productCode={orderHeader?.orderNumber}
        />
      ),
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      size: "550px",
    });

  const openDeleteConfirmModal = (row: MRT_Row<dataOrderDetailTable>) => {
    if (isHaveShiping) {
      NotificationExtension.Warn(
        "Đã lưu thông tin giao hàng, không thể xóa sản phẩm!",
      );
      return;
    }
    return modals.openConfirmModal({
      title: "Bạn có chắc chắn xóa sản phẩm này?",
      children: (
        <Text size="lg" mt={15}>
          Bạn có chắc chắn muốn xóa ?
        </Text>
      ),
      labels: { confirm: "Xóa", cancel: "Thoát" },
      confirmProps: { color: "red" },
      onConfirm: () => {
        setListAdd((prevData) => {
          const remaining = prevData.filter(
            (item) =>
              item.id !== row.original?.id &&
              !row.original?.listIdGift?.includes(item?.id),
          );
          return handleWarrantyOnDeleteRow(remaining, row.original);
        });
      },
    });
  };

  const openModalDeliveryInformation = () => {
    modals.openConfirmModal({
      title: <Title order={5}>Thông tin giao hàng</Title>,
      size: "70%",
      children: (
        <ModalDeliveryInformation
          listAddress={listAddress}
          attribute36={orderHeader?.attribute36}
          cod={
            containsDT(orderHeader?.orderNumber) &&
            location?.state?.actionType !== "doi"
              ? orderHeader?.amountTotal
              : deferredPayment - orderHeader?.amountPaid
          }
          readOnly={location?.state?.actionType === "view"}
          shipping={shipping}
          shipingVendor={shipingVendor}
          setShippingVendor={setShipingVendor}
          customerCheck={customerCheck}
          dataDeliveryInformation={dataDeliveryInformation}
          setDataDeliveryInformation={setDataDeliveryInformation}
          branchId={branchId ? branchId : orderHeader?.orgId}
          listAdd={listAdd}
          payType={orderHeader?.attribute24}
          setIsHaveShipping={setIsHaveShipping}
          isHaveVat={
            orderHeader?.printInvoiceCheck === 1 ||
            orderHeader?.printInvoiceCheck === 2
          }
          setOrderHeader={setOrderHeader}
          technicalRequired={orderHeader?.technicalRequired ?? 0}
          orderHeader={orderHeader}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  function openFormShipCompany() {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Thông tin đối tác giao vận</Title>
        </>
      ),
      size: "70vw",
      children: <ShipCompanyTable onSelect={handleSelectShipingVendor} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function openFormShipDepartment() {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Thông tin bộ phận giao vận</Title>
        </>
      ),
      size: "400px",
      children: <ChooseShipDepartment onSelect={handleSelectShipingVendor} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  const openModalPaymentBase = async () => {
    modals.openConfirmModal({
      title: <Title order={5}>Xác nhận hoàn tất thanh toán</Title>,
      children: (
        <>
          <Flex justify={"end"} gap={20} mt={"sm"}>
            <Button
              color="gray"
              leftSection={<IconWindow size={18} />}
              onClick={() => {
                modals.closeAll();
              }}
            >
              Huỷ
            </Button>
            <Button
              leftSection={<IconCheck size={18} />}
              onClick={() => {
                handleCallApiPayment();
                modals.closeAll();
              }}
            >
              Xác nhận
            </Button>
          </Flex>
        </>
      ),
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      size: "400px",
      classNames: {
        title: "custom-modal-title",
        body: "custom-modal-body",
      },
    });
  };

  //#region Table sản phẩm
  const handleChangeRequestReduction = async (
    value: number | string,
    id: number,
    price: number,
  ) => {
    // Tìm item cụ thể để kiểm tra CTKM
    const targetItem = listAdd.find((item) => item.id === id);

    // // Kiểm tra điều kiện CTKM trước khi cho phép giảm giá
    // if (!canApplyCustomDiscount(targetItem)) {
    //   NotificationExtension.Warn(
    //     "Vui lòng điền đầy đủ thông tin mã CTKM và mô tả CTKM cho sản phẩm này trước khi áp dụng giảm giá tự nhập"
    //   );
    //   return;
    // }

    if (branchId) {
      setListAdd((prevList) => {
        return prevList.map((item) => {
          if (item.id === id) {
            const newValue =
              typeof value === "number" ? value : parseFloat(value);
            const validNewValue = isNaN(newValue) ? 0 : newValue;
            const newPriceFinal =
              price - validNewValue - (item.discountAmount || 0); // Thêm discountAmount
            return {
              ...item,
              discountAdded: validNewValue,
              priceFinal: newPriceFinal,
              isDiscountReset: false, // Reset flag khi user set discount thủ công
            };
          }
          return item;
        });
      });
    }
  };
  console.log("LoggorderHeader", orderHeader);
  // console.log("Logglocation", location);
  // console.log("LoggpayableAmount", payableAmount);

  const columns = React.useMemo<MRT_ColumnDef<dataOrderDetailTable>[]>(() => {
    return [
      {
        header: "STT",
        enableEditing: false,
        size: 30,
        Cell: ({ renderedCellValue, row }) => (
          <Text>{row.index === -1 ? "" : row.index + 1}</Text>
        ),
      },
      {
        accessorKey: "lineTyle",
        header: "Loại",
        enableEditing: false,
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => (
          <Text>
            <LineType status={row?.original?.lineTyle} />
          </Text>
        ),
        size: 110,
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        enableEditing: false,
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => (
          <Box style={{ pointerEvents: "auto" }}>
            <Tooltip label={renderedCellValue}>
              <Text w={200} style={{ whiteSpace: "normal" }} lineClamp={2}>
                {renderedCellValue}
              </Text>
            </Tooltip>

            {row?.original?.coBanLe === "N" ? (
              <Text
                size="md"
                fw={600}
                style={{
                  color: "#c92a2a",
                  margin: 0,
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <IconAlertCircle size={16} style={{ color: "#c92a2a" }} />
                Kinh doanh lưu ý — hàng không bán lẻ
              </Text>
            ) : null}
          </Box>
        ),
      },
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        enableEditing: isCreating,
        enableSorting: false,
        size: 120,
        Edit: ({ cell, row, table, column }) => {
          return (
            <>
              <Menu
                opened={!!valueDebounced && dataProducts?.length > 0}
                trapFocus={false}
                shadow="md"
                width={"800"}
                position="bottom-start"
              >
                <Menu.Target>
                  <TextInput
                    autoFocus
                    onChange={async (e) => {
                      const _key = e.target.value ?? "";
                      setValueDebounced(_key);
                      handleSearch();
                    }}
                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                      if (
                        e.key === "Enter" &&
                        dataProducts?.length === 1 &&
                        !listAdd.some(
                          (item) => item.itemCode === e.currentTarget.value,
                        )
                      ) {
                        setValueDebounced("");
                        handleSelectProduct(dataProducts[0], row?.index);
                        table.setCreatingRow(null);
                        handleSearch();
                      }
                    }}
                  />
                </Menu.Target>
                <Menu.Dropdown>
                  {/* Nút đóng góc trên */}
                  <ActionIcon
                    onClick={() => {
                      setValueDebounced(""); // Đóng menu khi nút đóng được bấm
                      handleSearch();
                    }}
                    style={{
                      position: "absolute",
                      top: 4, // Điều chỉnh khoảng cách từ trên xuống
                      right: 20, // Điều chỉnh khoảng cách từ phải sang
                      zIndex: 11,
                      backgroundColor: "#f5f5f5", // Màu nền nhạt
                      border: "1px solid #ccc", // Viền nhẹ
                      borderRadius: "4%", // Bo tròn hoàn toàn
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)", // Hiệu ứng bóng
                      color: "#000", // Màu biểu tượng
                      width: "22px", // Kích thước nút
                      height: "2px", // Kích thước nút
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      transition: "all 0.3s ease", // Hiệu ứng mượt mà
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#e0e0e0"; // Màu nền khi hover
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#f5f5f5"; // Trả về màu nền ban đầu
                    }}
                    variant="transparent"
                  >
                    <IconX size={22} />
                  </ActionIcon>

                  {modeSearch === "SP" ? (
                    <TableSelect
                      dataProducts={dataProducts}
                      onSelectProduct={(product) => {
                        handleSelectProduct(product, row?.index);
                      }}
                      rowIndex={row.index}
                    />
                  ) : (
                    <TableSelectDV
                      dataProducts={dataProducts}
                      onSelectProduct={(product) => {
                        handleSelectProduct(product, row?.index, "DV");
                      }}
                      rowIndex={row.index}
                    />
                  )}
                </Menu.Dropdown>
              </Menu>
            </>
          );
        },
      },

      {
        accessorKey: "attribute23", // Khóa để truy cập dữ liệu
        header: "Mã kho", // Tiêu đề của cột
        enableEditing: false, // Không cho phép chỉnh sửa
        enableSorting: false, // Tắt sắp xếp
        size: 80, // Độ rộng của cột
        Cell: ({ row }) => {
          return <Text>{row?.original?.attribute23}</Text>; // Hiển thị giá trị
        },
      },

      {
        accessorKey: "primaryUomCode",
        header: "ĐVT",
        enableEditing: false,
        enableSorting: false,
        size: 50,
      },

      {
        accessorKey: "quality",
        header: "Số lượng",
        enableEditing: false,
        enableSorting: false,
        size: 80,
        Cell: ({ renderedCellValue, row }) => (
          <NumberInput
            disabled={!row?.original?.itemCode}
            min={1}
            max={100000}
            hideControls
            clampBehavior="strict"
            value={row.original.quality}
            onChange={(e) => {
              handleChangeQuantity(e, row);
            }}
            onBlur={(e) => {
              table.setEditingCell(null);
            }}
            onKeyDown={handleKeyDown}
            defaultValue={1}
            allowDecimal={false}
            allowNegative={false}
          />
        ),
      },
      {
        accessorKey: "attribute20",
        header: "Bảo hành",
        size: 160,
        enableEditing: false,
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => {
          // BHMR: máy nhận theo cờ (không theo mã / tên); đơn không có gói BHMR và máy chưa gán gói thì hiện chữ thường
          if (
            isLaptopItem(row.original) &&
            (listAdd.some((it) => isWarrantyItem(it)) ||
              getAssignedWarrantyCodes(row.original).length > 0)
          ) {
            const assignedCodes = getAssignedWarrantyCodes(row.original);
            const baseWarranty = row.original.attribute20 || "24T";
            const warrantyPackagesInCart = listAdd.filter((it) =>
              isWarrantyItem(it)
            );

            return (
              <Flex align="center" gap={4} wrap="wrap">
                <Badge size="xs" variant="outline" color="gray">
                  {baseWarranty.includes("T") ||
                  baseWarranty.includes("tháng")
                    ? baseWarranty
                    : `${baseWarranty}T`}{" "}
                  gốc
                </Badge>
                {/* Gom suất cùng mã gói: "+MÃ*số suất"; nút X vẫn hủy 1 suất */}
                {Array.from(
                  assignedCodes.reduce(
                    (acc, c) => acc.set(c, (acc.get(c) || 0) + 1),
                    new Map<string, number>()
                  )
                ).map(([code, slots]) => (
                  <Badge
                    key={code}
                    size="xs"
                    variant="filled"
                    color="teal"
                    rightSection={
                      <ActionIcon
                        size={14}
                        color="teal"
                        variant="transparent"
                        onClick={(e) => {
                          e.stopPropagation();
                          setListAdd((prev) =>
                            unassignOneWarrantyFromLaptop(
                              prev,
                              row.original.id,
                              code
                            )
                          );
                          NotificationExtension.Info(`Đã hủy gán gói ${code}`);
                        }}
                        title="Bấm để hủy gán 1 suất gói này"
                      >
                        <IconX size={10} color="#fff" />
                      </ActionIcon>
                    }
                  >
                    +{code}
                    {slots > 1 ? `*${slots}` : ""}
                  </Badge>
                ))}

                {warrantyPackagesInCart.length <= 1 ? (
                  <Tooltip
                    label={
                      warrantyPackagesInCart.length === 1
                        ? `Bấm để gán 1 suất gói ${warrantyPackagesInCart[0].itemCode}`
                        : "Chưa có gói bảo hành BHMR trong đơn"
                    }
                  >
                    <ActionIcon
                      size="xs"
                      variant="light"
                      color="blue"
                      onClick={() => {
                        if (warrantyPackagesInCart.length === 1) {
                          const wCode = warrantyPackagesInCart[0].itemCode;
                          const res = assignOneWarrantyToLaptop(
                            listAdd,
                            row.original.id,
                            wCode
                          );
                          if (res.success) {
                            setListAdd(res.list);
                            NotificationExtension.Success(res.message);
                          } else {
                            NotificationExtension.Warn(res.message);
                          }
                        } else {
                          NotificationExtension.Warn(
                            "Vui lòng thêm sản phẩm gói bảo hành BHMR vào đơn hàng trước!"
                          );
                        }
                      }}
                    >
                      <IconShieldCheck size={14} />
                    </ActionIcon>
                  </Tooltip>
                ) : (
                  <Menu shadow="md" width={220} position="bottom-end">
                    <Menu.Target>
                      <Tooltip label="Gán gói bảo hành cho Laptop này">
                        <ActionIcon size="xs" variant="light" color="blue">
                          <IconShieldCheck size={14} />
                        </ActionIcon>
                      </Tooltip>
                    </Menu.Target>
                    <Menu.Dropdown>
                      <Menu.Label>Chọn gói bảo hành để gán</Menu.Label>
                      {warrantyPackagesInCart.map((pkg, pIdx) => (
                        <Menu.Item
                          key={pIdx}
                          leftSection={
                            <IconShieldCheck size={14} color="#059669" />
                          }
                          onClick={() => {
                            const res = assignOneWarrantyToLaptop(
                              listAdd,
                              row.original.id,
                              pkg.itemCode
                            );
                            if (res.success) {
                              setListAdd(res.list);
                              NotificationExtension.Success(res.message);
                            } else {
                              NotificationExtension.Warn(res.message);
                            }
                          }}
                        >
                          <Text size="xs" fw={500}>
                            {pkg.itemCode}
                          </Text>
                          <Text size="xs" c="dimmed" lineClamp={1}>
                            {pkg.itemName}
                          </Text>
                        </Menu.Item>
                      ))}
                      <Menu.Divider />
                      <Menu.Item
                        leftSection={<IconPencil size={14} color="#2563eb" />}
                        onClick={() => {
                          setSelectedWarrantyRow(warrantyPackagesInCart[0]);
                          setWarrantyModalOpened(true);
                        }}
                      >
                        <Text size="xs">Chia suất chi tiết...</Text>
                      </Menu.Item>
                    </Menu.Dropdown>
                  </Menu>
                )}
              </Flex>
            );
          }
          if (isWarrantyItem(row.original)) {
            const summary = getWarrantyAllocationSummary(
              listAdd,
              row.original
            );
            const oldSerials = getExternalSerialsForWarranty(row.original);
            return (
              <Flex align="center" gap={4}>
                {/* Chữ dài thì xuống dòng thay vì bị cắt; rê chuột xem serial máy cũ */}
                <Badge
                  size="xs"
                  variant="light"
                  color="indigo"
                  tt="none"
                  // Bấm được cả khi đơn đã chốt / đang xem (bảng bị khoá pointerEvents), hộp chia suất mở ở chế độ chỉ xem
                  style={{ cursor: "pointer", pointerEvents: "auto" }}
                  styles={{ root: { height: "auto", paddingBlock: 2 }, label: { whiteSpace: "normal" } }}
                  onClick={() => {
                    setSelectedWarrantyRow(row.original);
                    setWarrantyModalOpened(true);
                  }}
                  title={
                    oldSerials.length > 0
                      ? `Serial máy cũ: ${oldSerials.join(", ")}\nBấm để mở hộp thoại chia suất`
                      : "Bấm để mở hộp thoại chia suất"
                  }
                >
                  {summary}
                </Badge>
                <Tooltip label="Chia suất bảo hành cho các máy">
                  <ActionIcon
                    size="xs"
                    variant="subtle"
                    color="blue"
                    style={{ pointerEvents: "auto" }}
                    onClick={() => {
                      setSelectedWarrantyRow(row.original);
                      setWarrantyModalOpened(true);
                    }}
                  >
                    <IconPencil size={14} />
                  </ActionIcon>
                </Tooltip>
              </Flex>
            );
          }
          return (
            <Text size="xs">
              {renderedCellValue ? `${renderedCellValue}` : ""}
            </Text>
          );
        },
      },
      {
        accessorKey: "priceOnPriceList",
        header: "Giá bán",
        enableEditing: false,
        enableSorting: false,
        size: 120,
        Cell: ({ row }) => {
          // if (location?.state?.isReadOnly) {
          if (false) {
            // Trạng thái chỉ đọc, không hiển thị gì
            return null;
          }

          if (row.original.lineTyle === "DV") {
            return (
              <Flex direction="column" gap="sm" rowGap={1}>
                <Flex align="center">
                  <NumberInput
                    size="sm"
                    placeholder="Nhập giá"
                    value={row.original.priceOnPriceList}
                    onChange={(value) => {
                      if (value !== null) {
                        // Giới hạn giá trị tối đa là 100 triệu
                        const newValue = Math.min(
                          Number(value) || 0,
                          100000000,
                        );
                        setListAdd((prevData) =>
                          prevData.map((item, i) =>
                            i === row.index
                              ? {
                                  ...item,
                                  priceFinal: newValue * item?.quality,
                                  priceOnPriceList: newValue,
                                }
                              : item,
                          ),
                        );
                      }
                    }}
                    onKeyDown={(event) => {
                      // Ngăn không cho nhập '-' và 'e'
                      if (
                        event.key === "-" ||
                        event.key === "e" ||
                        event.key === "E"
                      ) {
                        event.preventDefault();
                      }
                    }}
                    hideControls
                    max={100000000} // Thiết lập giá trị tối đa
                    thousandSeparator="."
                    decimalSeparator=","
                    styles={{
                      input: {
                        height: "30px",
                        fontSize: "14px",
                        padding: "4px",
                      },
                    }}
                  />
                </Flex>
              </Flex>
            );
          } else {
            return (
              <Flex direction="column">
                <NumberFormatter
                  value={row.original.priceOnPriceList}
                  thousandSeparator="."
                  decimalSeparator=","
                />
              </Flex>
            );
          }
        },
      },

      {
        header: "KM",
        enableEditing: false,
        enableSorting: false,
        size: 120,
        Cell: ({ row }) => {
          const [customDiscount, setCustomDiscount] = React.useState<
            number | null
          >(row.original.discountAmount || null);

          // Hàm mở modal CTKM
          const openCTKMModal = () => {
            modals.openConfirmModal({
              title: <Title order={5}>Thông tin CTKM</Title>,
              size: "800px", // Tăng kích thước từ 500px lên 800px
              children: (
                <CTKMModalContent
                  row={row}
                  customDiscount={customDiscount}
                  setCustomDiscount={setCustomDiscount}
                  setListAdd={setListAdd}
                  location={location}
                />
              ),
              confirmProps: { display: "none" },
              cancelProps: { display: "none" },
            });
          };

          const calculatedDiscount =
            customDiscount ??
            (row.original.discountRate
              ? -(
                  (row.original.discountRate * row.original.priceOnPriceList) /
                  100
                )
              : -(row.original.discountAmount || 0));

          return (
            <Flex
              direction="column"
              align="center"
              style={{
                padding: "4px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                backgroundColor: "#f9f9f9",
                gap: "4px",
              }}
            >
              {/* Hiển thị label và giá trị giảm */}
              <Flex
                direction="row"
                align="center"
                justify="center"
                style={{ gap: "4px" }}
              >
                <Box
                  style={{
                    fontSize: "10px",
                    fontWeight: 600,
                    color: "#666",
                    textAlign: "center",
                  }}
                >
                  Giảm CTKM:
                </Box>
                <Box
                  style={{
                    color: "red",
                    fontWeight: 600,
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                >
                  <NumberFormatter
                    value={Math.abs(calculatedDiscount)}
                    thousandSeparator="."
                    decimalSeparator=","
                  />
                </Box>
              </Flex>

              {/* Button mở modal - chỉ hiển thị khi không phải approved */}
              {location?.state?.actionType !== "approved" && (
                <Button
                  size="xs"
                  variant="light"
                  color="blue"
                  onClick={openCTKMModal}
                  style={{
                    fontSize: "10px",
                    height: "24px",
                    padding: "2px 8px",
                    pointerEvents: "auto", // Cho phép click ngay cả khi ở mode view
                  }}
                >
                  Giảm tự nhập
                </Button>
              )}

              {/* Hiển thị status CTKM */}
              {(row.original.attribute33 || row.original.attribute34) && (
                <Box
                  style={{
                    fontSize: "9px",
                    color: "green",
                    textAlign: "center",
                    fontWeight: 500,
                  }}
                >
                  ✓ Đã có CTKM
                </Box>
              )}
            </Flex>
          );
        },
      },

      {
        accessorKey: "discount",
        header: "Xin giảm",
        enableEditing: false,
        enableSorting: false,
        size: 180,
        Cell: ({ renderedCellValue, row }) => {
          // Tạo hàm debounce với Mantine
          const debouncedHandleChange = useDebouncedCallback(
            (value) => {
              handleChangeRequestReduction(
                value,
                row.original.id,
                row?.original?.priceOnPriceList,
              );
            },
            500, // 300ms là thời gian debounce
          );

          return (
            <Flex gap="xs" align="center">
              <NumberInput
                disabled
                style={{ height: 35, flex: 1 }}
                size="sm"
                fw={"500"}
                hideControls
                thousandSeparator="."
                decimalSeparator=","
                value={row.original?.discountAdded}
                onChange={(e) => {
                  debouncedHandleChange(e);
                }}
                min={1}
                max={1000000000}
                clampBehavior="strict"
                onKeyDown={handleKeyDown}
                allowDecimal={false}
                allowNegative={false}
                placeholder={
                  !canApplyCustomDiscount(row.original) ? "Cần nhập CTKM" : ""
                }
              />
              {location?.state?.actionType === "approved" &&
              orderStatus === "DON_HANG_CHO_DUYET_GIAM" ? (
                row.original?.priceOnPriceList > 0 ? (
                  <Flex gap="xs">
                    <Tooltip label="Chọn mức giảm giá">
                      <ActionIcon
                        variant="outline"
                        color="blue"
                        size="sm"
                        onClick={() => handleOpenDiscountSelection(row)}
                        disabled={!row.original?.itemCode}
                        style={{ pointerEvents: "auto" }}
                      >
                        <IconSettings size={14} />
                      </ActionIcon>
                    </Tooltip>
                    <Tooltip label="Bỏ xin giảm">
                      <ActionIcon
                        variant="outline"
                        color="red"
                        size="sm"
                        onClick={() => handleResetDiscount(row)}
                        disabled={
                          !row.original?.itemCode ||
                          !row.original?.discountAdded
                        }
                        style={{ pointerEvents: "auto" }}
                      >
                        <IconRefresh size={14} />
                      </ActionIcon>
                    </Tooltip>
                  </Flex>
                ) : (
                  <div style={{ width: 56, height: 28 }} />
                )
              ) : null}
            </Flex>
          );
        },
      },
      {
        accessorKey: "priceFinal",
        header: "Thành tiền",
        size: 80,
        enableEditing: false,
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => {
          // if (location?.state?.isReadOnly) {
          if (false) {
            // Trạng thái chỉ đọc, không hiển thị gì
            return null;
          }

          const { priceFinal, quality } = row.original;
          // Đảm bảo không có giá âm
          const displayedPrice = Math.max(priceFinal * quality, 0);

          return (
            <>
              <NumberFormatter
                value={displayedPrice}
                thousandSeparator="."
                decimalSeparator=","
              />
            </>
          );
        },
      },

      {
        accessorKey: "attribute28", // Khóa để truy cập dữ liệu
        header: location?.state?.fromTMDTList
          ? "Phí sàn phân bổ"
          : "KM phân bổ", // Tiêu đề của cột thay đổi theo nguồn
        enableEditing: false, // Không cho phép chỉnh sửa
        enableSorting: false, // Tắt sắp xếp
        size: 80, // Độ rộng của cột
        Cell: ({ row }) => {
          return (
            <NumberFormatter
              value={Math.round(Number(row?.original?.attribute28) || 0) || ""}
              thousandSeparator="."
              decimalSeparator=","
            />
          ); // Hiển thị giá trị
        },
      },
      // {
      //   accessorKey: "attribute29", // Khóa để truy cập dữ liệu
      //   header: "Xin giảm phân bổ", // Tiêu đề của cột
      //   enableEditing: false, // Không cho phép chỉnh sửa
      //   enableSorting: false, // Tắt sắp xếp
      //   size: 80, // Độ rộng của cột
      //   Cell: ({ row }) => {
      //     return (
      //       <NumberFormatter
      //         value={Math.round(Number(row?.original?.attribute29) || 0) || ""}
      //         thousandSeparator="."
      //         decimalSeparator=","
      //       />
      //     );
      //   },
      // },
      {
        accessorKey: "attribute35", // Thành tiền sau bổ
        header: "Thành tiền sau bổ", // Tiêu đề của cột
        enableEditing: false, // Không cho phép chỉnh sửa
        enableSorting: false, // Tắt sắp xếp
        size: 80, // Độ rộng của cột
        Cell: ({ row }) => {
          return (
            <NumberFormatter
              value={Math.round(Number(row?.original?.attribute35) || 0) || ""}
              thousandSeparator="."
              decimalSeparator=","
            />
          );
        },
      },
      {
        accessorKey: "note",
        header: "Ghi chú",
        enableSorting: false,
        enableEditing: false,
        size: 120,
        Cell: ({ row }) => (
          <TextInput
            value={row.original.note || ""}
            onChange={(event) => {
              setListAdd((prevData) =>
                prevData.map((item, i) =>
                  i === row.index
                    ? { ...item, note: event.target.value }
                    : item,
                ),
              );
            }}
          />
        ),
      },
      {
        accessorKey: "attribute16",
        header: "Chứng từ DV",
        enableEditing: false,
        enableSorting: false,
        size: 120,
        Cell: ({ row }) => (
          <TextInput
            disabled={row.original.lineTyle !== "DV"}
            value={row.original.attribute16 || ""}
            onChange={(event) => {
              setListAdd((prevData) =>
                prevData.map((item, i) =>
                  i === row.index
                    ? { ...item, attribute16: event.target.value }
                    : item,
                ),
              );
            }}
          />
        ),
      },
      {
        accessorKey: "attribute17",
        header: "Giá DV",
        enableEditing: false,
        enableSorting: false,
        size: 120,
        Cell: ({ row }) => (
          <NumberInput
            disabled={row.original.lineTyle !== "DV"}
            value={row.original.attribute17 || 0} // Giá trị mặc định
            onChange={(value) => {
              setListAdd((prevData) =>
                prevData.map((item, i) =>
                  i === row.index
                    ? { ...item, attribute17: Number(value) } // Đảm bảo giá trị là số
                    : item,
                ),
              );
            }}
            thousandSeparator="."
            decimalSeparator=","
            hideControls
            min={0}
            step={1000}
            placeholder="Nhập số tiền"
          />
        ),
      },
      {
        accessorKey: "attribute15",
        header: "LK giàn",
        enableSorting: false,
        enableEditing: false,
        size: 100,
        Cell: ({ row }) => (
          <Checkbox
            checked={row?.original?.attribute15 === "1"}
            onChange={(event) => {
              const isChecked = event.currentTarget.checked;
              setListAdd((prevData) =>
                prevData.map((item, i) =>
                  i === row.index
                    ? { ...item, attribute15: isChecked ? "1" : "0" }
                    : item,
                ),
              );
            }}
          />
        ),
      },
    ];
  }, [
    listAdd,
    dataProducts,
    isCreating,
    orderHeader?.discountAddedTotal,
    canApplyCustomDiscount,
    isHaveShiping,
  ]);

  const table = useMantineReactTable<dataOrderDetailTable>({
    columns,
    data: listAdd,
    displayColumnDefOptions: {
      "mrt-row-actions": {
        header: "Thao tác",
      },
    },
    positionToolbarAlertBanner: "bottom",
    createDisplayMode: "row",
    editDisplayMode: "cell",
    enableEditing: !orderHeader?.attribute39 && !isHaveShiping, // Disable editing when voucher is applied or shipping info is saved
    enableRowActions: true,
    enableColumnActions: false,
    enableColumnOrdering: false,
    enableTopToolbar: false,
    enableBatchRowSelection: true,
    positionActionsColumn: "last",
    enableExpandAll: false,

    renderRowActions: ({ row, table }) => (
      <Flex gap="4">
        {!row?.original?.attribute11 &&
          !orderHeader?.attribute39 &&
          !isHaveShiping && (
            <>
              <Tooltip label="Chọn chính sách khuyến mãi">
                <ActionIcon
                  color={orange.base}
                  variant="outline"
                  disabled={
                    row.original?.listIdPromotion?.length < 1 ||
                    !row.original?.listIdPromotion?.length ||
                    row?.original?.lineTyle === "DV"
                  }
                  onClick={async () => {
                    openFormVoucher(row);
                  }}
                >
                  <IconDiscount
                    style={{
                      color:
                        row.original?.listIdPromotion?.length < 1 ||
                        !row.original?.listIdPromotion?.length ||
                        row?.original?.lineTyle === "DV"
                          ? "gray"
                          : orange.base,
                    }}
                  />
                </ActionIcon>
              </Tooltip>
              <Tooltip label="Xoá sản phẩm">
                <ActionIcon variant="outline" color="red">
                  <IconTrash onClick={() => openDeleteConfirmModal(row)} />
                </ActionIcon>
              </Tooltip>
            </>
          )}
        {/* Show disabled message when voucher is applied */}
        {orderHeader?.attribute39 && (
          <Tooltip label="Đã áp voucher - không thể chỉnh sửa" withArrow>
            <ActionIcon
              variant="subtle"
              color="red"
              style={{ cursor: "not-allowed" }}
            >
              <IconBan size={20} color="red" />
            </ActionIcon>
          </Tooltip>
        )}
        {/* Show disabled message when shipping info is saved */}
        {isHaveShiping && !orderHeader?.attribute39 && (
          <Tooltip label="Đã lưu thông tin giao hàng - không thể chỉnh sửa" withArrow>
            <ActionIcon
              variant="subtle"
              color="red"
              style={{ cursor: "not-allowed" }}
            >
              <IconBan size={20} color="red" />
            </ActionIcon>
          </Tooltip>
        )}
      </Flex>
    ),
    renderTopToolbarCustomActions: ({ table }) => (
      <>
        <Flex
          gap="md"
          justify="flex-start"
          align="center"
          direction="row"
          wrap="wrap"
          mb={"xs"}
          style={{ opacity: 0 }}
        ></Flex>
      </>
    ),
    renderToolbarInternalActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localizationSales,
    getRowId: (row) => row.id?.toString(),
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    initialState: {
      expanded: true,
      columnPinning: {
        left: ["mrt-row-select", "mrt-row-expand"],
        right: ["mrt-row-actions"],
      },
      columnVisibility: { id: true },
      density: "xs",
    },

    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualSorting: false,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        ...styleCellTable(row),
        ...getStyle(true),
      },
    }),
    mantineTableBodyRowProps: ({ row }) => ({
      style: {
        backgroundColor: handleCheckBackgroundColor(
          row?.original?.attribute11 || "",
        ),
      },
      onContextMenu: (e: React.MouseEvent) => {
        e.preventDefault(); // chặn menu mặc định
        setCtxPos({ x: e.clientX, y: e.clientY });
        setCtxRowData(row.original); // đây là dữ liệu row bạn cần
        setCtxOpen(true);
      },
    }),
    enablePagination: false,
    enableBottomToolbar: false,
    state: {
      showAlertBanner: isError,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    enableColumnPinning: true,
    mantineTableProps: {},
  });

  //#region useEffect

  useHotkeys([
    ["mod+J", () => console.log("Toggle color scheme")],
    [
      "ctrl+F5",
      () => {
        //  openNew();
      },
    ],
    [
      "F5",
      () => {
        //  openNew();
      },
    ],
    ["alt+mod+shift+X", () => console.log("Rick roll")],
    [
      "F11",
      () => {
        // openNew(true);
      },
    ],
    ["ctrl+M", () => toggleCollapse()],
  ]);

  useEffect(() => {
    const total = [cardPayment, cashPayment, vnpayPayment, bankTransfer]
      .filter((value) => value > 0) // Filter out values that are 0 or less
      .reduce((acc, curr) => acc + curr, 0); // Sum up the remaining values

    setTotalPaid(total);
  }, [cardPayment, cashPayment, vnpayPayment, bankTransfer]);

  // Fetch user auth when component mounts
  useEffect(() => {
    const fetchUserAuth = async () => {
      try {
        const authData = await apiAuth.getUserAuth();
        setUserAuth(authData?.data);
      } catch (error) {
        console.error("Error fetching user auth:", error);
        setUserAuth(null);
      }
    };

    fetchUserAuth();
  }, []);

  useEffect(() => {
    if (selectedWarehouse?.branchId) {
      setBranchId(selectedWarehouse?.branchId);
      const name = listBranch?.find(
        (item: any) => item?.value == selectedWarehouse?.branchId,
      );
      setBranchName(name?.text);
      const updatedList = listAdd.map((item) => ({
        ...item, // Giữ nguyên tất cả các field hiện tại
        attribute23: selectedWarehouse.subInvCode,
        warehouse: selectedWarehouse.branchName,
        subInvId: selectedWarehouse.subInvId,
        // Đặc biệt giữ nguyên discountAdded để không bị reset về 0
      }));

      setListAdd(updatedList);
    }
  }, [selectedWarehouse, listBranch]);

  useEffect(() => {
    if (dataAllocate?.length > 0) {
      setListAdd((prevListAdd) => {
        return prevListAdd.map((item) => {
          const hasSameProductPaidRow = prevListAdd.some(
            (otherItem) =>
              otherItem !== item &&
              otherItem.itemId === item.itemId &&
              otherItem.itemCode === item.itemCode &&
              (otherItem.priceFinal || 0) > 0,
          );

          const isGiftDuplicateWithPaidRow =
            item.lineTyle === "KM" &&
            (item.priceFinal || 0) <= 0 &&
            hasSameProductPaidRow;

          if (isGiftDuplicateWithPaidRow) {
            return {
              ...item,
              attribute28: "0",
              attribute29: "0",
              attribute35: "0",
            };
          }

          const matchedAllocation: any = dataAllocate.find(
            (allocation: any) => allocation.itemId === item.itemId,
          );

          if (matchedAllocation) {
            const priceAfterAllocation =
              (item.priceFinal -
                matchedAllocation?.priceAllKM -
                matchedAllocation?.priceAll) *
              item.quality;

            return {
              ...item,
              attribute28: matchedAllocation?.priceAllKM,
              attribute29: matchedAllocation?.priceAll,
              attribute35: priceAfterAllocation.toString() || "", // Thành tiền sau khi phân bổ
            };
          }

          return item;
        });
      });
    }
  }, [dataAllocate]);

  useEffect(() => {
    setDeferredPayment(payableAmount - totalPaid);
  }, [payableAmount, totalPaid]);

  useEffect(() => {
    const fetchDataCreate = async () => {
      const url = `/api/v1/CreateSellItem/create?codePrefix=DH`;
      try {
        const response = await repositoryPos.get<MessageResponse<any>>(url);
        if (response && response?.success && !orderHeader?.orderNumber) {
          setOrderHeader(response.data.orderHeader);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (orderHeader?.orderNumber || isFetchDataCalledRef.current) return;

    if (
      location?.state?.actionType !== "view" &&
      location?.state?.actionType !== "payment" &&
      location?.state?.actionType !== "edit" &&
      location?.state?.actionType !== "approved" &&
      location?.state?.actionType !== "doi"
    ) {
      fetchDataCreate();
      isFetchDataCalledRef.current = true; // Đặt flag để tránh gọi lại
    }
  }, [orderHeader, location?.state]);

  useEffect(() => {
    if (branchId && branchName) return;
    setBranchId(orderHeader?.orgId || 0);
    const name = listBranch?.find(
      (item: any) => item?.value == orderHeader?.orgId,
    );
    setBranchName(name?.text);
  }, [orderHeader, listBranch]);

  useEffect(() => {
    const handleCheckPayableAmount = (listAdd: any[]) => {
      let priceTotal = 0;

      if (location?.state?.actionType === "doi") {
        listAdd?.forEach((item) => {
          if (item?.attribute14 || item?.attribute2) {
            // Tính giá sản phẩm và cộng thêm attribute11 và attribute12
            const itemPrice =
              (item?.priceOnPriceList || 0) * (item?.quality || 0);
            const additionalAmount =
              (parseFloat(item?.attribute5) || 0) +
              (parseFloat(item?.attribute12) || 0);
            priceTotal += itemPrice + additionalAmount;
          }
        });
      } else {
        listAdd?.forEach((item) => {
          priceTotal += (item?.priceOnPriceList || 0) * (item?.quality || 0);
        });
      }

      return priceTotal;
    };
    setListSerial(handleRenderOptionListAdd(listAdd));
    let priceTotal = handleCheckPayableAmount(listAdd);

    setTotalAmount(priceTotal);
    let totalXGDetail = listAdd.reduce((acc, item) => {
      const discountAdded = item.discountAdded || 0; // Lấy giá trị xin giảm, mặc định là 0 nếu không có
      return acc + discountAdded * (item.quality || 1); // Cộng dồn vào tổng, nhân với số lượng
    }, 0);
    const totalDiscount = listAdd.reduce((acc, item) => {
      const discountAmount = item.discountAmount || 0; // Lấy giá trị giảm giá, mặc định là 0 nếu không có
      return acc + discountAmount * (item.quality || 1); // Cộng dồn vào tổng, nhân với số lượng
    }, 0);

    const totalDiscountRate = listAdd.reduce((acc, item) => {
      const discountRate = item.discountRate || 0; // Giá trị phần trăm giảm giá
      const price = item.priceOnPriceList || 0; // Giá của sản phẩm
      const quality = item.quality || 1; // Số lượng sản phẩm
      const discountValue = (discountRate / 100) * price * quality; // Tính giá trị giảm giá
      return acc + discountValue; // Cộng dồn vào tổng
    }, 0);

    setTotalXGDetail(totalXGDetail); // Cập nhật tổng xin giảm
    setTotalKM(
      totalDiscount +
        totalDiscountRate +
        (orderHeader?.amountDiscountTotal || 0),
    );
    setTotalKMLine(totalDiscount + totalDiscountRate);
    const shouldUseStoredDeliveryFee = ["view", "payment", "approved"].includes(
      location?.state?.actionType || "",
    );
    const deliveryFee =
      listAdd.length > 0
        ? shouldUseStoredDeliveryFee
          ? Number(orderHeader?.attributeValue3) || 0
          : Number(dataDeliveryInformation?.deliveryFee) ||
            Number(orderHeader?.attributeValue3) ||
            0
        : 0;
    console.log("LoggdeliveryFee", deliveryFee);
    setPayableAmount(
      (priceTotal ?? 0) -
        (totalDiscount ?? 0) -
        (totalDiscountRate ?? 0) -
        (orderHeader?.amountDiscountTotal ?? 0) -
        (totalXGDetail ?? 0) -
        (orderHeader?.discountAddedTotal ?? 0) +
        deliveryFee,
    );
  }, [
    listAdd,
    orderHeader,
    location?.state?.actionType,
    dataDeliveryInformation?.deliveryFee,
  ]);

  // hàm lấy data ban đầu
  useEffect(() => {
    const userLogin = localStorage.getItem("userLogin");

    if (userLogin) {
      const userLoginObject = JSON.parse(userLogin);
      // gán người thanh toán chính là người bấm nút hoàn thành
      setUserLogin(userLoginObject);
    }

    const fetchDataBranch = async () => {
      const response = await repositoryPos.get<
        MessageResponse<TblDMPaymentMethod[]>
      >("/api/v1/TblDmInventory/get-select-branch?auth=false");

      if (response && response.success) {
        let result = response.data
          .filter(
            (i: any) =>
              String(i.att2) !== "99" &&
              !String(i.text).includes("Văn phòng 124 Minh Khai")
          )
          .map((i: any) => ({
            ...i,
            text: `${[i.att2, i.text]
              .filter((i) => i && String(i).length > 0)
              .map((i) => i?.trim())
              .join(" - ")}`,
          }));

        result.sort((a, b) => {
          if (!a.att2 && !b.att2) return 0;
          if (!a.att2) return -1;
          if (!b.att2) return 1;

          const valA = a.att2!;
          const valB = b.att2!;

          if (typeof valA === "string" && typeof valB === "string") {
            return valA.localeCompare(valB);
          }

          return valA < valB ? -1 : valA > valB ? 1 : 0;
        });

        setListBranch(result);
      }
    };

    const fetchDataSaleChanelId = async () => {
      const response = await repositoryMdm.get<MessageResponse<any[]>>(
        "/api/v1/TblDmSaleChanel/get-all",
      );

      if (response && response.success) {
        let result = response.data;
        setSaleChanelList(result);
      }
    };

    const fetchAllDepartment = async () => {
      const response = await repositoryPos.get<
        MessageResponse<DepartmentModel[]>
      >(`/api/v1/TblDepartment/get-all`);

      if (response && response.success) {
        let result = response.data;
        setListDepartment(result);
      } else {
      }
    };

    Promise.all([
      fetchDataSaleChanelId(),
      fetchAllDepartment(),
      fetchDataBranch(),
    ]);
  }, []);

  const [searchTrigger, setSearchTrigger] = useState(0);

  useEffect(() => {
    const fetchItemSell = async () => {
      const keySearch = valueDebounced.toLowerCase();
      const url =
        modeSearch === "SP"
          ? `/api/v1/TblItem/search-sell?inv=${branchId}&key=${keySearch}`
          : `/api/v1/TblItem/search-sell-service?inv=${branchId}&key=${keySearch}`;
      try {
        const searchResult =
          await repositoryPos.get<MessageResponse<ProductModel[]>>(url);
        if (searchResult?.data) {
          setDataProducts(searchResult.data);
        } else {
          setDataProducts([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setDataProducts([]);
      }
    };

    if (valueDebounced && valueDebounced.length > 2) {
      fetchItemSell();
    } else {
      setDataProducts([]);
    }
  }, [valueDebounced, branchId, modeSearch, searchTrigger]);

  const handleSearch = () => {
    setSearchTrigger((prev) => prev + 1); // Kích hoạt lại useEffect
  };

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (270 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  // Noti nếu thanh toán trước hơn thanh toán sau
  useEffect(() => {
    if (
      deferredPayment < 0 &&
      totalAmount !== 0 &&
      location?.state?.actionType !== "doi"
    ) {
      NotificationExtension.Warn(
        "Số tiền thanh toán lớn hơn tổng số tiền cần thanh toán của đơn!",
      );
    }
  }, [deferredPayment]);

  // //region logic chọn chi nhánh
  // useEffect(() => {
  //   const fetchDepartmentByBanchId = async () => {
  //     if (branchId) {
  //       const response = await repositoryPos.get<MessageResponse<any>>(
  //         `/api/v1/TblDepartment/get-all?branchId=${branchId}`
  //       );
  //       if (response && response.success) {
  //         let result = response.data;
  //         setListDepartment(result);
  //       }
  //     }
  //   };
  //   fetchDepartmentByBanchId();
  // }, [branchId]);

  useEffect(() => {
    const fetchEmployeeByDepartmentId = async () => {
      const response = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/TblDmEmployee/get-all`,
      );
      if (response && response.success) {
        let result = response.data;
        setListEmployeeSales(result);
      }
    };
    fetchEmployeeByDepartmentId();
  }, []);

  //region  logic sửa đơn hàng

  const fetchDetailSaleChanel = async (SaleChanelId: number) => {
    if (SaleChanelId) {
      const response = await repositoryMdm.get<MessageResponse<any>>(
        `/api/v1/TblDmSaleChanel/update?id=${SaleChanelId}`,
      );
      if (response && response.success) {
        let result = response.data;
        setSaleChanel(result?.name);
      }
    }
  };

  const fetchDelivery = async (data: string) => {
    try {
      const parsedData = data ? JSON.parse(data) : null;
      setDataDeliveryInformation((prev: any) => ({
        ...prev,
        branchId: parsedData?.branchId,
        customerAddress: parsedData?.customerAddress,
        customerCommuneId: parsedData?.customerCommuneId,
        customerDistrictId: parsedData?.customerDistrictId,
        customerId: parsedData?.customerId,
        customerName: parsedData?.customerName,
        customerProvinceId: parsedData?.customerProvinceId,
        depId: parsedData?.depId,
        sourceType: parsedData?.sourceType,
        telephoneNumber: parsedData?.telephoneNumber,
        deliveryAppointmentTime: parsedData?.deliveryAppointmentTime
          ? new Date(parsedData.deliveryAppointmentTime)
          : new Date(),
        deliveryFee: parsedData?.deliveryFee,
        timeDelivery: parsedData?.timeDelivery,
        timeDeliveryTime: parsedData?.timeDeliveryTime,
        weight: parsedData?.weight,
        width: parsedData?.width,
        length: parsedData?.length,
        height: parsedData?.height,
        feeShip: parsedData?.feeShip,
        description: parsedData?.description,
        status: parsedData?.status,
        typeShip: parsedData?.typeShip,
        // shippingVendor may be stored inside attribute1 JSON or in orderHeader.shipingVendor
        shippingVendor:
          parsedData?.shippingVendor ??
          parsedData?.shipingVendor ??
          orderHeader?.shipingVendor ??
          "",
        to_address: parsedData?.to_address,
        distance: parsedData?.distance,
        to_addressid: parsedData?.to_addressid,
        transportName: parsedData?.transportName,
        listAddress: parsedData?.listAddress || [],
        itemNotes: parsedData?.itemNotes,
        itemNotesName: parsedData?.itemNotesName,
        isOffice124: parsedData?.isOffice124,
        senderPhone: parsedData?.senderPhone,
        pick_address: parsedData?.pick_address,
        pick_tel: parsedData?.pick_tel,
        fromAddress: parsedData?.fromAddress,
        pick_province: parsedData?.pick_province,
        pick_district: parsedData?.pick_district,
        pick_ward: parsedData?.pick_ward,
      }));

      // Set isHaveShiping = true nếu đã có thông tin giao hàng (có customerId)
      if (parsedData?.customerId) {
        setIsHaveShipping(true);
      }
    } catch (error) {
      console.error("JSON parsing failed:", error);
    }
  };

  // thêm logic bo phan sẽ ăn theo người hưởng số
  useEffect(() => {
    const foundEmployee = listEmployeeSales.find(
      (emp) => emp.id === Number(employeeSalesRevenueId),
    );

    if (foundEmployee?.departmentId) {
      setDepartmentId(foundEmployee?.departmentId);
      // Tìm kiếm bộ phận
      const departmentName = listDepartment.find((item) => {
        return item.departmentId === foundEmployee.departmentId;
      });

      if (departmentName?.name) {
        setDepartment(departmentName.name);
      } else {
        console.log("No department found or no name property");
      }
    }
  }, [employeeSalesRevenueId, listEmployeeSales, listDepartment]);
  useEffect(() => {
    if (
      !location?.state ||
      location?.state?.actionType === "view" ||
      location?.state?.actionType === "doi"
    )
      return;
    const fetchDataPaymentMethod = async () => {
      if (location.state?.orderNumber) {
        const url =
          location?.state?.actionType === "approved"
            ? `/api/v1/CreateSellItem/approve?orderNumber=${location.state?.orderNumber}`
            : location?.state?.actionType === "edit"
              ? `/api/v1/CreateSellItem/edit?orderNumber=${location.state?.orderNumber}`
              : `/api/v1/CreateSellItem/payment?orderNumber=${location.state?.orderNumber}`;

        const response = await repositoryPos.get<MessageResponse<any>>(url);

        if (response && response.success) {
          let result = response.data;
          setOrderHeader({ ...result.orderHeader });
          setOrderStatus(result?.orderHeader?.orderStatus);
          setBranchId(result?.orderHeader?.orgId);
          setShipingVendor(result?.orderHeader?.shipingVendor);
          const branchName = listBranch?.find(
            (item: any) => item?.id == result?.orderHeader?.orgId,
          );

          // Kiểm tra nếu branchName tồn tại trước khi set
          if (branchName) {
            setBranchName(branchName?.text);
          }
          if (!result?.orderDetail) return;
          setListAdd(fromStoredWarranty(result.orderDetail));
          // Load email list from attribute53
          if (result?.orderHeader?.attribute53) {
            setVatEmailList(result.orderHeader.attribute53);
          }
          // Load tax info from attribute57
          if (result?.orderHeader?.attribute57) {
            try {
              const parsedTaxInfo = JSON.parse(result.orderHeader.attribute57);
              setTaxInfo(parsedTaxInfo);
            } catch (error) {
              console.error("Error parsing attribute57:", error);
            }
          }
        }
      }
    };
    fetchDataPaymentMethod();
  }, [location, listBranch]);

  useEffect(() => {
    if (!location?.state) return;

    const handleFetchDataCustomer = async () => {
      const customerId =
        location?.state?.actionType === "doi"
          ? orderHeaderRef?.custId
          : orderHeader?.custId;

      if (customerId) {
        const customerReturn = await repositoryPos.get<MessageResponse<any>>(
          `/api/v1/TblDmCustomer/get-detail?id=${customerId}`,
        );

        setCustomerCheck((prev) => ({
          ...prev,
          active: customerReturn?.data?.active ?? false,
          address: customerReturn?.data?.address ?? "",
          birthOfDate: customerReturn?.data?.birthOfDate ?? null,
          code: customerReturn?.data?.code ?? "",
          contact: customerReturn?.data?.contact ?? "",
          description: customerReturn?.data?.description ?? "",
          email: customerReturn?.data?.email ?? "",
          fax: customerReturn?.data?.fax ?? "",
          groupId: customerReturn?.data?.groupId ?? 0,
          id: customerReturn?.data?.id ?? 0,
          name: customerReturn?.data?.name ?? "",
          companyName: customerReturn?.data?.companyName ?? "",
          sex: customerReturn?.data?.sex ?? null,
          taxCode: customerReturn?.data?.taxCode ?? "",
          telephoneNumber: customerReturn?.data?.telephoneNumber ?? "",
          type: customerReturn?.data?.type ?? 0,
          attribute1: customerReturn?.data?.attribute1 ?? "",
          attribute4: customerReturn?.data?.attribute4 ?? "",
          // debtLimit: customerReturn?.data?.debtLimit ?? 0,
          // debtTerm: customerReturn?.data?.debtTerm ?? 0,
        }));
      }
    };

    handleFetchDataCustomer();
  }, [orderHeader, location?.state, orderHeaderRef]);

  useEffect(() => {
    if (location?.state && !location?.state?.orderNumberOld) {
      fetchDetailSaleChanel(orderHeader?.saleChanelId);
      setContractcode(orderHeader?.contractcode);
      fetchDelivery(orderHeader?.attribute1 || "");
      setShipping(orderHeader?.shipngType);
      setAccountantId(orderHeader?.attribute2 || 0);
      handleGetNameAccountantById(orderHeader?.attribute2);
    }
  }, [orderHeader, location]);

  useEffect(() => {
    const fetchDepartment = async (DeptId: number) => {
      setDepartmentId(DeptId);
      const DeptName = listDepartment.find((item) => {
        return item.departmentId === DeptId;
      });
      if (DeptName?.name) {
        setDepartment(DeptName?.name || "");
      }
    };

    const fetchDetailEmployeeSales = async (
      SaleId: number,
      attribute18?: string,
    ) => {
      if (SaleId && SaleId != 0) {
        const response = await repositoryPos.get<MessageResponse<any>>(
          `/api/v1/TblDmEmployee/detail-employee?id=${SaleId}`,
        );
        if (response && response.success) {
          let result = response.data;
          setEmployeeSalesId(SaleId.toString());
          setEmployeeSalesName(result?.fullName);
          if (
            location?.state?.actionType !== "payment" &&
            location?.state?.actionType !== "approved" &&
            location?.state?.actionType !== "view" &&
            location?.state?.actionType !== "edit"
          ) {
            setEmployeeSalesRevenueId(SaleId.toString());
            setEmployeeSalesRevenueName(result?.fullName);
          } else {
            if (attribute18 && attribute18 != "0") {
              const response = await repositoryPos.get<MessageResponse<any>>(
                `/api/v1/TblDmEmployee/detail-employee?id=${attribute18}`,
              );
              if (response && response.success) {
                let resultRevenue = response.data;
                setEmployeeSalesRevenueId(attribute18 || "");
                setEmployeeSalesRevenueName(resultRevenue?.fullName);
              }
            }
          }
        }
      }
    };
    fetchDepartment(orderHeader?.deptId);
    fetchDetailEmployeeSales(orderHeader?.saleId, orderHeader?.attribute18);
  }, [
    orderHeader?.deptId,
    orderHeader?.saleId,
    listDepartment,
    location,
    orderHeader?.attribute18,
  ]);

  // logic xem đơn
  useEffect(() => {
    const handleViewSalesOrder = async () => {
      if (
        location?.state?.actionType === "payment" ||
        location?.state?.actionType === "approved"
      ) {
        const url = `/api/v1/CreateSellItem/details?orderNumber=${location.state.orderNumber}`;
        const response = await repositoryPos.get<MessageResponse<any>>(url);
        if (response && response?.success) {
          if (response?.data?.orderHeader?.shipingVendor) {
            setShipingVendor(response?.data?.orderHeader?.shipingVendor);
          }
        }
      }

      if (location?.state?.actionType === "view") {
        const url = `/api/v1/CreateSellItem/details?orderNumber=${location.state.orderNumber}`;
        const response = await repositoryPos.get<MessageResponse<any>>(url);
        if (response && response?.success) {
          setOrderHeader({ ...response?.data?.orderHeader });
          setDataPayment(JSON.parse(response?.data?.orderHeader?.attribute9));
          if (response?.data?.orderHeader?.shipingVendor) {
            setShipingVendor(response?.data?.orderHeader?.shipingVendor);
          }
          setDataPaymentLatter(
            JSON.parse(response?.data?.orderHeader?.attribute20),
          );
          setPayLaterMethod(
            JSON.parse(response?.data?.orderHeader?.attribute20)
              ?.payLaterMethod,
          );
          setListAdd(fromStoredWarranty(response.data.orderDetail));
          setOrderStatus(response?.data?.orderHeader?.orderStatus);
          // Load email list from attribute53
          if (response?.data?.orderHeader?.attribute53) {
            setVatEmailList(response.data.orderHeader.attribute53);
          }
          // Load tax info from attribute57
          if (response?.data?.orderHeader?.attribute57) {
            try {
              const parsedTaxInfo = JSON.parse(
                response.data.orderHeader.attribute57,
              );
              setTaxInfo(parsedTaxInfo);
            } catch (error) {
              console.error("Error parsing attribute57:", error);
            }
          }
        }
      }
    };

    handleViewSalesOrder();
  }, [location]);

  // logic doi tra
  useEffect(() => {
    const handleViewSalesOrder = async () => {
      if (location?.state?.actionType === "doi") {
        const url = `/api/v1/CreateSellItem/details-return?orderNumber=${location.state.orderNumberOld}&check=false`;
        const response = await repositoryPos.get<MessageResponse<any>>(url);
        if (response && response?.success) {
          setOrderHeader({ ...response?.data?.orderHeader });
          setOrderHeaderRef({ ...response?.data?.orderHeaderRef });
          setDataPayment(response?.data?.paymentCommands);
          setListAdd(fromStoredWarrantyByOrder(response.data.orderDetail));
          setOrderStatus(response?.data?.orderHeader?.orderStatus);
        }
      }
    };

    handleViewSalesOrder();
  }, [location]);

  // Fetch approval history when in view mode
  useEffect(() => {
    const fetchApprovalHistory = async () => {
      if (location?.state?.actionType === "view" && orderHeader?.id) {
        try {
          const response = await repositoryPos.get<MessageResponse<any>>(
            `/api/v1/CreateSellItem/get-history-approve?orderId=${orderHeader.id}`,
          );
          if (response && response.success && response.data) {
            setApprovalHistory(response.data);
          }
        } catch (error) {
          console.error("Error fetching approval history:", error);
        }
      }
    };

    fetchApprovalHistory();
  }, [location?.state?.actionType, orderHeader?.id]);

  // logic build pc

  useEffect(() => {
    if (orderHeader?.attribute19) {
      setListAdd((prevData) => {
        return prevData.map((item, i) => {
          return { ...item, attribute15: "1" };
        });
      });
      isFetchDataCalledRef.current = true;
    }
  }, [orderHeader?.attribute19]);

  // logic thanh toan sau
  useEffect(() => {
    const handlePayLaterMethodChange = (method: string) => {
      setPayLaterMethod(method);

      // Reset thông tin trả góp hoặc công nợ nếu phương thức thanh toán khác được chọn
      if (method !== "Trả góp") {
        setInstallmentInfo({
          installmentType: "",
          companyName: "",
          contractCode: "",
          cardType: "",
        });
      }
      if (method !== "Công nợ") {
        setDebtInfo({
          dueDate: "",
        });
      }
    };
    handlePayLaterMethodChange(payLaterMethod);
  }, [payLaterMethod]);

  useEffect(() => {
    if (
      location?.state?.actionType !== "payment" &&
      location?.state?.actionType !== "view" &&
      location?.state?.actionType !== "approved"
    ) {
      // Reset shippingVendor khi shipping thay đổi
      // setShipingVendor("");
      //Comment lại thằng này vì  khi edit đơn website thì trong mở modal thông tin giao hàng khi edit sẽ bị mất đ

      // Cập nhật deliveryFee về 0
      setDataDeliveryInformation((prev: any) => {
        if (!prev) return prev; // Kiểm tra nếu prev là null hoặc undefined
        return {
          ...prev,
          // deliveryFee: 0, // Cập nhật deliveryFee về 0
          //Comment lại thằng này vì  khi edit đơn website  thì trong mở modal thông tin giao hàng khi edit sẽ bị mất số tiền phí ship
        };
      });
    }
  }, [shipping, location?.state?.actionType]);

  useEffect(() => {
    if (shipping === "Nhận tại cửa hàng") {
      setDataDeliveryInformation({
        ...dataDeliveryInformation,
        typeShip: "",
        shippingVendor: "",
      });
      setIsHaveShipping(false);
    }
  }, [shipping]);

  // Thêm ở đầu component (trước return hoặc trong component cha)
  const [buyerPopoverOpened, setBuyerPopoverOpened] = React.useState(false);
  const handleCopyBuyer = (text: string) => {
    navigator.clipboard.writeText(text);
  };

  useEffect(() => {
    if (printOrderModalOpened) {
      handlePrint();
      setPrintOrderModalOpened(false);
    }
  }, [printOrderModalOpened]);
  const handlePrintLinhKienLapRap = async (rowData: any) => {
    const itemCodePrint = rowData?.itemCode || "";
    if (itemCodePrint) {
      const response = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/Outward/print-sale-order-out-ward?order_number=${orderHeader?.orderNumber}&isserive=false`,
      );
      if (response && response.success && response.data) {
        setDataOutWard(response.data);
        const listDataResponse =
          response.data.inventoryTransactionSerialModels.filter(
            (item: any) => item.itemCode === itemCodePrint,
          );
        if (listDataResponse.length > 0) {
          // const result = await repositoryPos.get<MessageResponse<any>>(`/api/v1/TblItemTransaction/get-serial-parent-info?parentSerial=${String(listDataResponse[0]?.serial)}`);
          const result = await repositoryPos.post<MessageResponse<any>>(
            `/api/v1/TblItemTransaction/get-serial-parent-info`,
            {
              parentSerial: [String(listDataResponse[0]?.serial)],
            },
          );
          setDataLinhKienLR(result?.data || []);
        }
      } else {
        NotificationExtension.Fails("In linh kiện lắp ráp thất bại!");
      }
    }
  };

  useEffect(() => {
    if (dataLinhKienLR !== null) {
      handlePrintLK();
    }
  }, [dataLinhKienLR]);

  // useClickOutside từ Mantine: ngắn gọn và đồng bộ
  const ctxMenuRef = useClickOutside(() => {
    if (ctxOpen) setCtxOpen(false);
  });

  // đã dùng useHotkeys(...) ở trên; thêm if cần bắt Esc đơn lẻ:
  useHotkeys([["Escape", () => ctxOpen && setCtxOpen(false)]]);
  return (
    <Box style={{ position: "relative" }}>
      <LoadingOverlay
        visible={loading}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
        loaderProps={{ color: "blue", type: "bars" }}
      />
      <div
        style={{
          ...getStyle(true),
        }}
      >
        {titleSell()}
      </div>
      <PanelGroup direction="horizontal" id="group" style={{ width: "100%" }}>
        <Panel
          defaultSize={
            isCollapse ? 0 : location?.state?.actionType === "view" ? 35 : 45
          }
          minSize={isCollapse ? 0 : 35}
          maxSize={65}
          collapsible
          style={{
            transition: "0.3s ease",
            display: isCollapse ? "none" : "block",
          }}
        >
          <Collapse
            in={!isCollapse}
            transitionDuration={100}
            transitionTimingFunction="ease-in-out"
            h={"100%"}
          >
            <Card h="100%" p={0} shadow="sm" radius="md" withBorder>
              {formOrderHeader()}
            </Card>
          </Collapse>
        </Panel>

        {!isCollapse && <PanelResizeHandle id="resize-handle" />}

        <Panel
          defaultSize={isCollapse ? 100 : 55}
          minSize={35}
          maxSize={isCollapse ? 100 : 65}
          style={{
            width: isCollapse ? "100%" : "auto",
            transition: "width 0.3s ease",
          }}
        >
          <Flex direction={"column"}>
            <MantineReactTable table={table} />
            {ctxOpen &&
              orderStatus === "DON_HANG_HOAN_THANH" &&
              orderHeader?.attribute3 === "DA_XUAT" && (
                <div
                  ref={ctxMenuRef}
                  style={{
                    position: "fixed",
                    left: ctxPos.x,
                    top: ctxPos.y,
                    zIndex: 9999,
                    minWidth: 200,
                  }}
                >
                  <Button
                    leftSection={<IconPrinter size={16} />}
                    style={{
                      justifyContent: "flex-start",
                      textTransform: "none",
                      padding: "8px 12px",
                    }}
                    variant="filled"
                    onClick={() => {
                      handlePrintLinhKienLapRap(ctxRowData);
                      setCtxOpen(false);
                    }}
                  >
                    In linh kiện lắp ráp
                  </Button>
                </div>
              )}
            {/* Thêm thanh hiển thị thông tin đơn hàng ở đây */}
            {!containsDT(orderHeader?.orderNumber) &&
              // !location?.state?.isReadOnly && (
              true && (
                <Card
                  shadow="sm"
                  radius="md"
                  withBorder
                  p="md"
                  style={{
                    backgroundColor: "#f9f9f9",
                    borderRadius: "10px",
                    padding: "20px",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Grid>
                    <Grid.Col span={2} className={styles.orderInfoStyle}>
                      <Text fw={500} className={styles.infoLabelStyle}>
                        Số lượng:
                      </Text>
                      <Text className={styles.infoValueStyle}>
                        {getTotalQuality(listAdd)}
                      </Text>
                    </Grid.Col>
                    <Grid.Col span={2} className={styles.orderInfoStyle}>
                      <Text fw={500} className={styles.infoLabelStyle}>
                        Tổng tiền hàng:
                      </Text>
                      <Text fw={"bold"}>
                        <NumberFormatter
                          value={totalAmount}
                          thousandSeparator="."
                          decimalSeparator=","
                        />
                      </Text>
                    </Grid.Col>
                    <Grid.Col span={2} className={styles.orderInfoStyle}>
                      <Text fw={500} className={styles.infoLabelStyle}>
                        {location?.state?.fromTMDTList
                          ? "Tổng phí sàn:"
                          : "Tổng khuyến mãi:"}
                      </Text>
                      <Text fw={"bold"}>
                        <NumberFormatter
                          value={totalKM === 0 ? 0 : `-${totalKM}`}
                          thousandSeparator="."
                          decimalSeparator=","
                        />
                      </Text>
                    </Grid.Col>
                    <Grid.Col span={2} className={styles.orderInfoStyle}>
                      <Text fw={500} className={styles.infoLabelStyle}>
                        Tổng xin giảm:
                      </Text>
                      <Text fw={"bold"}>
                        <NumberFormatter
                          value={
                            (totalXGDetail ?? 0) +
                              (orderHeader?.discountAddedTotal ?? 0) ===
                            0
                              ? 0
                              : `-${
                                  (totalXGDetail ?? 0) +
                                  (orderHeader?.discountAddedTotal ?? 0)
                                }`
                          }
                          thousandSeparator="."
                          decimalSeparator=","
                        />
                      </Text>
                    </Grid.Col>
                    <Grid.Col span={2} className={styles.orderInfoStyle}>
                      <Text fw={500} className={styles.infoLabelStyle}>
                        Thanh toán:
                      </Text>
                      <Text fw={"bold"} style={{ color: "red" }}>
                        <NumberFormatter
                          value={payableAmount}
                          thousandSeparator="."
                          decimalSeparator=","
                        />
                      </Text>
                    </Grid.Col>
                  </Grid>
                </Card>
              )}
          </Flex>
        </Panel>
      </PanelGroup>
      <Box display={"none"}>
        <PrintInvoice
          isDVT={
            listBranch?.find(
              (item: any) => Number(item.value) === Number(branchId),
            )?.attr6 === "DVT"
          }
          idPrint={idPrint}
          setIdPrint={setIdPrint}
          isPrinting={isPrinting}
          setIsPrinting={setIsPrinting}
          orderNumber={orderHeader.orderNumber}
          // price={bankTransfer + anotherPayment || getPayAmountByPayType("01")}
          price={deferredPayment - orderHeader?.amountPaid}
          buyerName={orderHeader?.attribute36}
        />
      </Box>
      <Box>
        <WarehouseSelector
          opened={opened2}
          setOpened={setOpened2}
          selectedWarehouse={selectedWarehouse}
          setSelectedWarehouse={setSelectedWarehouse}
          warehouseList={warehouseList}
        />

        {/* Hiển thị kho đã chọn */}
        {selectedWarehouse && (
          <Box mt="md">
            <Text size="sm" c="teal">
              <b>Kho đã chọn:</b> {selectedWarehouse.subInvName} (
              {selectedWarehouse.branchName})
            </Text>
          </Box>
        )}
      </Box>

      {/* Modal gợi ý chiết khấu */}
      <DiscountSuggestionModal
        opened={discountModalOpened}
        onClose={() => setDiscountModalOpened(false)}
        discountData={discountSuggestionData}
        loading={discountLoading}
        userAuth={userAuth}
        onReceiveMaxDiscounts={handleReceiveMaxDiscounts}
        isRetail={true}
        listAdd={listAdd}
        fromCompletedList={isFromCompletedList}
      />

      {/* Modal chọn mức giảm giá cho từng sản phẩm */}
      <DiscountSelectionModal
        opened={discountSelectionOpened}
        onClose={() => setDiscountSelectionOpened(false)}
        onSelectDiscount={handleSelectDiscount}
        discountOptions={currentDiscountOptions}
        initialCustomDiscount={currentCustomDiscount}
      />

      {/* Modal chia suất gói bảo hành mở rộng */}
      <ModalAllocateWarranty
        opened={warrantyModalOpened}
        onClose={() => {
          setWarrantyModalOpened(false);
          setSelectedWarrantyRow(null);
        }}
        warrantyItem={selectedWarrantyRow}
        listAdd={listAdd}
        setListAdd={setListAdd}
        // Cùng điều kiện khoá ô của bảng sản phẩm (mantineTableBodyCellProps)
        readOnly={getStyle(true).pointerEvents === "none"}
      />

      {/* Modal thông tin xuất hóa đơn VAT */}
      <Modal
        opened={taxInfoModalOpened}
        onClose={() => {
          // Kiểm tra nếu đang ở chế độ view thì cho phép đóng
          if (location?.state?.actionType === "view") {
            setTaxInfoModalOpened(false);
            return;
          }

          // Chỉ validate khi là "Có xuất VAT" (printInvoiceCheck === 1)
          // Không validate khi là "Không" hoặc "Nợ VAT"
          if (orderHeader?.printInvoiceCheck === 1) {
            // Kiểm tra đủ 4 thông tin bắt buộc
            // if (
            //   !taxInfo.TaxCode ||
            //   !taxInfo.TaxCompany ||
            //   !taxInfo.TaxEmail ||
            //   !taxInfo.TaxAddress
            // ) {
            //   NotificationExtension.Warn(
            //     "Vui lòng nhập đầy đủ thông tin: Mã số thuế, Tên công ty, Email nhận hóa đơn và Địa chỉ công ty"
            //   );
            //   return;
            // }

            // Kiểm tra email hợp lệ
            if (emailError) {
              NotificationExtension.Warn(
                "Email không đúng định dạng. Vui lòng kiểm tra lại!",
              );
              return;
            }
          }

          setTaxInfoModalOpened(false);
        }}
        title="Thông tin xuất hóa đơn VAT"
        size="70vw"
        centered
        closeOnClickOutside={false}
        closeOnEscape={false}
      >
        <Grid>
          <Grid.Col span={6}>
            <TextInput
              label="Mã số thuế"
              size="lg"
              placeholder="Nhập mã số thuế"
              value={taxInfo.TaxCode}
              rightSection={
                <ActionIcon
                  disabled={
                    !taxInfo.TaxCode ||
                    String(taxInfo.TaxCode).length < 8 ||
                    timeOutCallApi
                  }
                  onClick={() => handleSearchTax()}
                >
                  <IconSearch size={18} />
                </ActionIcon>
              }
              variant={
                location?.state?.actionType === "view" ? "filled" : "default"
              }
              readOnly={location?.state?.actionType === "view"}
              withAsterisk
              styles={{
                input: {
                  fontSize: "16px",
                  color:
                    location?.state?.actionType === "view"
                      ? "#000 !important"
                      : undefined,
                  opacity:
                    location?.state?.actionType === "view" ? 1 : undefined,
                },
                label: {
                  fontSize: "15px",
                  fontWeight: 500,
                },
              }}
              onChange={(e) => {
                const newTaxInfo = { ...taxInfo, TaxCode: e.target.value };
                setTaxInfo(newTaxInfo);
                setOrderHeader((prev) => ({
                  ...prev,
                  attribute57: JSON.stringify(newTaxInfo),
                }));
              }}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <TextInput
              label="Tên công ty"
              size="lg"
              placeholder="Nhập tên công ty"
              value={taxInfo.TaxCompany}
              variant={
                location?.state?.actionType === "view" ? "filled" : "default"
              }
              readOnly={location?.state?.actionType === "view"}
              withAsterisk
              styles={{
                input: {
                  fontSize: "16px",
                  color:
                    location?.state?.actionType === "view"
                      ? "#000 !important"
                      : undefined,
                  opacity:
                    location?.state?.actionType === "view" ? 1 : undefined,
                },
                label: {
                  fontSize: "15px",
                  fontWeight: 500,
                },
              }}
              onChange={(e) => {
                const newTaxInfo = { ...taxInfo, TaxCompany: e.target.value };
                setTaxInfo(newTaxInfo);
                setOrderHeader((prev) => ({
                  ...prev,
                  attribute57: JSON.stringify(newTaxInfo),
                }));
              }}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <TextInput
              label="Email nhận hóa đơn"
              size="lg"
              placeholder="Nhập email"
              value={taxInfo.TaxEmail}
              variant={
                location?.state?.actionType === "view" ? "filled" : "default"
              }
              readOnly={location?.state?.actionType === "view"}
              withAsterisk
              error={emailError}
              styles={{
                input: {
                  fontSize: "16px",
                  color:
                    location?.state?.actionType === "view"
                      ? "#000 !important"
                      : undefined,
                  opacity:
                    location?.state?.actionType === "view" ? 1 : undefined,
                },
                label: {
                  fontSize: "15px",
                  fontWeight: 500,
                },
              }}
              onChange={(e) => {
                const emailValue = e.target.value;
                const newTaxInfo = { ...taxInfo, TaxEmail: emailValue };

                // Validate email format
                const emailRegex =
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                if (emailValue && !emailRegex.test(emailValue)) {
                  setEmailError("Email không đúng định dạng");
                } else {
                  setEmailError("");
                }

                setTaxInfo(newTaxInfo);
                setOrderHeader((prev) => ({
                  ...prev,
                  attribute57: JSON.stringify(newTaxInfo),
                  attribute53: emailValue,
                }));
                setVatEmailList(emailValue);
              }}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <TextInput
              label="Địa chỉ công ty"
              size="lg"
              placeholder="Nhập địa chỉ"
              value={taxInfo.TaxAddress}
              variant={
                location?.state?.actionType === "view" ? "filled" : "default"
              }
              readOnly={location?.state?.actionType === "view"}
              withAsterisk
              styles={{
                input: {
                  fontSize: "16px",
                  color:
                    location?.state?.actionType === "view"
                      ? "#000 !important"
                      : undefined,
                  opacity:
                    location?.state?.actionType === "view" ? 1 : undefined,
                },
                label: {
                  fontSize: "15px",
                  fontWeight: 500,
                },
              }}
              onChange={(e) => {
                const addressValue = e.target.value;

                // Allow '-' character in address input. Removed previous restriction.

                const newTaxInfo = { ...taxInfo, TaxAddress: addressValue };
                setTaxInfo(newTaxInfo);
                setOrderHeader((prev) => ({
                  ...prev,
                  attribute57: JSON.stringify(newTaxInfo),
                }));
              }}
            />
          </Grid.Col>
        </Grid>
      </Modal>

      <Box style={{ display: "none" }}>
        <PrintOderhandover
          componentRef={componentRef}
          valuePrintOrderModal={valuePrintOrderModal}
          listAdd={listAdd}
          orderHeader={orderHeader}
        />
      </Box>
      {/* Component in phiếu xuất kho */}
      <Box style={{ display: "none" }}>
        {dataPrintOutWard && (
          <PrintWarehouseOutWard
            dataPrint={dataPrintOutWard}
            typePrint={typePrintOutWard || "XUAT_BAN"}
            userInfo={userLogin}
            currentDate={currentDateOutWard}
            componentRef={componentRefOutWard}
            locationData={locationDataOutWard}
            valuePrintOptionModal={valuePrintOutWardModal}
            dataCommuneMoi={dataCommuneMoi}
            dataLinhKienLR={dataLinhKienLR}
            valueQRCode={valueQRCodeOutWard}
            paymentAmounts={paymentSummaryForPrint}
          />
        )}

        {/* in list  linh kiện lắp ráp cho cho sản phẩm lắp ráp của bên mình , mục đích để check sp và thời gian baảo hành*/}
        <PrintWarehouseLKLR
          componentRef3={componentRef3}
          dataLinhKienLR={dataLinhKienLR}
          dataOutWard={dataOutWard}
          isDonBanLe={true}
        />
      </Box>
    </Box>
  );
};

export default RetailOrder;
